import jQuery from 'jquery';
/*eslint-disable */

var Taf = Taf || {};
Taf.INT8 = function()
{
    this._clone	= function() { return 0; }
    this._write	= function(os, tag, val) { return os.writeInt8(tag, val); }
    this._read 	= function(is, tag, def) { return is.readInt8(tag, true, def); }
    this._className = function(){ return Taf.CHAR; }
};
Taf.INT16 = function()
{
    this._clone	= function() { return 0; }
    this._write	= function(os, tag, val) { return os.writeInt16(tag, val); }
    this._read 	= function(is, tag, def) { return is.readInt16(tag, true, def); }
    this._className = function(){ return Taf.SHORT; }
};
Taf.INT32 = function()
{
    this._clone	= function() { return 0; }
    this._write	= function(os, tag, val) { return os.writeInt32(tag, val); }
    this._read	= function(is, tag, def) { return is.readInt32(tag, true, def); }
    this._className = function(){ return Taf.INT32; }
};
Taf.INT64 = function()
{
    this._clone = function() { return 0; }
    this._write	= function(os, tag, val) { return os.writeInt64(tag, val); }
    this._read	= function(is, tag, def) { return is.readInt64(tag, true, def); }
    this._className = function(){ return Taf.INT64; }
};
Taf.UINT8 = function()
{
    this._clone	= function() { return 0; }
    this._write	= function(os, tag, val) { return os.writeInt16(tag, val); }
    this._read	= function(is, tag, def) { return is.readInt16(tag, true, def); }
    this._className = function(){ return Taf.SHORT; }
};
Taf.UInt16 = function()
{
    this._clone = function() { return 0; }
    this._write = function(os, tag, val) { return os.writeInt32(tag, val); }
    this._read	= function(is, tag, def) { return is.readInt32(tag, true, def); }
    this._className = function(){ return Taf.INT32; }
};
Taf.UInt32 = function()
{
    this._clone = function() { return 0; }
    this._write = function(os, tag, val) { return os.writeInt64(tag, val); }
    this._read  = function(is, tag, def) { return is.readInt64(tag, true, def); }
    this._className = function(){ return Taf.INT64; }
};
Taf.Float = function()
{
    this._clone = function() { return 0; }
    this._write = function(os, tag, val) { return os.writeFloat(tag, val); }
    this._read  = function(is, tag, def) { return is.readFloat(tag, true, def); }
    this._className = function(){ return Taf.FLOAT; }
};
Taf.Double = function()
{
    this._clone = function() { return 0; }
    this._write = function(os, tag, val) { return os.writeDouble(tag, val); }
    this._read  = function(is, tag, def) { return is.readDouble(tag, true, def); }
    this._className = function(){ return Taf.DOUBLE; }
};
Taf.STRING = function()
{
    this._clone = function() { return 0; }
    this._write = function(os, tag, val) { return os.writeString(tag, val); }
    this._read	= function(is, tag, def) { return is.readString(tag, true, def); }
    this._className = function(){ return Taf.STRING; }
};
Taf.BOOLEAN	= function()
{
    this._clone	= function() { return false; }
    this._write	= function(os, tag, val) { return os.writeBoolean(tag, val); }
    this._read	= function(is, tag, def) { return is.readBoolean(tag, true, def); }
    this._className = function(){ return Taf.BOOLEAN; }
};
Taf.ENUM	= function()
{
    this._clone	= function() { return 0; }
    this._write	= function(os, tag, val) { return os.writeInt32(tag, val); }
    this._read	= function(is, tag, def) { return is.readInt32(tag, true, def); }
};

/**
 * TAFVECTOR实现类
 */
Taf.Vector	= function(proto)
{
    this.proto = proto;
    this.value   = new Array();
}
Taf.Vector.prototype._clone = function() { return new Taf.Vector(this.proto); }
Taf.Vector.prototype._write	= function(os, tag, val) { return os.writeVector(tag, val); }
Taf.Vector.prototype._read  = function(is, tag, def) { return is.readVector(tag, true, def); }
Taf.Vector.prototype._className = function() {
    return Taf.TypeHelp.VECTOR.replace("$t",this.proto._className() );
}

/**
 * TAFMAP实现类
 */
Taf.Map	= function(kproto, vproto)
{
    this.kproto = kproto;
    this.vproto = vproto;
    this.value 	= new Object();
};
Taf.Map.prototype._clone = function () { return new Taf.Map(this.kproto, this.vproto); }
Taf.Map.prototype._write = function (os, tag, val) { return os.writeMap(tag, val); }
Taf.Map.prototype._read	 = function (is, tag, def) { return is.readMap(tag, true, def); }

Taf.Map.prototype.put    = function(key, value) { this.value[key] = value; }
Taf.Map.prototype.get    = function(key) { return this.value[key]; }
Taf.Map.prototype.remove = function(key) { delete this.value[key]; }
Taf.Map.prototype.clear  = function()    { this.value = new Object(); }
Taf.Map.prototype.size   = function()
{
    var anum = 0;
    for (var key in this.value) {anum++;}
    return anum;
};

Taf.Vector.prototype._className = function() {
    return Taf.TypeHelp.Map.replace("$k",this.kproto._className() ).replace("$v", this.vproto._className() );
}
;
var Taf = Taf || {};

/**
 * KevinTian@tencent.com
 *
 * JCE编解码底层辅助类
 */
Taf.DataHelp = {
    EN_INT8: 0,
    EN_INT16: 1,
    EN_INT32: 2,
    EN_INT64: 3,
    EN_FLOAT: 4,
    EN_DOUBLE: 5,
    EN_STRING1: 6,
    EN_STRING4: 7,
    EN_MAP: 8,
    EN_LIST: 9,
    EN_STRUCTBEGIN: 10,
    EN_STRUCTEND: 11,
    EN_ZERO: 12,
    EN_SIMPLELIST: 13
};

Taf.TypeHelp = {
    BOOLEAN: "bool",
    CHAR: "char",
    SHORT: "short",
    INT32: "int32",
    INT64: "int64",
    FLOAT: "float",
    DOUBLE: "double",
    STRING: "string",
    VECTOR: "list<$t>",
    MAP: "map<$k, $v>",
};

/**
 * 二进制Buffer类
 */
Taf.BinBuffer = function(buffer) {
    this.buf = null;
    this.vew = null;
    this.len = 0;
    this.position = 0;

    if (buffer != null && buffer != undefined && buffer instanceof Taf.BinBuffer) {
        this.buf = buffer.buf;
        this.vew = new DataView(this.buf);
        this.len = buffer.length;
        this.position = buffer.position;
    }
    if (buffer != null && buffer != undefined && buffer instanceof ArrayBuffer) {
        this.buf = buffer;
        this.vew = new DataView(this.buf);
        this.len = this.vew.byteLength;
        this.position = 0;
    }

    this.__defineGetter__("length", function() {
        return this.len;
    });
    this.__defineGetter__("buffer", function() {
        return this.buf;
    });
};

Taf.BinBuffer.prototype._write = function(os, tag, val) {
    return os.writeBytes(tag, val);
}


Taf.BinBuffer.prototype._read = function(os, tag, def) {
    return os.readBytes(tag, true, def);
}

Taf.BinBuffer.prototype._clone = function() {
    return new Taf.BinBuffer();
}

Taf.BinBuffer.prototype.allocate = function(uiLength) {
    uiLength = this.position + uiLength;
    if (this.buf != null && this.buf.length > uiLength) {
        return;
    }

    var temp = new ArrayBuffer(Math.max(256, uiLength * 2));
    if (this.buf != null) {
        new Uint8Array(temp).set(new Uint8Array(this.buf));
        this.buf = undefined;
    }

    this.buf = temp;
    this.vew = undefined;
    this.vew = new DataView(this.buf);
};

Taf.BinBuffer.prototype.getBuffer = function() {
    var temp = new ArrayBuffer(this.len);
    new Uint8Array(temp).set(new Uint8Array(this.buf, 0, this.len));
    return temp;
}

Taf.BinBuffer.prototype.memset = function(fbuf, offset, length) {
    this.allocate(length);
    new Uint8Array(this.buf).set(new Uint8Array(fbuf, offset, length), this.position);
};



Taf.BinBuffer.prototype.writeInt8 = function(value) {
    this.allocate(1);
    this.vew.setInt8(this.position, value);
    this.position += 1;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeUInt8 = function(value) {
    this.allocate(1);
    this.vew.setUint8(this.position++, value);
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeInt16 = function(value) {
    this.allocate(2);
    this.vew.setInt16(this.position, value);
    this.position += 2;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeUInt16 = function(value) {
    this.allocate(2);
    this.vew.setUint16(this.position, value);
    this.position += 2;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeInt32 = function(value) {
    this.allocate(4);
    this.vew.setInt32(this.position, value);
    this.position += 4;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeUInt32 = function(value) {
    this.allocate(4);
    this.vew.setUint32(this.position, value);
    this.position += 4;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeInt64 = function(value) {
    this.allocate(8);
    this.vew.setUint32(this.position, parseInt(value / 4294967296));
    this.vew.setUint32(this.position + 4, value % 4294967296);
    this.position += 8;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeFloat = function(value) {
    this.allocate(4);
    this.vew.setFloat32(this.position, value);
    this.position += 4;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeDouble = function(value) {
    this.allocate(8);
    this.vew.setFloat64(this.position, value);
    this.position += 8;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeString = function(value) {
    for (var arr = [], i = 0; i < value.length; i++) {
        arr.push(value.charCodeAt(i) & 0xFF);
    }

    this.allocate(arr.length);
    new Uint8Array(this.buf).set(new Uint8Array(arr), this.position);
    this.position += arr.length;
    this.len = this.position;
};

Taf.BinBuffer.prototype.writeBytes = function(value) {
    if (value.length == 0 || value.buf == null) return;

    this.allocate(value.length);
    new Uint8Array(this.buf).set(new Uint8Array(value.buf, 0, value.length), this.position);
    this.position += value.length;
    this.len = this.position;
};

Taf.BinBuffer.prototype.readInt8 = function() {
    return this.vew.getInt8(this.position++);
};

Taf.BinBuffer.prototype.readInt16 = function() {
    this.position += 2;
    return this.vew.getInt16(this.position - 2);
};

Taf.BinBuffer.prototype.readInt32 = function() {
    this.position += 4;
    return this.vew.getInt32(this.position - 4);
};

Taf.BinBuffer.prototype.readUInt8 = function() {
    this.position += 1;
    return this.vew.getUint8(this.position - 1);
};

Taf.BinBuffer.prototype.readUInt16 = function() {
    this.position += 2;
    return this.vew.getUint16(this.position - 2);
};

Taf.BinBuffer.prototype.readUInt32 = function() {
    this.position += 4;
    return this.vew.getUint32(this.position - 4);
};

Taf.BinBuffer.prototype.readInt64 = function() {
    var H4 = this.vew.getUint32(this.position);
    var L4 = this.vew.getUint32(this.position + 4);
    this.position += 8;
    return H4 * 4294967296 + L4;
};


Taf.BinBuffer.prototype.readFloat = function() {
    var temp = this.vew.getFloat32(this.position);
    this.position += 4;
    return temp;
}

Taf.BinBuffer.prototype.readDouble = function() {
    var temp = this.vew.getFloat64(this.position);
    this.position += 8;
    return temp;
}

Taf.BinBuffer.prototype.readString = function(value) {
    for (var arr = [], i = 0; i < value; i++) {
        arr.push(String.fromCharCode(this.vew.getUint8(this.position++)));
    }
    var result = arr.join("");
    try {
        result = decodeURIComponent(escape(result));
    } catch (e) {}
    return result;
};

Taf.BinBuffer.prototype.readBytes = function(value) {
    var temp = new Taf.BinBuffer();
    temp.allocate(value);
    temp.memset(this.buf, this.position, value);
    temp.position = 0;
    temp.len = value;
    this.position = this.position + value;
    return temp;
};

/**
 * TAFJCE输出编解码包裹类
 *
 * KevinTian@tencent.com
 */
Taf.JceOutputStream = function() {
    this.buf = new Taf.BinBuffer();
    this.getBinBuffer = function() {
        return this.buf;
    }
    this.getBuffer = function() {
        return this.buf.getBuffer();
    }
}

Taf.JceOutputStream.prototype.writeTo = function(tag, type) {
    if (tag < 15) {
        this.buf.writeUInt8((tag << 4 & 0xF0) | type);
    } else {
        this.buf.writeUInt16((0xF0 | type) << 8 | tag);
    }
};

Taf.JceOutputStream.prototype.writeBoolean = function(tag, value) {
    this.writeInt8(tag, value == true ? 1 : 0);
};

Taf.JceOutputStream.prototype.writeInt8 = function(tag, value) {
    if (value == 0) {
        this.writeTo(tag, Taf.DataHelp.EN_ZERO);
    } else {
        this.writeTo(tag, Taf.DataHelp.EN_INT8);
        this.buf.writeInt8(value);
    }
};

Taf.JceOutputStream.prototype.writeInt16 = function(tag, value) {
    if (value >= -128 && value <= 127) {
        this.writeInt8(tag, value);
    } else {
        this.writeTo(tag, Taf.DataHelp.EN_INT16);
        this.buf.writeInt16(value);
    }
}

Taf.JceOutputStream.prototype.writeInt32 = function(tag, value) {
    if (value >= -32768 && value <= 32767) {
        this.writeInt16(tag, value);
    } else {
        this.writeTo(tag, Taf.DataHelp.EN_INT32);
        this.buf.writeInt32(value);
    }
}

Taf.JceOutputStream.prototype.writeInt64 = function(tag, value) {
    if (value >= -2147483648 && value <= 2147483647) {
        this.writeInt32(tag, value);
    } else {
        this.writeTo(tag, Taf.DataHelp.EN_INT64);
        this.buf.writeInt64(value);
    }
}

Taf.JceOutputStream.prototype.writeUInt8 = function(tag, value) {
    this.writeInt16(tag, value);
}

Taf.JceOutputStream.prototype.writeUInt16 = function(tag, value) {
    this.writeInt32(tag, value);
}

Taf.JceOutputStream.prototype.writeUInt32 = function(tag, value) {
    this.writeInt64(tag, value);
}

Taf.JceOutputStream.prototype.writeFloat = function(tag, value) {
    if (value == 0) {
        this.writeTo(tag, Taf.DataHelp.EN_ZERO);
    } else {
        this.writeTo(tag, Taf.DataHelp.EN_FLOAT);
        this.buf.writeFloat(value);
    }
}

Taf.JceOutputStream.prototype.writeDouble = function(tag, value) {
    if (value == 0) {
        this.writeTo(tag, Taf.DataHelp.EN_ZERO);
    } else {
        this.writeTo(tag, Taf.DataHelp.EN_DOUBLE);
        this.buf.writeDouble(value);
    }
}

Taf.JceOutputStream.prototype.writeStruct = function(tag, value) {
    if (value.writeTo == undefined) {
        throw Error("not defined writeTo Function");
    }

    this.writeTo(tag, Taf.DataHelp.EN_STRUCTBEGIN);
    value.writeTo(this);
    this.writeTo(0, Taf.DataHelp.EN_STRUCTEND);
}

Taf.JceOutputStream.prototype.writeString = function(tag, value) {
    var str = value;
    try {
        str = unescape(encodeURIComponent(str));
    } catch (e) {}
    if (str.length > 255) {
        this.writeTo(tag, Taf.DataHelp.EN_STRING4);
        this.buf.writeUInt32(str.length);
    } else {
        this.writeTo(tag, Taf.DataHelp.EN_STRING1);
        this.buf.writeUInt8(str.length);
    }
    this.buf.writeString(str);
};

Taf.JceOutputStream.prototype.writeBytes = function(tag, value) {
    if (!(value instanceof Taf.BinBuffer)) {
        throw Error("value not instanceof Taf.BinBuffer");
    }

    this.writeTo(tag, Taf.DataHelp.EN_SIMPLELIST);
    this.writeTo(0, Taf.DataHelp.EN_INT8);
    this.writeInt32(0, value.length);
    this.buf.writeBytes(value);
};

Taf.JceOutputStream.prototype.writeVector = function(tag, value) {
    this.writeTo(tag, Taf.DataHelp.EN_LIST);
    this.writeInt32(0, value.value.length);
    for (var i = 0; i < value.value.length; i++) {
        value.proto._write(this, 0, value.value[i]);
    }
};

Taf.JceOutputStream.prototype.writeMap = function(tag, value) {
    this.writeTo(tag, Taf.DataHelp.EN_MAP);
    this.writeInt32(0, value.size());

    for (var temp in value.value) {
        value.kproto._write(this, 0, temp);
        value.vproto._write(this, 1, value.value[temp]);
    }
};

/**
 * TAFJCE输入编解码包裹类
 *
 * KevinTian@tencent.com
 */
Taf.JceInputStream = function(buffer) {
    this.buf = new Taf.BinBuffer(buffer);
};

Taf.JceInputStream.prototype.readFrom = function() {
    var temp = this.buf.readUInt8();
    var tag = (temp & 0xF0) >> 4;
    var type = (temp & 0x0F);

    if (tag >= 15) tag = this.buf.readUInt8();
    return { tag: tag, type: type };
};

Taf.JceInputStream.prototype.peekFrom = function() {
    var pos = this.buf.position;
    var head = this.readFrom();
    this.buf.position = pos;

    return { tag: head.tag, type: head.type, size: (head.tag >= 15) ? 2 : 1 };
};

Taf.JceInputStream.prototype.skipField = function(type) {
    switch (type) {
        case Taf.DataHelp.EN_INT8:
            this.buf.position += 1;
            break;
        case Taf.DataHelp.EN_INT16:
            this.buf.position += 2;
            break;
        case Taf.DataHelp.EN_INT32:
            this.buf.position += 4;
            break;
        case Taf.DataHelp.EN_INT64:
            this.buf.position += 8;
            break;
        case Taf.DataHelp.EN_STRING1:
            var a = this.buf.readUInt8();
            this.buf.position += a;
            break;
        case Taf.DataHelp.EN_STRING4:
            var b = this.buf.readInt32();
            this.buf.position += b;
            break;
        case Taf.DataHelp.EN_STRUCTBEGIN:
            this.skipToStructEnd();
            break;
        case Taf.DataHelp.EN_STRUCTEND:
        case Taf.DataHelp.EN_ZERO:
            break;
        case Taf.DataHelp.EN_MAP:
        {
            var size = this.readInt32(0, true);

            for (var i = 0; i < size * 2; ++i) {
                var head = this.readFrom();
                this.skipField(head.type);
            }

            break;
        }
        case Taf.DataHelp.EN_SIMPLELIST:
        {
            var head = this.readFrom();
            if (head.type != Taf.DataHelp.EN_INT8) {
                throw Error("skipField with invalid type, type value: " + type + "," + head.type);
            }

            var a = this.readInt32(0, true);
            this.buf.position += a;
            break;
        }
        case Taf.DataHelp.EN_LIST:
        {
            var size = this.readInt32(0, true);
            for (var i = 0; i < size; ++i) {
                var head = this.readFrom();
                this.skipField(head.type);
            }
            break;
        }
        default:
            throw new Error("skipField with invalid type, type value: " + type);
    }
}

Taf.JceInputStream.prototype.skipToStructEnd = function() {
    for (;;) {
        var head = this.readFrom();
        this.skipField(head.type);

        if (head.type == Taf.DataHelp.EN_STRUCTEND) {
            return;
        }
    }
}

Taf.JceInputStream.prototype.skipToTag = function(tag, require) {
    while (this.buf.position < this.buf.length) {
        var head = this.peekFrom();
        if (tag <= head.tag || head.type == Taf.DataHelp.EN_STRUCTEND) {
            // if ((head.type == Taf.DataHelp.EN_STRUCTEND || tag != head.tag) && require) {
            //     break;
            // }
            // return true;
            return head.type == Taf.DataHelp.EN_STRUCTEND ? false : (tag == head.tag);
        }

        this.buf.position += head.size;
        this.skipField(head.type);
    }

    if (require) throw Error("require field not exist, tag:" + tag);
    return false;
}

Taf.JceInputStream.prototype.readBoolean = function(tag, require, def) {
    return this.readInt8(tag, require, def) == 1 ? true : false;
}

Taf.JceInputStream.prototype.readInt8 = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
            return 0;
        case Taf.DataHelp.EN_INT8:
            return this.buf.readInt8();
    }
    throw Error("read int8 type mismatch, tag:" + tag + ", get type:" + head.type);
}

Taf.JceInputStream.prototype.readInt16 = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
            return 0;
        case Taf.DataHelp.EN_INT8:
            return this.buf.readInt8();
        case Taf.DataHelp.EN_INT16:
            return this.buf.readInt16();
    }
    throw Error("read int8 type mismatch, tag:" + tag + ", get type:" + head.type);
}

Taf.JceInputStream.prototype.readInt32 = function(tag, requrire, def) {
    if (this.skipToTag(tag, requrire) == false) {
        return def;
    }

    var head = this.readFrom();
    switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
            return 0;
        case Taf.DataHelp.EN_INT8:
            return this.buf.readInt8();
        case Taf.DataHelp.EN_INT16:
            return this.buf.readInt16();
        case Taf.DataHelp.EN_INT32:
            return this.buf.readInt32();
    }
    throw Error("read int8 type mismatch, tag:" + tag + ", get type:" + head.type);
}

Taf.JceInputStream.prototype.readInt64 = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
            return 0;
        case Taf.DataHelp.EN_INT8:
            return this.buf.readInt8();
        case Taf.DataHelp.EN_INT16:
            return this.buf.readInt16();
        case Taf.DataHelp.EN_INT32:
            return this.buf.readInt32();
        case Taf.DataHelp.EN_INT64:
            return this.buf.readInt64();
    }
    throw Error("read int64 type mismatch, tag:" + tag + ", get type:" + h.type);
}

Taf.JceInputStream.prototype.readFloat = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
            return 0;
        case Taf.DataHelp.EN_FLOAT:
            return this.buf.readFloat();
    }
    throw Error("read float type mismatch, tag:" + tag + ", get type:" + h.type);
}

Taf.JceInputStream.prototype.readDouble = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
            return 0;
        case Taf.DataHelp.EN_DOUBLE:
            return this.buf.readDouble();
    }
    throw Error("read double type mismatch, tag:" + tag + ", get type:" + h.type);
}

Taf.JceInputStream.prototype.readUInt8 = function(tag, require, def) {
    return this.readInt16(tag, require, def);
}

Taf.JceInputStream.prototype.readUInt16 = function(tag, require, def) {
    return this.readInt32(tag, require, def);
}

Taf.JceInputStream.prototype.readUInt32 = function(tag, require, def) {
    return this.readInt64(tag, require, def);
}

Taf.JceInputStream.prototype.readStruct = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    if (head.type != Taf.DataHelp.EN_STRUCTBEGIN) {
        throw Error("read struct type mismatch, tag: " + tag + ", get type:" + head.type);
    }

    def.readFrom(this);
    this.skipToStructEnd();
    return def;
}

Taf.JceInputStream.prototype.readString = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    if (head.type == Taf.DataHelp.EN_STRING1) {
        return this.buf.readString(this.buf.readUInt8());
    }

    if (head.type == Taf.DataHelp.EN_STRING4) {
        return this.buf.readString(this.buf.readUInt32());
    }

    throw Error("read 'string' type mismatch, tag: " + tag + ", get type: " + head.type + ".");
}

Taf.JceInputStream.prototype.readString2 = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    if (head.type == Taf.DataHelp.EN_STRING1) {
        return this.buf.readBytes(this.buf.readUInt8());
    }

    if (head.type == Taf.DataHelp.EN_STRING4) {
        return this.buf.readBytes(this.buf.readUInt32());
    }

    throw Error("read 'string' type mismatch, tag: " + tag + ", get type: " + head.type + ".");
}

Taf.JceInputStream.prototype.readBytes = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    if (head.type == Taf.DataHelp.EN_SIMPLELIST) {
        var temp = this.readFrom();
        if (temp.type != Taf.DataHelp.EN_INT8) {
            throw Error("type mismatch, tag:" + tag + ",type:" + head.type + "," + temp.type);
        }
        var size = this.readInt32(0, true);
        if (size < 0) {
            throw Error("invalid size, tag:" + tag + ",type:" + head.type + "," + temp.type);
        }

        return this.buf.readBytes(size);
    }

    if (head.type == Taf.DataHelp.EN_LIST) {
        var size = this.readInt32(0, true);
        return this.buf.readBytes(size);
    }

    throw Error("type mismatch, tag:" + tag + ",type:" + head.type);
}

Taf.JceInputStream.prototype.readVector = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    if (head.type != Taf.DataHelp.EN_LIST) {
        throw Error("read 'vector' type mismatch, tag: " + tag + ", get type: " + head.type);
    }

    var size = this.readInt32(0, true);
    if (size < 0) {
        throw Error("invalid size, tag: " + tag + ", type: " + head.type + ", size: " + size);
    }
    for (var i = 0; i < size; ++i) {
        def.value.push(def.proto._read(this, 0, def.proto._clone()));
    }

    return def;
}

Taf.JceInputStream.prototype.readMap = function(tag, require, def) {
    if (this.skipToTag(tag, require) == false) {
        return def;
    }

    var head = this.readFrom();
    if (head.type != Taf.DataHelp.EN_MAP) {
        throw Error("read 'map' type mismatch, tag: " + tag + ", get type: " + head.type);
    }

    var size = this.readInt32(0, true);
    if (size < 0) {
        throw Error("invalid map, tag: " + tag + ", size: " + size);
    }

    for (var i = 0; i < size; i++) {
        var key = def.kproto._read(this, 0, def.kproto._clone());
        var val = def.vproto._read(this, 1, def.vproto._clone());
        def.put(key, val);
    }

    return def;
}
;
var Taf = Taf || {};

/**
 * WUP使用类
 *
 */
Taf.Wup = function() {
    this.iVersion = 3;
    this.cPacketType = 0;
    this.iMessageType = 0;
    this.iRequestId = 0;
    this.sServantName = '';
    this.sFuncName = '';
    this.sBuffer = new Taf.BinBuffer();
    this.iTimeout = 0;
    this.context = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.status = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.data = new Taf.Map(new Taf.STRING(), new Taf.Map(new Taf.STRING(), new Taf.BinBuffer()));
    this.newdata = new Taf.Map(new Taf.STRING(), new Taf.BinBuffer());
};


Taf.Wup.prototype.setVersion = function(value) {
    this.iVersion = value;
}

Taf.Wup.prototype.getVersion = function(value) {
    return this.iVersion;
}


Taf.Wup.prototype.setServant = function(value) {
    this.sServantName = value;
};

Taf.Wup.prototype.setFunc = function(value) {
    this.sFuncName = value;
};


Taf.Wup.prototype.setRequestId = function(value) {
    this.iRequestId = value ? value : (++this.iRequestId);
};

Taf.Wup.prototype.getRequestId = function() {
    return this.iRequestId;
};


Taf.Wup.prototype.setTimeOut = function(value) {
    this.iTimeout = value;
};

Taf.Wup.prototype.getTimeOut = function() {
    return this.iTimeout;
};





Taf.Wup.prototype.writeTo = function() {
    // body...
    var os = new Taf.JceOutputStream();
    os.writeInt16(1, this.iVersion);
    os.writeInt8(2, this.cPacketType);
    os.writeInt32(3, this.iMessageType);
    os.writeInt32(4, this.iRequestId);
    os.writeString(5, this.sServantName);
    os.writeString(6, this.sFuncName);
    os.writeBytes(7, this.sBuffer);
    os.writeInt32(8, this.iTimeout);
    os.writeMap(9, this.context);
    os.writeMap(10, this.status);
    return new Taf.BinBuffer(os.getBuffer());
};


Taf.Wup.prototype.encode = function() {
    var os = new Taf.JceOutputStream();
    if (this.iVersion == 3) {
        os.writeMap(0, this.newdata);
    } else {
        os.writeMap(0, this.data);
    }
    this.sBuffer = os.getBinBuffer();

    var temp = new Taf.BinBuffer();
    temp = this.writeTo();

    var buf = new Taf.BinBuffer();
    buf.writeInt32(4 + temp.len);
    buf.writeBytes(temp);
    return buf;
}


Taf.Wup.prototype.writeBoolean = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeBoolean(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = TAF.TypeHelp.BOOLEAN;
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Taf.BinBuffer(os.getBuffer()));
        this.data.put(name, temp);
    }
}


Taf.Wup.prototype.writeInt8 = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeInt8(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = TAF.TypeHelp.CHAR;
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Taf.BinBuffer(os.getBuffer()));
        this.data.put(name, temp);
    }
}


Taf.Wup.prototype.writeInt16 = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeInt16(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = TAF.TypeHelp.SHORT;
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}


Taf.Wup.prototype.writeInt32 = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeInt32(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = TAF.TypeHelp.INT32;
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}


Taf.Wup.prototype.writeInt64 = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeInt64(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = TAF.TypeHelp.INT64;
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}

Taf.Wup.prototype.writeFloat = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeFloat(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = TAF.TypeHelp.FLOAT;
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}

Taf.Wup.prototype.writeDouble = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeDouble(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = TAF.TypeHelp.DOUBLE;
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}

Taf.Wup.prototype.writeString = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeString(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = Taf.TypeHelp.STRING;
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}

Taf.Wup.prototype.writeVector = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeVector(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBinBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = value._className();
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}


Taf.Wup.prototype.writeStruct = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeStruct(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        //todo
        var classType = " ";
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}

Taf.Wup.prototype.writeBytes = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeBytes(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = "vec";
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}

Taf.Wup.prototype.writeMap = function(name, value) {
    var os = new Taf.JceOutputStream();
    os.writeMap(0, value);
    if (this.iVersion == 3) {
        this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    } else {
        var temp = this.data.get(name);
        var classType = Taf.Util.getClassType(value);
        if (temp == undefined) {
            var newNode = new Taf.Map(Taf.STRING, Taf.STRING);
            temp = newNode;
        }
        temp.put(classType, new Uint8Array(os.getBuffer()));
        this.data.put(name, temp);
    }
}


Taf.Wup.prototype.readFrom = function(is) {
    this.iVersion = is.readInt16(1, true);
    this.cPacketType = is.readInt8(2, true);
    this.iMessageType = is.readInt32(3, true);
    this.iRequestId = is.readInt32(4, true);
    this.sServantName = is.readString(5, true);
    this.sFuncName = is.readString(6, true);

    if (localStorage.__wup) {
        console.info('%c@@@ ' + this.sServantName + '.' + this.sFuncName, 'color:white;background:black;', this);
    }

    this.sBuffer = is.readBytes(7, true);
    this.iTimeout = is.readInt32(8, true);
    this.context = is.readMap(9, true);
    this.status = is.readMap(10, true);
}



Taf.Wup.prototype.decode = function(buf) {
    var is = new Taf.JceInputStream(buf);
    var len = is.buf.vew.getInt32(is.buf.position);
    if (len < 4) {
        throw Error("packet length too short");
    }
    // is.buf.length = len;
    is.buf.position += 4;
    this.readFrom(is);
    is = new Taf.JceInputStream(this.sBuffer.getBuffer());
    if (this.iVersion == 3) {
        this.newdata.clear();
        is.readMap(0, true, this.newdata);
    } else {
        this.data.clear();
        is.readMap(0, true, this.newdata);
    }
}


Taf.Wup.prototype.readBoolean = function(name) {
    var temp, def;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readBoolean(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var className = Taf.TypeHelp.BOOLEAN;
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readBoolean(0, true, def);
    }
    return def;
}


Taf.Wup.prototype.readInt8 = function(name) {
    var temp, def;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readInt8(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var className = Taf.TypeHelp.CHAR;
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readInt8(0, true, def);
    }
    return def;
}


Taf.Wup.prototype.readInt16 = function(name) {
    var temp, def;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readInt16(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var className = Taf.TypeHelp.SHORT;
        var newNode = temp.get(className);
        var is = new Taf.JceInputStream(newNode);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        def = is.readInt16(0, true, def);
    }
    return def;
}

Taf.Wup.prototype.readInt32 = function(name) {
    var temp, def;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readInt32(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var className = Taf.TypeHelp.INT32;
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readInt32(0, true, def);
    }
    return def;
}


Taf.Wup.prototype.readInt64 = function(name) {
    var temp, def;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readInt64(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var className = Taf.TypeHelp.INT64;
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readInt64(0, true, def);
    }
    return def;
}

Taf.Wup.prototype.readFloat = function(name) {
    var temp, def;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readFloat(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var className = Taf.TypeHelp.FLOAT;
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readFloat(0, true, def);
    }
    return def;
}


Taf.Wup.prototype.readDouble = function(name) {
    var temp;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readDouble(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var className = Taf.TypeHelp.DOUBLE;
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readDouble(0, true, def);
    }
    return def;
}


Taf.Wup.prototype.readVector = function(name, def, className) {
    var temp;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readVector(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readVector(0, true, def);
    }
    return def;
}

Taf.Wup.prototype.readStruct = function(name, def, className) {
    var temp;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readStruct(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readStruct(0, true, def);
    }
    return def;
}


Taf.Wup.prototype.readMap = function(name, def, className) {
    var temp;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readMap(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readMap(0, true, def);
    }
    return def;
}

Taf.Wup.prototype.readBytes = function(name, def, className) {
    var temp;
    if (this.iVersion == 3) {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var is = new Taf.JceInputStream(temp.buffer);
        def = is.readBytes(0, true, def);
    } else {
        temp = this.newdata.get(name);
        if (temp == undefined) {
            throw Error("UniAttribute not found key:" + name);
        }
        var newNode = temp.get(className);
        if (newNode == undefined) {
            throw Error("UniAttribute not found type:" + className);
        }
        var is = new Taf.JceInputStream(newNode);
        def = is.readBytes(0, true, def);
    }
    return def;
}
;
var Taf = Taf || {};
Taf.Util = Taf.Util || {};

Taf.Util.jcestream = function(value, col)
{
    if (value == null || value == undefined)
    {
        console.log("Taf.Util.jcestream::value is null or undefined");
        return ;
    }
    if (!(value instanceof ArrayBuffer))
    {
        console.log("Taf.Util.jcestream::value is not ArrayBuffer");
        return ;
    }
    col = col || 16;
    var view = new Uint8Array(value);
    var str = "";
    for (var i = 0; i < view.length; i++)
    {
        if (i != 0 && i%col == 0)
        {
            str += "\n";
        }
        else if (i!= 0)
        {
            str += " ";
        }

        str += (view[i] > 15?"":"0") + view[i].toString(16);
    }
    console.log(str.toUpperCase());
};

Taf.Util.str2ab = function (value)
{
    var idx, len = value.length, arr = new Array(len);
    for (idx = 0; idx < len; ++idx)
    {
        arr[ idx ] = value.charCodeAt(idx);
    }

    return new Uint8Array(arr).buffer;
};

Taf.Util.ajax = function (sURL, oData, oSuccFunc, oFailFunc)
{
    var xmlobj = new XMLHttpRequest();
    xmlobj.overrideMimeType('text/plain; charset=x-user-defined'); 	//必须的&&一定要设置

    var handleStateChange = function ()
    {
        if (xmlobj.readyState === 4)
        {
            if (xmlobj.status === 200 || xmlobj.status === 304)
            {
                oSuccFunc(Taf.Util.str2ab(xmlobj.response));
            }
            else
            {
                oFailFunc(xmlobj.status);
            }

            xmlobj.removeEventListener('readystatechange', handleStateChange);
            xmlobj = undefined;
        }
    };

    xmlobj.addEventListener('readystatechange', handleStateChange);
    xmlobj.open("post", sURL);
    xmlobj.send(oData);
};
;

//This file depends on Taf.min.js

var HUYA = HUYA || {};
HUYA.EWebSocketCommandType =
{
    EWSCmd_NULL : 0,
    EWSCmd_RegisterReq : 1,
    EWSCmd_RegisterRsp : 2,
    EWSCmd_WupReq : 3,
    EWSCmd_WupRsp : 4,
    EWSCmdC2S_HeartBeat : 5,
    EWSCmdS2C_HeartBeatAck : 6,
    EWSCmdS2C_MsgPushReq : 7,
    EWSCmdC2S_DeregisterReq : 8,
    EWSCmdS2C_DeRegisterRsp : 9,
    EWSCmdC2S_VerifyCookieReq : 10,
    EWSCmdS2C_VerifyCookieRsp : 11,
    EWSCmdC2S_VerifyHuyaTokenReq : 12,
    EWSCmdS2C_VerifyHuyaTokenRsp : 13
};
HUYA.ELiveSource =
{
    PC_YY : 0,
    PC_HUYA : 1,
    MOBILE_HUYA : 2,
    WEB_HUYA : 3
};
HUYA.EGender =
{
    MALE : 0,
    FEMALE : 1
};
HUYA.EClientTemplateType =
{
    TPL_PC : 64,
    TPL_WEB : 32,
    TPL_JIEDAI : 16,
    TPL_TEXAS : 8,
    TPL_MATCH : 4,
    TPL_HUYAAPP : 2,
    TPL_MIRROR : 1
};
HUYA.TemplateType =
{
    PRIMARY : 1,
    RECEPTION : 2
};
HUYA.EStreamLineType =
{
    STREAM_LINE_OLD_YY : 0,
    STREAM_LINE_WS : 1,
    STREAM_LINE_NEW_YY : 2,
    STREAM_LINE_AL : 3,
    STREAM_LINE_HUYA : 4,
    STREAM_LINE_TX : 5,
    STREAM_LINE_CDN : 8
};
HUYA.eUserOperation =
{
    USER_IN : 1,
    USER_OUT : 2,
    USER_MOVE : 3
};
HUYA.WebSocketCommand = function()
{
    this.iCmdType = 0;
    this.vData = new Taf.BinBuffer();
    this.lRequestId = 0;
};
HUYA.WebSocketCommand.prototype._clone = function () { return new HUYA.WebSocketCommand(); }
HUYA.WebSocketCommand.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WebSocketCommand.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WebSocketCommand.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCmdType);
    os.writeBytes(1, this.vData);
    os.writeInt64(2, this.lRequestId);
};

HUYA.WebSocketCommand.prototype.readFrom = function (is)
{
    this.iCmdType= is.readInt32(0, false, this.iCmdType);
    this.vData= is.readBytes(1, false, this.vData);
    this.lRequestId= is.readInt64(2, false, this.lRequestId);
};
HUYA.WSRegisterRsp = function()
{
    this.iResCode = 0;
    this.lRequestId = 0;
    this.sMessage = "";
    this.sBCConnHost = "";
};
HUYA.WSRegisterRsp.prototype._clone = function () { return new HUYA.WSRegisterRsp(); }
HUYA.WSRegisterRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSRegisterRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSRegisterRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResCode);
    os.writeInt64(1, this.lRequestId);
    os.writeString(2, this.sMessage);
    os.writeString(3, this.sBCConnHost);
};

HUYA.WSRegisterRsp.prototype.readFrom = function (is)
{
    this.iResCode= is.readInt32(0, false, this.iResCode);
    this.lRequestId= is.readInt64(1, false, this.lRequestId);
    this.sMessage= is.readString(2, false, this.sMessage);
    this.sBCConnHost= is.readString(3, false, this.sBCConnHost);
};
HUYA.WSPushMessage = function()
{
    this.ePushType = 0;
    this.iUri = 0;
    this.sMsg = new Taf.BinBuffer();
    this.iProtocolType = 0;
};
HUYA.WSPushMessage.prototype._clone = function () { return new HUYA.WSPushMessage(); }
HUYA.WSPushMessage.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSPushMessage.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSPushMessage.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.ePushType);
    os.writeInt64(1, this.iUri);
    os.writeBytes(2, this.sMsg);
    os.writeInt32(3, this.iProtocolType);
};

HUYA.WSPushMessage.prototype.readFrom = function (is)
{
    this.ePushType= is.readInt32(0, false, this.ePushType);
    this.iUri= is.readInt64(1, false, this.iUri);
    this.sMsg= is.readBytes(2, false, this.sMsg);
    this.iProtocolType= is.readInt32(3, false, this.iProtocolType);
};
HUYA.WSHeartBeat = function()
{
    this.iState = 0;
};
HUYA.WSHeartBeat.prototype._clone = function () { return new HUYA.WSHeartBeat(); }
HUYA.WSHeartBeat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSHeartBeat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSHeartBeat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iState);
};

HUYA.WSHeartBeat.prototype.readFrom = function (is)
{
    this.iState= is.readInt32(0, false, this.iState);
};
HUYA.WSUserInfo = function()
{
    this.lUid = 0;
    this.bAnonymous = true;
    this.sGuid = "";
    this.sToken = "";
    this.lTid = 0;
    this.lSid = 0;
    this.lGroupId = 0;
    this.lGroupType = 0;
    this.sAppId = "";
};
HUYA.WSUserInfo.prototype._clone = function () { return new HUYA.WSUserInfo(); }
HUYA.WSUserInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSUserInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSUserInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeBoolean(1, this.bAnonymous);
    os.writeString(2, this.sGuid);
    os.writeString(3, this.sToken);
    os.writeInt64(4, this.lTid);
    os.writeInt64(5, this.lSid);
    os.writeInt64(6, this.lGroupId);
    os.writeInt64(7, this.lGroupType);
    os.writeString(8, this.sAppId);
};

HUYA.WSUserInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.bAnonymous= is.readBoolean(1, false, this.bAnonymous);
    this.sGuid= is.readString(2, false, this.sGuid);
    this.sToken= is.readString(3, false, this.sToken);
    this.lTid= is.readInt64(4, false, this.lTid);
    this.lSid= is.readInt64(5, false, this.lSid);
    this.lGroupId= is.readInt64(6, false, this.lGroupId);
    this.lGroupType= is.readInt64(7, false, this.lGroupType);
    this.sAppId= is.readString(8, false, this.sAppId);
};
HUYA.WSVerifyCookieReq = function()
{
    this.lUid = 0;
    this.sUA = "";
    this.sCookie = "";
};
HUYA.WSVerifyCookieReq.prototype._clone = function () { return new HUYA.WSVerifyCookieReq(); }
HUYA.WSVerifyCookieReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSVerifyCookieReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSVerifyCookieReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sUA);
    os.writeString(2, this.sCookie);
};

HUYA.WSVerifyCookieReq.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sUA= is.readString(1, false, this.sUA);
    this.sCookie= is.readString(2, false, this.sCookie);
};
HUYA.WSVerifyCookieRsp = function()
{
    this.iValidate = 0;
};
HUYA.WSVerifyCookieRsp.prototype._clone = function () { return new HUYA.WSVerifyCookieRsp(); }
HUYA.WSVerifyCookieRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSVerifyCookieRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSVerifyCookieRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iValidate);
};

HUYA.WSVerifyCookieRsp.prototype.readFrom = function (is)
{
    this.iValidate= is.readInt32(0, false, this.iValidate);
};
HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
};
HUYA.EnterChannelReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.lTid = 0;
    this.lSid = 0;
    this.iChannelType = 0;
};
HUYA.EnterChannelReq.prototype._clone = function () { return new HUYA.EnterChannelReq(); }
HUYA.EnterChannelReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.EnterChannelReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.EnterChannelReq.prototype.writeTo = function (os)
{
    os.writeStruct(1, this.tUserId);
    os.writeInt64(2, this.lTid);
    os.writeInt64(3, this.lSid);
    os.writeInt32(4, this.iChannelType);
};

HUYA.EnterChannelReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(1, false, this.tUserId);
    this.lTid= is.readInt64(2, false, this.lTid);
    this.lSid= is.readInt64(3, false, this.lSid);
    this.iChannelType= is.readInt32(4, false, this.iChannelType);
};
HUYA.UserEventReq = function()
{
    this.tId = new HUYA.UserId();
    this.lTid = 0;
    this.lSid = 0;
    this.eOp = 0;
    this.sChan = "";
    this.eSource = 0;
    this.lPid = 0;
    this.bWatchVideo = false;
    this.bAnonymous = false;
    this.eTemplateType = HUYA.TemplateType.PRIMARY;
    this.sTraceSource = "";
};
HUYA.UserEventReq.prototype._clone = function () { return new HUYA.UserEventReq(); }
HUYA.UserEventReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserEventReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserEventReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeInt32(4, this.eOp);
    os.writeString(5, this.sChan);
    os.writeInt32(6, this.eSource);
    os.writeInt64(7, this.lPid);
    os.writeBoolean(8, this.bWatchVideo);
    os.writeBoolean(9, this.bAnonymous);
    os.writeInt32(10, this.eTemplateType);
    os.writeString(11, this.sTraceSource);
};

HUYA.UserEventReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.eOp= is.readInt32(4, false, this.eOp);
    this.sChan= is.readString(5, false, this.sChan);
    this.eSource= is.readInt32(6, false, this.eSource);
    this.lPid= is.readInt64(7, false, this.lPid);
    this.bWatchVideo= is.readBoolean(8, false, this.bWatchVideo);
    this.bAnonymous= is.readBoolean(9, false, this.bAnonymous);
    this.eTemplateType= is.readInt32(10, false, this.eTemplateType);
    this.sTraceSource= is.readString(11, false, this.sTraceSource);
};
HUYA.UserEventRsp = function()
{
    this.lTid = 0;
    this.lSid = 0;
    this.iUserHeartBeatInterval = 60;
    this.iPresentHeartBeatInterval = 60;
};
HUYA.UserEventRsp.prototype._clone = function () { return new HUYA.UserEventRsp(); }
HUYA.UserEventRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserEventRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserEventRsp.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTid);
    os.writeInt64(1, this.lSid);
    os.writeInt32(2, this.iUserHeartBeatInterval);
    os.writeInt32(3, this.iPresentHeartBeatInterval);
};

HUYA.UserEventRsp.prototype.readFrom = function (is)
{
    this.lTid= is.readInt64(0, false, this.lTid);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.iUserHeartBeatInterval= is.readInt32(2, false, this.iUserHeartBeatInterval);
    this.iPresentHeartBeatInterval= is.readInt32(3, false, this.iPresentHeartBeatInterval);
};
HUYA.UserHeartBeatReq = function()
{
    this.tId = new HUYA.UserId();
    this.lTid = 0;
    this.lSid = 0;
    this.lPid = 0;
    this.bWatchVideo = false;
    this.eLineType = HUYA.EStreamLineType.STREAM_LINE_OLD_YY;
    this.iFps = 0;
    this.iAttendee = 0;
    this.iBandwidth = 0;
    this.iLastHeartElapseTime = 0;
};
HUYA.UserHeartBeatReq.prototype._clone = function () { return new HUYA.UserHeartBeatReq(); }
HUYA.UserHeartBeatReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserHeartBeatReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserHeartBeatReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeInt64(4, this.lPid);
    os.writeBoolean(5, this.bWatchVideo);
    os.writeInt32(6, this.eLineType);
    os.writeInt32(7, this.iFps);
    os.writeInt32(8, this.iAttendee);
    os.writeInt32(9, this.iBandwidth);
    os.writeInt32(10, this.iLastHeartElapseTime);
};

HUYA.UserHeartBeatReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.lPid= is.readInt64(4, false, this.lPid);
    this.bWatchVideo= is.readBoolean(5, false, this.bWatchVideo);
    this.eLineType= is.readInt32(6, false, this.eLineType);
    this.iFps= is.readInt32(7, false, this.iFps);
    this.iAttendee= is.readInt32(8, false, this.iAttendee);
    this.iBandwidth= is.readInt32(9, false, this.iBandwidth);
    this.iLastHeartElapseTime= is.readInt32(10, false, this.iLastHeartElapseTime);
};
HUYA.UserHeartBeatRsp = function()
{
    this.iRet = 0;
};
HUYA.UserHeartBeatRsp.prototype._clone = function () { return new HUYA.UserHeartBeatRsp(); }
HUYA.UserHeartBeatRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserHeartBeatRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserHeartBeatRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
};

HUYA.UserHeartBeatRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
};
HUYA.SendMessageReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.lTid = 0;
    this.lSid = 0;
    this.sContent = "";
    this.iShowMode = 0;
    this.tFormat = new HUYA.ContentFormat();
    this.tBulletFormat = new HUYA.BulletFormat();
    this.vAtSomeone = new Taf.Vector(new HUYA.UidNickName());
    this.lPid = 0;
};
HUYA.SendMessageReq.prototype._clone = function () { return new HUYA.SendMessageReq(); }
HUYA.SendMessageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendMessageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendMessageReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeString(3, this.sContent);
    os.writeInt32(4, this.iShowMode);
    os.writeStruct(5, this.tFormat);
    os.writeStruct(6, this.tBulletFormat);
    os.writeVector(7, this.vAtSomeone);
    os.writeInt64(8, this.lPid);
};

HUYA.SendMessageReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.sContent= is.readString(3, false, this.sContent);
    this.iShowMode= is.readInt32(4, false, this.iShowMode);
    this.tFormat= is.readStruct(5, false, this.tFormat);
    this.tBulletFormat= is.readStruct(6, false, this.tBulletFormat);
    this.vAtSomeone= is.readVector(7, false, this.vAtSomeone);
    this.lPid= is.readInt64(8, false, this.lPid);
};
HUYA.SendMessageRsp = function()
{
    this.iStatus = 0;
    this.tNotice = new HUYA.MessageNotice();
};
HUYA.SendMessageRsp.prototype._clone = function () { return new HUYA.SendMessageRsp(); }
HUYA.SendMessageRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendMessageRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendMessageRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStatus);
    os.writeStruct(1, this.tNotice);
};

HUYA.SendMessageRsp.prototype.readFrom = function (is)
{
    this.iStatus= is.readInt32(0, false, this.iStatus);
    this.tNotice= is.readStruct(1, false, this.tNotice);
};
HUYA.MessageNotice = function()
{
    this.tUserInfo = new HUYA.SenderInfo();
    this.lTid = 0;
    this.lSid = 0;
    this.sContent = "";
    this.iShowMode = 0;
    this.tFormat = new HUYA.ContentFormat();
    this.tBulletFormat = new HUYA.BulletFormat();
    this.iTermType = 0;
    this.vDecorationPrefix = new Taf.Vector(new HUYA.DecorationInfo());
    this.vDecorationSuffix = new Taf.Vector(new HUYA.DecorationInfo());
    this.vAtSomeone = new Taf.Vector(new HUYA.UidNickName());
    this.lPid = 0;
};
HUYA.MessageNotice.prototype._clone = function () { return new HUYA.MessageNotice(); }
HUYA.MessageNotice.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MessageNotice.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MessageNotice.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserInfo);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeString(3, this.sContent);
    os.writeInt32(4, this.iShowMode);
    os.writeStruct(5, this.tFormat);
    os.writeStruct(6, this.tBulletFormat);
    os.writeInt32(7, this.iTermType);
    os.writeVector(8, this.vDecorationPrefix);
    os.writeVector(9, this.vDecorationSuffix);
    os.writeVector(10, this.vAtSomeone);
    os.writeInt64(11, this.lPid);
};

HUYA.MessageNotice.prototype.readFrom = function (is)
{
    this.tUserInfo= is.readStruct(0, false, this.tUserInfo);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.sContent= is.readString(3, false, this.sContent);
    this.iShowMode= is.readInt32(4, false, this.iShowMode);
    this.tFormat= is.readStruct(5, false, this.tFormat);
    this.tBulletFormat= is.readStruct(6, false, this.tBulletFormat);
    this.iTermType= is.readInt32(7, false, this.iTermType);
    this.vDecorationPrefix= is.readVector(8, false, this.vDecorationPrefix);
    this.vDecorationSuffix= is.readVector(9, false, this.vDecorationSuffix);
    this.vAtSomeone= is.readVector(10, false, this.vAtSomeone);
    this.lPid= is.readInt64(11, false, this.lPid);
};
HUYA.ContentFormat = function()
{
    this.iFontColor = -1;
    this.iFontSize = 4;
    this.iPopupStyle = 0;
};
HUYA.ContentFormat.prototype._clone = function () { return new HUYA.ContentFormat(); }
HUYA.ContentFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ContentFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ContentFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iFontColor);
    os.writeInt32(1, this.iFontSize);
    os.writeInt32(2, this.iPopupStyle);
};

HUYA.ContentFormat.prototype.readFrom = function (is)
{
    this.iFontColor= is.readInt32(0, false, this.iFontColor);
    this.iFontSize= is.readInt32(1, false, this.iFontSize);
    this.iPopupStyle= is.readInt32(2, false, this.iPopupStyle);
};
HUYA.BulletFormat = function()
{
    this.iFontColor = -1;
    this.iFontSize = 4;
    this.iTextSpeed = 0;
    this.iTransitionType = 1;
    this.iPopupStyle = 0;
};
HUYA.BulletFormat.prototype._clone = function () { return new HUYA.BulletFormat(); }
HUYA.BulletFormat.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BulletFormat.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BulletFormat.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iFontColor);
    os.writeInt32(1, this.iFontSize);
    os.writeInt32(2, this.iTextSpeed);
    os.writeInt32(3, this.iTransitionType);
    os.writeInt32(4, this.iPopupStyle);
};

HUYA.BulletFormat.prototype.readFrom = function (is)
{
    this.iFontColor= is.readInt32(0, false, this.iFontColor);
    this.iFontSize= is.readInt32(1, false, this.iFontSize);
    this.iTextSpeed= is.readInt32(2, false, this.iTextSpeed);
    this.iTransitionType= is.readInt32(3, false, this.iTransitionType);
    this.iPopupStyle= is.readInt32(4, false, this.iPopupStyle);
};
HUYA.UidNickName = function()
{
    this.lUid = 0;
    this.sNickName = "";
};
HUYA.UidNickName.prototype._clone = function () { return new HUYA.UidNickName(); }
HUYA.UidNickName.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UidNickName.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UidNickName.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
};

HUYA.UidNickName.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
};
HUYA.SenderInfo = function()
{
    this.lUid = 0;
    this.lImid = 0;
    this.sNickName = "";
    this.iGender = 0;
    this.sAvatarUrl = "";
};
HUYA.SenderInfo.prototype._clone = function () { return new HUYA.SenderInfo(); }
HUYA.SenderInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SenderInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SenderInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lImid);
    os.writeString(2, this.sNickName);
    os.writeInt32(3, this.iGender);
    os.writeString(4, this.sAvatarUrl);
};

HUYA.SenderInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lImid= is.readInt64(1, false, this.lImid);
    this.sNickName= is.readString(2, false, this.sNickName);
    this.iGender= is.readInt32(3, false, this.iGender);
    this.sAvatarUrl= is.readString(4, false, this.sAvatarUrl);
};
HUYA.DecorationInfo = function()
{
    this.iAppId = 0;
    this.iViewType = 0;
    this.vData = new Taf.BinBuffer();
};
HUYA.DecorationInfo.prototype._clone = function () { return new HUYA.DecorationInfo(); }
HUYA.DecorationInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DecorationInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DecorationInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAppId);
    os.writeInt32(1, this.iViewType);
    os.writeBytes(2, this.vData);
};

HUYA.DecorationInfo.prototype.readFrom = function (is)
{
    this.iAppId= is.readInt32(0, false, this.iAppId);
    this.iViewType= is.readInt32(1, false, this.iViewType);
    this.vData= is.readBytes(2, false, this.vData);
};
HUYA.EDecorationAppType =
{
    kDecorationAppTypeCommon : 100,
    kDecorationAppTypeChannel : 10000,
    kDecorationAppTypeAdmin : 10100,
    kDecorationAppTypeDaiyanClub : 10150,
    kDecorationAppTypeNoble : 10200,
    kDecorationAppTypeGuard : 10300,
    kDecorationAppTypeFans : 10400,
    kDecorationAppTypeVIP : 10500,
    kDecorationAppTypeUserProfile : 10560,
    kDecorationAppTyperPurpleDiamond : 10600,
    kDecorationAppTypeStamp : 10700,
    KDecorationAppTypeNobleEmoticon : 10800,
    KDecorationAppTypePresenter : 10900,
    KDecorationAppTypeFirstRecharge : 11000
};
HUYA.EDecorationViewType =
{
    kDecorationViewTypeCustomized : 0,
    kDecorationViewTypeText : 1,
    kDecorationViewTypeIcon : 2
};
HUYA.MsgCommDecoChannelRoleInfo = function()
{
    this.iLevel = 0;
};
HUYA.MsgCommDecoChannelRoleInfo.prototype._clone = function () { return new HUYA.MsgCommDecoChannelRoleInfo(); }
HUYA.MsgCommDecoChannelRoleInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MsgCommDecoChannelRoleInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MsgCommDecoChannelRoleInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iLevel);
};

HUYA.MsgCommDecoChannelRoleInfo.prototype.readFrom = function (is)
{
    this.iLevel= is.readInt32(0, false, this.iLevel);
};
HUYA.GetStampRsp = function()
{
    this.lUid = 0;
    this.lStampUid = 0;
    this.sStampNick = "";
    this.lStampTime = 0;
    this.tStampInfo = new HUYA.StampInfo();
    this.lDeadline = 0;
};
HUYA.GetStampRsp.prototype._clone = function () { return new HUYA.GetStampRsp(); }
HUYA.GetStampRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetStampRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetStampRsp.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lStampUid);
    os.writeString(2, this.sStampNick);
    os.writeInt64(3, this.lStampTime);
    os.writeStruct(4, this.tStampInfo);
    os.writeInt64(5, this.lDeadline);
};

HUYA.GetStampRsp.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lStampUid= is.readInt64(1, false, this.lStampUid);
    this.sStampNick= is.readString(2, false, this.sStampNick);
    this.lStampTime= is.readInt64(3, false, this.lStampTime);
    this.tStampInfo= is.readStruct(4, false, this.tStampInfo);
    this.lDeadline= is.readInt64(5, false, this.lDeadline);
};
HUYA.StampInfo = function()
{
    this.iId = 0;
    this.sStamp = "";
    this.iLevel = 0;
    this.lStampPrice = 0;
    this.iValidity = 0;
};
HUYA.StampInfo.prototype._clone = function () { return new HUYA.StampInfo(); }
HUYA.StampInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.StampInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.StampInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iId);
    os.writeString(1, this.sStamp);
    os.writeInt32(2, this.iLevel);
    os.writeInt64(3, this.lStampPrice);
    os.writeInt32(4, this.iValidity);
};

HUYA.StampInfo.prototype.readFrom = function (is)
{
    this.iId= is.readInt32(0, false, this.iId);
    this.sStamp= is.readString(1, false, this.sStamp);
    this.iLevel= is.readInt32(2, false, this.iLevel);
    this.lStampPrice= is.readInt64(3, false, this.lStampPrice);
    this.iValidity= is.readInt32(4, false, this.iValidity);
};
HUYA.MsgCommDecoIcon = function()
{
    this.sUrl = "";
};
HUYA.MsgCommDecoIcon.prototype._clone = function () { return new HUYA.MsgCommDecoIcon(); }
HUYA.MsgCommDecoIcon.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MsgCommDecoIcon.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MsgCommDecoIcon.prototype.writeTo = function (os)
{
    os.writeString(0, this.sUrl);
};

HUYA.MsgCommDecoIcon.prototype.readFrom = function (is)
{
    this.sUrl= is.readString(0, false, this.sUrl);
};
HUYA.MsgCommDecoText = function()
{
    this.sText = "";
    this.iColor = 0;
};
HUYA.MsgCommDecoText.prototype._clone = function () { return new HUYA.MsgCommDecoText(); }
HUYA.MsgCommDecoText.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MsgCommDecoText.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MsgCommDecoText.prototype.writeTo = function (os)
{
    os.writeString(0, this.sText);
    os.writeInt32(1, this.iColor);
};

HUYA.MsgCommDecoText.prototype.readFrom = function (is)
{
    this.sText= is.readString(0, false, this.sText);
    this.iColor= is.readInt32(1, false, this.iColor);
};
HUYA.GetUserTypeRsp = function()
{
    this.lUid = 0;
    this.lPresenterUid = 0;
    this.iType = 0;
    this.tIsMutedRsp = new HUYA.IsMutedRsp();
};
HUYA.GetUserTypeRsp.prototype._clone = function () { return new HUYA.GetUserTypeRsp(); }
HUYA.GetUserTypeRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetUserTypeRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetUserTypeRsp.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPresenterUid);
    os.writeInt32(3, this.iType);
    os.writeStruct(4, this.tIsMutedRsp);
};

HUYA.GetUserTypeRsp.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPresenterUid= is.readInt64(1, false, this.lPresenterUid);
    this.iType= is.readInt32(3, false, this.iType);
    this.tIsMutedRsp= is.readStruct(4, false, this.tIsMutedRsp);
};
HUYA.IsMutedRsp = function()
{
    this.bMuted = false;
    this.iMutedTime = 0;
    this.lAutoUnmutedTime = 0;
    this.iMutedType = 0;
};
HUYA.IsMutedRsp.prototype._clone = function () { return new HUYA.IsMutedRsp(); }
HUYA.IsMutedRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.IsMutedRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.IsMutedRsp.prototype.writeTo = function (os)
{
    os.writeBoolean(0, this.bMuted);
    os.writeInt32(1, this.iMutedTime);
    os.writeInt64(2, this.lAutoUnmutedTime);
    os.writeInt32(3, this.iMutedType);
};

HUYA.IsMutedRsp.prototype.readFrom = function (is)
{
    this.bMuted= is.readBoolean(0, false, this.bMuted);
    this.iMutedTime= is.readInt32(1, false, this.iMutedTime);
    this.lAutoUnmutedTime= is.readInt64(2, false, this.lAutoUnmutedTime);
    this.iMutedType= is.readInt32(3, false, this.iMutedType);
};
HUYA.MsgCommDecoGuardInfo = function()
{
    this.iLevel = 0;
};
HUYA.MsgCommDecoGuardInfo.prototype._clone = function () { return new HUYA.MsgCommDecoGuardInfo(); }
HUYA.MsgCommDecoGuardInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MsgCommDecoGuardInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MsgCommDecoGuardInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iLevel);
};

HUYA.MsgCommDecoGuardInfo.prototype.readFrom = function (is)
{
    this.iLevel= is.readInt32(0, false, this.iLevel);
};
HUYA.PurpleVipInfo = function()
{
    this.lUid = 0;
    this.iIsSuper = 0;
    this.iChargeType = 0;
    this.iVipGrade = 0;
    this.sIconUrl = "";
};
HUYA.PurpleVipInfo.prototype._clone = function () { return new HUYA.PurpleVipInfo(); }
HUYA.PurpleVipInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PurpleVipInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PurpleVipInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt32(1, this.iIsSuper);
    os.writeInt32(2, this.iChargeType);
    os.writeInt32(3, this.iVipGrade);
    os.writeString(4, this.sIconUrl);
};

HUYA.PurpleVipInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.iIsSuper= is.readInt32(1, false, this.iIsSuper);
    this.iChargeType= is.readInt32(2, false, this.iChargeType);
    this.iVipGrade= is.readInt32(3, false, this.iVipGrade);
    this.sIconUrl= is.readString(4, false, this.sIconUrl);
};
HUYA.BadgeInfo = function()
{
    this.lUid = 0;
    this.lBadgeId = 0;
    this.sPresenterNickName = "";
    this.sBadgeName = "";
    this.iBadgeLevel = 0;
    this.iRank = 0;
    this.iScore = 0;
    this.iNextScore = 0;
    this.iQuotaUsed = 0;
    this.iQuota = 0;
    this.lQuotaTS = 0;
    this.lOpenTS = 0;
    this.iVFlag = 0;
    this.sVLogo = "";
    this.tChannelInfo = new HUYA.PresenterChannelInfo();
    this.sPresenterLogo = "";
    this.lVExpiredTS = 0;
};
HUYA.BadgeInfo.prototype._clone = function () { return new HUYA.BadgeInfo(); }
HUYA.BadgeInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BadgeInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BadgeInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lBadgeId);
    os.writeString(2, this.sPresenterNickName);
    os.writeString(3, this.sBadgeName);
    os.writeInt32(4, this.iBadgeLevel);
    os.writeInt32(5, this.iRank);
    os.writeInt32(6, this.iScore);
    os.writeInt32(7, this.iNextScore);
    os.writeInt32(8, this.iQuotaUsed);
    os.writeInt32(9, this.iQuota);
    os.writeInt64(10, this.lQuotaTS);
    os.writeInt64(11, this.lOpenTS);
    os.writeInt32(12, this.iVFlag);
    os.writeString(13, this.sVLogo);
    os.writeStruct(14, this.tChannelInfo);
    os.writeString(15, this.sPresenterLogo);
    os.writeInt64(16, this.lVExpiredTS);
};

HUYA.BadgeInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lBadgeId= is.readInt64(1, false, this.lBadgeId);
    this.sPresenterNickName= is.readString(2, false, this.sPresenterNickName);
    this.sBadgeName= is.readString(3, false, this.sBadgeName);
    this.iBadgeLevel= is.readInt32(4, false, this.iBadgeLevel);
    this.iRank= is.readInt32(5, false, this.iRank);
    this.iScore= is.readInt32(6, false, this.iScore);
    this.iNextScore= is.readInt32(7, false, this.iNextScore);
    this.iQuotaUsed= is.readInt32(8, false, this.iQuotaUsed);
    this.iQuota= is.readInt32(9, false, this.iQuota);
    this.lQuotaTS= is.readInt64(10, false, this.lQuotaTS);
    this.lOpenTS= is.readInt64(11, false, this.lOpenTS);
    this.iVFlag= is.readInt32(12, false, this.iVFlag);
    this.sVLogo= is.readString(13, false, this.sVLogo);
    this.tChannelInfo= is.readStruct(14, false, this.tChannelInfo);
    this.sPresenterLogo= is.readString(15, false, this.sPresenterLogo);
    this.lVExpiredTS= is.readInt64(16, false, this.lVExpiredTS);
};
HUYA.GuardInfo = function()
{
    this.lUid = 0;
    this.lPid = 0;
    this.iGuardLevel = 0;
    this.lEndTime = 0;
};
HUYA.GuardInfo.prototype._clone = function () { return new HUYA.GuardInfo(); }
HUYA.GuardInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GuardInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GuardInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPid);
    os.writeInt32(2, this.iGuardLevel);
    os.writeInt64(3, this.lEndTime);
};

HUYA.GuardInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.iGuardLevel= is.readInt32(2, false, this.iGuardLevel);
    this.lEndTime= is.readInt64(3, false, this.lEndTime);
};
HUYA.GetLivingInfoReq = function()
{
    this.tId = new HUYA.UserId();
    this.lTopSid = 0;
    this.lSubSid = 0;
    this.lPresenterUid = 0;
    this.sTraceSource = "";
};
HUYA.GetLivingInfoReq.prototype._clone = function () { return new HUYA.GetLivingInfoReq(); }
HUYA.GetLivingInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetLivingInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetLivingInfoReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lTopSid);
    os.writeInt64(2, this.lSubSid);
    os.writeInt64(3, this.lPresenterUid);
    os.writeString(4, this.sTraceSource);
};

HUYA.GetLivingInfoReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lTopSid= is.readInt64(1, false, this.lTopSid);
    this.lSubSid= is.readInt64(2, false, this.lSubSid);
    this.lPresenterUid= is.readInt64(3, false, this.lPresenterUid);
    this.sTraceSource= is.readString(4, false, this.sTraceSource);
};
HUYA.GetLivingInfoRsp = function()
{
    this.bIsLiving = 0;
    this.tNotice = new HUYA.BeginLiveNotice();
    this.tStreamSettingNotice = new HUYA.StreamSettingNotice();
    this.bIsSelfLiving = 0;
};
HUYA.GetLivingInfoRsp.prototype._clone = function () { return new HUYA.GetLivingInfoRsp(); }
HUYA.GetLivingInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetLivingInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetLivingInfoRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.bIsLiving);
    os.writeStruct(1, this.tNotice);
    os.writeStruct(2, this.tStreamSettingNotice);
    os.writeInt32(3, this.bIsSelfLiving);
};

HUYA.GetLivingInfoRsp.prototype.readFrom = function (is)
{
    this.bIsLiving= is.readInt32(0, false, this.bIsLiving);
    this.tNotice= is.readStruct(1, false, this.tNotice);
    this.tStreamSettingNotice= is.readStruct(2, false, this.tStreamSettingNotice);
    this.bIsSelfLiving= is.readInt32(3, false, this.bIsSelfLiving);
};
HUYA.BeginLiveNotice = function()
{
    this.lPresenterUid = 0;
    this.iGameId = 0;
    this.sGameName = "";
    this.iRandomRange = 0;
    this.iStreamType = 0;
    this.vStreamInfo = new Taf.Vector(new HUYA.StreamInfo());
    this.vCdnList = new Taf.Vector(new Taf.STRING());
    this.lLiveId = 0;
    this.iPCDefaultBitRate = 0;
    this.iWebDefaultBitRate = 0;
    this.iMobileDefaultBitRate = 0;
    this.lMultiStreamFlag = 0;
    this.sNick = "";
    this.lYYId = 0;
    this.lAttendeeCount = 0;
    this.iCodecType = 0;
    this.iScreenType = 0;
    this.vMultiStreamInfo = new Taf.Vector(new HUYA.MultiStreamInfo());
    this.sLiveDesc = "";
    this.lLiveCompatibleFlag = 0;
    this.sAvatarUrl = "";
    this.iSourceType = 0;
    this.sSubchannelName = "";
    this.sVideoCaptureUrl = "";
    this.iStartTime = 0;
    this.lChannelId = 0;
    this.lSubChannelId = 0;
    this.sLocation = "";
    this.iCdnPolicyLevel = 0;
    this.iGameType = 0;
    this.mMiscInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.iShortChannel = 0;
};
HUYA.BeginLiveNotice.prototype._clone = function () { return new HUYA.BeginLiveNotice(); }
HUYA.BeginLiveNotice.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BeginLiveNotice.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BeginLiveNotice.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPresenterUid);
    os.writeInt32(1, this.iGameId);
    os.writeString(2, this.sGameName);
    os.writeInt32(3, this.iRandomRange);
    os.writeInt32(4, this.iStreamType);
    os.writeVector(5, this.vStreamInfo);
    os.writeVector(6, this.vCdnList);
    os.writeInt64(7, this.lLiveId);
    os.writeInt32(8, this.iPCDefaultBitRate);
    os.writeInt32(9, this.iWebDefaultBitRate);
    os.writeInt32(10, this.iMobileDefaultBitRate);
    os.writeInt64(11, this.lMultiStreamFlag);
    os.writeString(12, this.sNick);
    os.writeInt64(13, this.lYYId);
    os.writeInt64(14, this.lAttendeeCount);
    os.writeInt32(15, this.iCodecType);
    os.writeInt32(16, this.iScreenType);
    os.writeVector(17, this.vMultiStreamInfo);
    os.writeString(18, this.sLiveDesc);
    os.writeInt64(19, this.lLiveCompatibleFlag);
    os.writeString(20, this.sAvatarUrl);
    os.writeInt32(21, this.iSourceType);
    os.writeString(22, this.sSubchannelName);
    os.writeString(23, this.sVideoCaptureUrl);
    os.writeInt32(24, this.iStartTime);
    os.writeInt64(25, this.lChannelId);
    os.writeInt64(26, this.lSubChannelId);
    os.writeString(27, this.sLocation);
    os.writeInt32(28, this.iCdnPolicyLevel);
    os.writeInt32(29, this.iGameType);
    os.writeMap(30, this.mMiscInfo);
    os.writeInt32(31, this.iShortChannel);
};

HUYA.BeginLiveNotice.prototype.readFrom = function (is)
{
    this.lPresenterUid= is.readInt64(0, false, this.lPresenterUid);
    this.iGameId= is.readInt32(1, false, this.iGameId);
    this.sGameName= is.readString(2, false, this.sGameName);
    this.iRandomRange= is.readInt32(3, false, this.iRandomRange);
    this.iStreamType= is.readInt32(4, false, this.iStreamType);
    this.vStreamInfo= is.readVector(5, false, this.vStreamInfo);
    this.vCdnList= is.readVector(6, false, this.vCdnList);
    this.lLiveId= is.readInt64(7, false, this.lLiveId);
    this.iPCDefaultBitRate= is.readInt32(8, false, this.iPCDefaultBitRate);
    this.iWebDefaultBitRate= is.readInt32(9, false, this.iWebDefaultBitRate);
    this.iMobileDefaultBitRate= is.readInt32(10, false, this.iMobileDefaultBitRate);
    this.lMultiStreamFlag= is.readInt64(11, false, this.lMultiStreamFlag);
    this.sNick= is.readString(12, false, this.sNick);
    this.lYYId= is.readInt64(13, false, this.lYYId);
    this.lAttendeeCount= is.readInt64(14, false, this.lAttendeeCount);
    this.iCodecType= is.readInt32(15, false, this.iCodecType);
    this.iScreenType= is.readInt32(16, false, this.iScreenType);
    this.vMultiStreamInfo= is.readVector(17, false, this.vMultiStreamInfo);
    this.sLiveDesc= is.readString(18, false, this.sLiveDesc);
    this.lLiveCompatibleFlag= is.readInt64(19, false, this.lLiveCompatibleFlag);
    this.sAvatarUrl= is.readString(20, false, this.sAvatarUrl);
    this.iSourceType= is.readInt32(21, false, this.iSourceType);
    this.sSubchannelName= is.readString(22, false, this.sSubchannelName);
    this.sVideoCaptureUrl= is.readString(23, false, this.sVideoCaptureUrl);
    this.iStartTime= is.readInt32(24, false, this.iStartTime);
    this.lChannelId= is.readInt64(25, false, this.lChannelId);
    this.lSubChannelId= is.readInt64(26, false, this.lSubChannelId);
    this.sLocation= is.readString(27, false, this.sLocation);
    this.iCdnPolicyLevel= is.readInt32(28, false, this.iCdnPolicyLevel);
    this.iGameType= is.readInt32(29, false, this.iGameType);
    this.mMiscInfo= is.readMap(30, false, this.mMiscInfo);
    this.iShortChannel= is.readInt32(31, false, this.iShortChannel);
};
HUYA.StreamInfo = function()
{
    this.sCdnType = "";
    this.iIsMaster = 0;
    this.lChannelId = 0;
    this.lSubChannelId = 0;
    this.lPresenterUid = 0;
    this.sStreamName = "";
    this.sFlvUrl = "";
    this.sFlvUrlSuffix = "";
    this.sFlvAntiCode = "";
    this.sHlsUrl = "";
    this.sHlsUrlSuffix = "";
    this.sHlsAntiCode = "";
    this.iLineIndex = 0;
    this.iIsMultiStream = 0;
    this.iPCPriorityRate = 0;
    this.iWebPriorityRate = 0;
    this.iMobilePriorityRate = 0;
    this.vFlvIPList = new Taf.Vector(new Taf.STRING());
    this.iIsP2PSupport = 0;
    this.sP2pUrl = "";
    this.sP2pUrlSuffix = "";
    this.sP2pAntiCode = "";
    this.lFreeFlag = 0;
};
HUYA.StreamInfo.prototype._clone = function () { return new HUYA.StreamInfo(); }
HUYA.StreamInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.StreamInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.StreamInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sCdnType);
    os.writeInt32(1, this.iIsMaster);
    os.writeInt64(2, this.lChannelId);
    os.writeInt64(3, this.lSubChannelId);
    os.writeInt64(4, this.lPresenterUid);
    os.writeString(5, this.sStreamName);
    os.writeString(6, this.sFlvUrl);
    os.writeString(7, this.sFlvUrlSuffix);
    os.writeString(8, this.sFlvAntiCode);
    os.writeString(9, this.sHlsUrl);
    os.writeString(10, this.sHlsUrlSuffix);
    os.writeString(11, this.sHlsAntiCode);
    os.writeInt32(12, this.iLineIndex);
    os.writeInt32(13, this.iIsMultiStream);
    os.writeInt32(14, this.iPCPriorityRate);
    os.writeInt32(15, this.iWebPriorityRate);
    os.writeInt32(16, this.iMobilePriorityRate);
    os.writeVector(17, this.vFlvIPList);
    os.writeInt32(18, this.iIsP2PSupport);
    os.writeString(19, this.sP2pUrl);
    os.writeString(20, this.sP2pUrlSuffix);
    os.writeString(21, this.sP2pAntiCode);
    os.writeInt64(22, this.lFreeFlag);
};

HUYA.StreamInfo.prototype.readFrom = function (is)
{
    this.sCdnType= is.readString(0, false, this.sCdnType);
    this.iIsMaster= is.readInt32(1, false, this.iIsMaster);
    this.lChannelId= is.readInt64(2, false, this.lChannelId);
    this.lSubChannelId= is.readInt64(3, false, this.lSubChannelId);
    this.lPresenterUid= is.readInt64(4, false, this.lPresenterUid);
    this.sStreamName= is.readString(5, false, this.sStreamName);
    this.sFlvUrl= is.readString(6, false, this.sFlvUrl);
    this.sFlvUrlSuffix= is.readString(7, false, this.sFlvUrlSuffix);
    this.sFlvAntiCode= is.readString(8, false, this.sFlvAntiCode);
    this.sHlsUrl= is.readString(9, false, this.sHlsUrl);
    this.sHlsUrlSuffix= is.readString(10, false, this.sHlsUrlSuffix);
    this.sHlsAntiCode= is.readString(11, false, this.sHlsAntiCode);
    this.iLineIndex= is.readInt32(12, false, this.iLineIndex);
    this.iIsMultiStream= is.readInt32(13, false, this.iIsMultiStream);
    this.iPCPriorityRate= is.readInt32(14, false, this.iPCPriorityRate);
    this.iWebPriorityRate= is.readInt32(15, false, this.iWebPriorityRate);
    this.iMobilePriorityRate= is.readInt32(16, false, this.iMobilePriorityRate);
    this.vFlvIPList= is.readVector(17, false, this.vFlvIPList);
    this.iIsP2PSupport= is.readInt32(18, false, this.iIsP2PSupport);
    this.sP2pUrl= is.readString(19, false, this.sP2pUrl);
    this.sP2pUrlSuffix= is.readString(20, false, this.sP2pUrlSuffix);
    this.sP2pAntiCode= is.readString(21, false, this.sP2pAntiCode);
    this.lFreeFlag= is.readInt64(22, false, this.lFreeFlag);
};
HUYA.MultiStreamInfo = function()
{
    this.sDisplayName = "";
    this.iBitRate = 0;
    this.iCodecType = 0;
    this.iCompatibleFlag = 0;
};
HUYA.MultiStreamInfo.prototype._clone = function () { return new HUYA.MultiStreamInfo(); }
HUYA.MultiStreamInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MultiStreamInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MultiStreamInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sDisplayName);
    os.writeInt32(1, this.iBitRate);
    os.writeInt32(2, this.iCodecType);
    os.writeInt32(3, this.iCompatibleFlag);
};

HUYA.MultiStreamInfo.prototype.readFrom = function (is)
{
    this.sDisplayName= is.readString(0, false, this.sDisplayName);
    this.iBitRate= is.readInt32(1, false, this.iBitRate);
    this.iCodecType= is.readInt32(2, false, this.iCodecType);
    this.iCompatibleFlag= is.readInt32(3, false, this.iCompatibleFlag);
};
HUYA.StreamSettingNotice = function()
{
    this.lPresenterUid = 0;
    this.iBitRate = 0;
    this.iResolution = 0;
    this.iFrameRate = 0;
    this.lLiveId = 0;
    this.sDisplayName = "";
};
HUYA.StreamSettingNotice.prototype._clone = function () { return new HUYA.StreamSettingNotice(); }
HUYA.StreamSettingNotice.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.StreamSettingNotice.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.StreamSettingNotice.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPresenterUid);
    os.writeInt32(1, this.iBitRate);
    os.writeInt32(2, this.iResolution);
    os.writeInt32(3, this.iFrameRate);
    os.writeInt64(4, this.lLiveId);
    os.writeString(5, this.sDisplayName);
};

HUYA.StreamSettingNotice.prototype.readFrom = function (is)
{
    this.lPresenterUid= is.readInt64(0, false, this.lPresenterUid);
    this.iBitRate= is.readInt32(1, false, this.iBitRate);
    this.iResolution= is.readInt32(2, false, this.iResolution);
    this.iFrameRate= is.readInt32(3, false, this.iFrameRate);
    this.lLiveId= is.readInt64(4, false, this.lLiveId);
    this.sDisplayName= is.readString(5, false, this.sDisplayName);
};
HUYA.LiveLaunchReq = function()
{
    this.tId = new HUYA.UserId();
    this.tLiveUB = new HUYA.LiveUserbase();
};
HUYA.LiveLaunchReq.prototype._clone = function () { return new HUYA.LiveLaunchReq(); }
HUYA.LiveLaunchReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveLaunchReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveLaunchReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeStruct(1, this.tLiveUB);
};

HUYA.LiveLaunchReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.tLiveUB= is.readStruct(1, false, this.tLiveUB);
};
HUYA.LiveLaunchRsp = function()
{
    this.sGuid = "";
    this.iTime = 0;
    this.vProxyList = new Taf.Vector(new HUYA.LiveProxyValue());
    this.eAccess = 0;
    this.sClientIp = "";
};
HUYA.LiveLaunchRsp.prototype._clone = function () { return new HUYA.LiveLaunchRsp(); }
HUYA.LiveLaunchRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveLaunchRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveLaunchRsp.prototype.writeTo = function (os)
{
    os.writeString(0, this.sGuid);
    os.writeInt32(1, this.iTime);
    os.writeVector(2, this.vProxyList);
    os.writeInt32(3, this.eAccess);
    os.writeString(4, this.sClientIp);
};

HUYA.LiveLaunchRsp.prototype.readFrom = function (is)
{
    this.sGuid= is.readString(0, false, this.sGuid);
    this.iTime= is.readInt32(1, false, this.iTime);
    this.vProxyList= is.readVector(2, false, this.vProxyList);
    this.eAccess= is.readInt32(3, false, this.eAccess);
    this.sClientIp= is.readString(4, false, this.sClientIp);
};
HUYA.LiveAppUAEx = function()
{
    this.sIMEI = "";
    this.sAPN = "";
    this.sNetType = "";
    this.sDeviceId = "";
};
HUYA.LiveAppUAEx.prototype._clone = function () { return new HUYA.LiveAppUAEx(); }
HUYA.LiveAppUAEx.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveAppUAEx.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveAppUAEx.prototype.writeTo = function (os)
{
    os.writeString(1, this.sIMEI);
    os.writeString(2, this.sAPN);
    os.writeString(3, this.sNetType);
    os.writeString(4, this.sDeviceId);
};

HUYA.LiveAppUAEx.prototype.readFrom = function (is)
{
    this.sIMEI= is.readString(1, false, this.sIMEI);
    this.sAPN= is.readString(2, false, this.sAPN);
    this.sNetType= is.readString(3, false, this.sNetType);
    this.sDeviceId= is.readString(4, false, this.sDeviceId);
};
HUYA.LiveUserbase = function()
{
    this.eSource = 0;
    this.eType = 0;
    this.tUAEx = new HUYA.LiveAppUAEx();
};
HUYA.LiveUserbase.prototype._clone = function () { return new HUYA.LiveUserbase(); }
HUYA.LiveUserbase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveUserbase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveUserbase.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.eSource);
    os.writeInt32(1, this.eType);
    os.writeStruct(2, this.tUAEx);
};

HUYA.LiveUserbase.prototype.readFrom = function (is)
{
    this.eSource= is.readInt32(0, false, this.eSource);
    this.eType= is.readInt32(1, false, this.eType);
    this.tUAEx= is.readStruct(2, false, this.tUAEx);
};
HUYA.LiveProxyValue = function()
{
    this.eProxyType = 0;
    this.sProxy = new Taf.Vector(new Taf.STRING());
};
HUYA.LiveProxyValue.prototype._clone = function () { return new HUYA.LiveProxyValue(); }
HUYA.LiveProxyValue.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveProxyValue.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveProxyValue.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.eProxyType);
    os.writeVector(1, this.sProxy);
};

HUYA.LiveProxyValue.prototype.readFrom = function (is)
{
    this.eProxyType= is.readInt32(0, false, this.eProxyType);
    this.sProxy= is.readVector(1, false, this.sProxy);
};
HUYA.SendCardPackageItemReq = function()
{
    this.tId = new HUYA.UserId();
    this.lSid = 0;
    this.lSubSid = 0;
    this.iShowFreeitemInfo = 0;
    this.iItemType = 0;
    this.iItemCount = 0;
    this.lPresenterUid = 0;
    this.sPayId = "";
    this.sSendContent = "";
    this.sSenderNick = "";
    this.sPresenterNick = "";
    this.iPayPloy = 0;
    this.iItemCountByGroup = 0;
    this.iItemGroup = 0;
    this.iSuperPupleLevel = 0;
    this.iFromType = 0;
    this.sExpand = "";
    this.sToken = "";
    this.iTemplateType = 0;
    this.sTokencaKey = "";
    this.sPassport = "";
    this.iSenderShortSid = 0;
    this.iPayByFreeItem = 0;
    this.tExtUser = new HUYA.ExternalUser();
    this.iEventType = 0;
};
HUYA.SendCardPackageItemReq.prototype._clone = function () { return new HUYA.SendCardPackageItemReq(); }
HUYA.SendCardPackageItemReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendCardPackageItemReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendCardPackageItemReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lSid);
    os.writeInt64(2, this.lSubSid);
    os.writeInt32(3, this.iShowFreeitemInfo);
    os.writeInt32(4, this.iItemType);
    os.writeInt32(5, this.iItemCount);
    os.writeInt64(6, this.lPresenterUid);
    os.writeString(7, this.sPayId);
    os.writeString(9, this.sSendContent);
    os.writeString(10, this.sSenderNick);
    os.writeString(11, this.sPresenterNick);
    os.writeInt32(12, this.iPayPloy);
    os.writeInt32(13, this.iItemCountByGroup);
    os.writeInt32(14, this.iItemGroup);
    os.writeInt32(15, this.iSuperPupleLevel);
    os.writeInt32(16, this.iFromType);
    os.writeString(17, this.sExpand);
    os.writeString(18, this.sToken);
    os.writeInt32(19, this.iTemplateType);
    os.writeString(20, this.sTokencaKey);
    os.writeString(21, this.sPassport);
    os.writeInt64(22, this.iSenderShortSid);
    os.writeInt32(23, this.iPayByFreeItem);
    os.writeStruct(24, this.tExtUser);
    os.writeInt16(25, this.iEventType);
};

HUYA.SendCardPackageItemReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.lSubSid= is.readInt64(2, false, this.lSubSid);
    this.iShowFreeitemInfo= is.readInt32(3, false, this.iShowFreeitemInfo);
    this.iItemType= is.readInt32(4, false, this.iItemType);
    this.iItemCount= is.readInt32(5, false, this.iItemCount);
    this.lPresenterUid= is.readInt64(6, false, this.lPresenterUid);
    this.sPayId= is.readString(7, false, this.sPayId);
    this.sSendContent= is.readString(9, false, this.sSendContent);
    this.sSenderNick= is.readString(10, false, this.sSenderNick);
    this.sPresenterNick= is.readString(11, false, this.sPresenterNick);
    this.iPayPloy= is.readInt32(12, false, this.iPayPloy);
    this.iItemCountByGroup= is.readInt32(13, false, this.iItemCountByGroup);
    this.iItemGroup= is.readInt32(14, false, this.iItemGroup);
    this.iSuperPupleLevel= is.readInt32(15, false, this.iSuperPupleLevel);
    this.iFromType= is.readInt32(16, false, this.iFromType);
    this.sExpand= is.readString(17, false, this.sExpand);
    this.sToken= is.readString(18, false, this.sToken);
    this.iTemplateType= is.readInt32(19, false, this.iTemplateType);
    this.sTokencaKey= is.readString(20, false, this.sTokencaKey);
    this.sPassport= is.readString(21, false, this.sPassport);
    this.iSenderShortSid= is.readInt64(22, false, this.iSenderShortSid);
    this.iPayByFreeItem= is.readInt32(23, false, this.iPayByFreeItem);
    this.tExtUser= is.readStruct(24, false, this.tExtUser);
    this.iEventType= is.readInt16(25, false, this.iEventType);
};
HUYA.SendCardPackageItemRsp = function()
{
    this.iPayRespCode = 0;
    this.iItemType = 0;
    this.iItemCount = 0;
    this.strPayId = "";
    this.strPayConfirmUrl = "";
    this.strSendContent = "";
    this.iItemCountByGroup = 0;
    this.iItemGroup = 0;
    this.lPresenterUid = 0;
    this.sExpand = "";
    this.strPayItemInfo = "";
    this.iPayType = 0;
};
HUYA.SendCardPackageItemRsp.prototype._clone = function () { return new HUYA.SendCardPackageItemRsp(); }
HUYA.SendCardPackageItemRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendCardPackageItemRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendCardPackageItemRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iPayRespCode);
    os.writeInt32(1, this.iItemType);
    os.writeInt32(2, this.iItemCount);
    os.writeString(3, this.strPayId);
    os.writeString(4, this.strPayConfirmUrl);
    os.writeString(5, this.strSendContent);
    os.writeInt32(6, this.iItemCountByGroup);
    os.writeInt32(7, this.iItemGroup);
    os.writeInt64(8, this.lPresenterUid);
    os.writeString(9, this.sExpand);
    os.writeString(10, this.strPayItemInfo);
    os.writeInt32(11, this.iPayType);
};

HUYA.SendCardPackageItemRsp.prototype.readFrom = function (is)
{
    this.iPayRespCode= is.readInt32(0, false, this.iPayRespCode);
    this.iItemType= is.readInt32(1, false, this.iItemType);
    this.iItemCount= is.readInt32(2, false, this.iItemCount);
    this.strPayId= is.readString(3, false, this.strPayId);
    this.strPayConfirmUrl= is.readString(4, false, this.strPayConfirmUrl);
    this.strSendContent= is.readString(5, false, this.strSendContent);
    this.iItemCountByGroup= is.readInt32(6, false, this.iItemCountByGroup);
    this.iItemGroup= is.readInt32(7, false, this.iItemGroup);
    this.lPresenterUid= is.readInt64(8, false, this.lPresenterUid);
    this.sExpand= is.readString(9, false, this.sExpand);
    this.strPayItemInfo= is.readString(10, false, this.strPayItemInfo);
    this.iPayType= is.readInt32(11, false, this.iPayType);
};
HUYA.SenderItem = function()
{
    this.lSenderUid = 0;
    this.lYYid = 0;
    this.iSenderRole = 0;
    this.iSenderGender = 0;
    this.sSenderNick = "";
};
HUYA.SenderItem.prototype._clone = function () { return new HUYA.SenderItem(); }
HUYA.SenderItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SenderItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SenderItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lSenderUid);
    os.writeInt64(1, this.lYYid);
    os.writeInt32(2, this.iSenderRole);
    os.writeInt32(3, this.iSenderGender);
    os.writeString(4, this.sSenderNick);
};

HUYA.SenderItem.prototype.readFrom = function (is)
{
    this.lSenderUid= is.readInt64(0, false, this.lSenderUid);
    this.lYYid= is.readInt64(1, false, this.lYYid);
    this.iSenderRole= is.readInt32(2, false, this.iSenderRole);
    this.iSenderGender= is.readInt32(3, false, this.iSenderGender);
    this.sSenderNick= is.readString(4, false, this.sSenderNick);
};
HUYA.FansItem = function()
{
    this.iFansLevel = 0;
    this.sFansNick = "";
    this.sFansPresenterNick = "";
};
HUYA.FansItem.prototype._clone = function () { return new HUYA.FansItem(); }
HUYA.FansItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.FansItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.FansItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iFansLevel);
    os.writeString(1, this.sFansNick);
    os.writeString(2, this.sFansPresenterNick);
};

HUYA.FansItem.prototype.readFrom = function (is)
{
    this.iFansLevel= is.readInt32(0, false, this.iFansLevel);
    this.sFansNick= is.readString(1, false, this.sFansNick);
    this.sFansPresenterNick= is.readString(2, false, this.sFansPresenterNick);
};
HUYA.VipSmileItem = function()
{
    this.sVipSmileKey = "";
    this.sVipSmilePath = "";
};
HUYA.VipSmileItem.prototype._clone = function () { return new HUYA.VipSmileItem(); }
HUYA.VipSmileItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VipSmileItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VipSmileItem.prototype.writeTo = function (os)
{
    os.writeString(0, this.sVipSmileKey);
    os.writeString(1, this.sVipSmilePath);
};

HUYA.VipSmileItem.prototype.readFrom = function (is)
{
    this.sVipSmileKey= is.readString(0, false, this.sVipSmileKey);
    this.sVipSmilePath= is.readString(1, false, this.sVipSmilePath);
};
HUYA.StampItem = function()
{
    this.sSealIconPath = "";
    this.sKeyImg = "";
    this.lStampTime = 0;
    this.lStampEndTime = 0;
    this.iValidity = 0;
    this.sStampUserNick = "";
};
HUYA.StampItem.prototype._clone = function () { return new HUYA.StampItem(); }
HUYA.StampItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.StampItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.StampItem.prototype.writeTo = function (os)
{
    os.writeString(0, this.sSealIconPath);
    os.writeString(1, this.sKeyImg);
    os.writeInt64(2, this.lStampTime);
    os.writeInt64(3, this.lStampEndTime);
    os.writeInt32(4, this.iValidity);
    os.writeString(5, this.sStampUserNick);
};

HUYA.StampItem.prototype.readFrom = function (is)
{
    this.sSealIconPath= is.readString(0, false, this.sSealIconPath);
    this.sKeyImg= is.readString(1, false, this.sKeyImg);
    this.lStampTime= is.readInt64(2, false, this.lStampTime);
    this.lStampEndTime= is.readInt64(3, false, this.lStampEndTime);
    this.iValidity= is.readInt32(4, false, this.iValidity);
    this.sStampUserNick= is.readString(5, false, this.sStampUserNick);
};
HUYA.MassItem = function()
{
    this.iGoldHostLevel = 0;
    this.iSuperPupleLevel = 0;
    this.iVipLevel = 0;
    this.iUserLevel = 0;
    this.iIsVipRed = 0;
    this.iAtSomebody = 0;
    this.sAtSomebodyNick = "";
    this.ibarrageColor = 0;
    this.sDevSourceType = "";
};
HUYA.MassItem.prototype._clone = function () { return new HUYA.MassItem(); }
HUYA.MassItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MassItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MassItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iGoldHostLevel);
    os.writeInt32(1, this.iSuperPupleLevel);
    os.writeInt32(2, this.iVipLevel);
    os.writeInt32(3, this.iUserLevel);
    os.writeInt32(4, this.iIsVipRed);
    os.writeInt32(5, this.iAtSomebody);
    os.writeString(6, this.sAtSomebodyNick);
    os.writeInt32(7, this.ibarrageColor);
    os.writeString(8, this.sDevSourceType);
};

HUYA.MassItem.prototype.readFrom = function (is)
{
    this.iGoldHostLevel= is.readInt32(0, false, this.iGoldHostLevel);
    this.iSuperPupleLevel= is.readInt32(1, false, this.iSuperPupleLevel);
    this.iVipLevel= is.readInt32(2, false, this.iVipLevel);
    this.iUserLevel= is.readInt32(3, false, this.iUserLevel);
    this.iIsVipRed= is.readInt32(4, false, this.iIsVipRed);
    this.iAtSomebody= is.readInt32(5, false, this.iAtSomebody);
    this.sAtSomebodyNick= is.readString(6, false, this.sAtSomebodyNick);
    this.ibarrageColor= is.readInt32(7, false, this.ibarrageColor);
    this.sDevSourceType= is.readString(8, false, this.sDevSourceType);
};
HUYA.EndLiveNotice = function()
{
    this.lPresenterUid = 0;
    this.iReason = 0;
    this.lLiveId = 0;
    this.sReason = "";
};
HUYA.EndLiveNotice.prototype._clone = function () { return new HUYA.EndLiveNotice(); }
HUYA.EndLiveNotice.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.EndLiveNotice.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.EndLiveNotice.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPresenterUid);
    os.writeInt32(1, this.iReason);
    os.writeInt64(2, this.lLiveId);
    os.writeString(3, this.sReason);
};

HUYA.EndLiveNotice.prototype.readFrom = function (is)
{
    this.lPresenterUid= is.readInt64(0, false, this.lPresenterUid);
    this.iReason= is.readInt32(1, false, this.iReason);
    this.lLiveId= is.readInt64(2, false, this.lLiveId);
    this.sReason= is.readString(3, false, this.sReason);
};
HUYA.NobleBase = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.iLevel = 0;
    this.sName = "";
    this.iPet = 0;
    this.lPid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.lStartTime = 0;
    this.lEndTime = 0;
    this.iLeftDay = 0;
    this.iStatus = 0;
    this.iOpenFlag = 0;
    this.iMonths = 0;
    this.sPNickName = "";
};
HUYA.NobleBase.prototype._clone = function () { return new HUYA.NobleBase(); }
HUYA.NobleBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleBase.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeInt32(2, this.iLevel);
    os.writeString(3, this.sName);
    os.writeInt32(4, this.iPet);
    os.writeInt64(5, this.lPid);
    os.writeInt64(6, this.lTid);
    os.writeInt64(7, this.lSid);
    os.writeInt64(8, this.lStartTime);
    os.writeInt64(9, this.lEndTime);
    os.writeInt32(10, this.iLeftDay);
    os.writeInt32(11, this.iStatus);
    os.writeInt32(12, this.iOpenFlag);
    os.writeInt32(13, this.iMonths);
    os.writeString(14, this.sPNickName);
};

HUYA.NobleBase.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.iLevel= is.readInt32(2, false, this.iLevel);
    this.sName= is.readString(3, false, this.sName);
    this.iPet= is.readInt32(4, false, this.iPet);
    this.lPid= is.readInt64(5, false, this.lPid);
    this.lTid= is.readInt64(6, false, this.lTid);
    this.lSid= is.readInt64(7, false, this.lSid);
    this.lStartTime= is.readInt64(8, false, this.lStartTime);
    this.lEndTime= is.readInt64(9, false, this.lEndTime);
    this.iLeftDay= is.readInt32(10, false, this.iLeftDay);
    this.iStatus= is.readInt32(11, false, this.iStatus);
    this.iOpenFlag= is.readInt32(12, false, this.iOpenFlag);
    this.iMonths= is.readInt32(13, false, this.iMonths);
    this.sPNickName= is.readString(14, false, this.sPNickName);
};
HUYA.GetPropsListReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.sMd5 = "";
    this.iTemplateType = 128;
    this.sVersion = "";
    this.iAppId = 0;
    this.lPresenterUid = 0;
    this.lSid = 0;
    this.lSubSid = 0;
};
HUYA.GetPropsListReq.prototype._clone = function () { return new HUYA.GetPropsListReq(); }
HUYA.GetPropsListReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetPropsListReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetPropsListReq.prototype.writeTo = function (os)
{
    os.writeStruct(1, this.tUserId);
    os.writeString(2, this.sMd5);
    os.writeInt32(3, this.iTemplateType);
    os.writeString(4, this.sVersion);
    os.writeInt32(5, this.iAppId);
    os.writeInt64(6, this.lPresenterUid);
    os.writeInt64(7, this.lSid);
    os.writeInt64(8, this.lSubSid);
};

HUYA.GetPropsListReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(1, false, this.tUserId);
    this.sMd5= is.readString(2, false, this.sMd5);
    this.iTemplateType= is.readInt32(3, false, this.iTemplateType);
    this.sVersion= is.readString(4, false, this.sVersion);
    this.iAppId= is.readInt32(5, false, this.iAppId);
    this.lPresenterUid= is.readInt64(6, false, this.lPresenterUid);
    this.lSid= is.readInt64(7, false, this.lSid);
    this.lSubSid= is.readInt64(8, false, this.lSubSid);
};
HUYA.GetPropsListRsp = function()
{
    this.vPropsItemList = new Taf.Vector(new HUYA.PropsItem());
    this.sMd5 = "";
    this.iNewEffectSwitch = 0;
    this.iMirrorRoomShowNum = 0;
    this.iGameRoomShowNum = 0;
};
HUYA.GetPropsListRsp.prototype._clone = function () { return new HUYA.GetPropsListRsp(); }
HUYA.GetPropsListRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetPropsListRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetPropsListRsp.prototype.writeTo = function (os)
{
    os.writeVector(1, this.vPropsItemList);
    os.writeString(2, this.sMd5);
    os.writeInt16(3, this.iNewEffectSwitch);
    os.writeInt16(4, this.iMirrorRoomShowNum);
    os.writeInt16(5, this.iGameRoomShowNum);
};

HUYA.GetPropsListRsp.prototype.readFrom = function (is)
{
    this.vPropsItemList= is.readVector(1, false, this.vPropsItemList);
    this.sMd5= is.readString(2, false, this.sMd5);
    this.iNewEffectSwitch= is.readInt16(3, false, this.iNewEffectSwitch);
    this.iMirrorRoomShowNum= is.readInt16(4, false, this.iMirrorRoomShowNum);
    this.iGameRoomShowNum= is.readInt16(5, false, this.iGameRoomShowNum);
};
HUYA.PropsItem = function()
{
    this.iPropsId = 0;
    this.sPropsName = "";
    this.iPropsYb = 0;
    this.iPropsGreenBean = 0;
    this.iPropsWhiteBean = 0;
    this.iPropsGoldenBean = 0;
    this.iPropsRed = 0;
    this.iPropsPopular = 0;
    this.iPropsExpendNum = -1;
    this.iPropsFansValue = -1;
    this.vPropsNum = new Taf.Vector(new Taf.INT32());
    this.iPropsMaxNum = 0;
    this.iPropsBatterFlag = 0;
    this.vPropsChannel = new Taf.Vector(new Taf.INT32());
    this.sPropsToolTip = "";
    this.vPropsIdentity = new Taf.Vector(new HUYA.PropsIdentity());
    this.iPropsWeights = 0;
    this.iPropsLevel = 0;
    this.tDisplayInfo = new HUYA.DisplayInfo();
    this.tSpecialInfo = new HUYA.SpecialInfo();
    this.iPropsGrade = 0;
    this.iPropsGroupNum = 0;
    this.sPropsCommBannerResource = "";
    this.sPropsOwnBannerResource = "";
    this.iPropsShowFlag = 0;
    this.iTemplateType = 0;
    this.iShelfStatus = 0;
    this.sAndroidLogo = "";
    this.sIpadLogo = "";
    this.sIphoneLogo = "";
    this.sPropsCommBannerResourceEx = "";
    this.sPropsOwnBannerResourceEx = "";
    this.vPresenterUid = new Taf.Vector(new Taf.INT64());
    this.vPropView = new Taf.Vector(new HUYA.PropView());
    this.iFaceUSwitch = 0;
    this.iDisplayCd = 0;
    this.iCount = 0;
    this.iVbCount = 0;
};
HUYA.PropsItem.prototype._clone = function () { return new HUYA.PropsItem(); }
HUYA.PropsItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PropsItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PropsItem.prototype.writeTo = function (os)
{
    os.writeInt32(1, this.iPropsId);
    os.writeString(2, this.sPropsName);
    os.writeInt32(3, this.iPropsYb);
    os.writeInt32(4, this.iPropsGreenBean);
    os.writeInt32(5, this.iPropsWhiteBean);
    os.writeInt32(6, this.iPropsGoldenBean);
    os.writeInt32(7, this.iPropsRed);
    os.writeInt32(8, this.iPropsPopular);
    os.writeInt32(9, this.iPropsExpendNum);
    os.writeInt32(10, this.iPropsFansValue);
    os.writeVector(11, this.vPropsNum);
    os.writeInt32(12, this.iPropsMaxNum);
    os.writeInt32(13, this.iPropsBatterFlag);
    os.writeVector(14, this.vPropsChannel);
    os.writeString(15, this.sPropsToolTip);
    os.writeVector(16, this.vPropsIdentity);
    os.writeInt32(17, this.iPropsWeights);
    os.writeInt32(18, this.iPropsLevel);
    os.writeStruct(19, this.tDisplayInfo);
    os.writeStruct(20, this.tSpecialInfo);
    os.writeInt32(21, this.iPropsGrade);
    os.writeInt32(22, this.iPropsGroupNum);
    os.writeString(23, this.sPropsCommBannerResource);
    os.writeString(24, this.sPropsOwnBannerResource);
    os.writeInt32(25, this.iPropsShowFlag);
    os.writeInt32(26, this.iTemplateType);
    os.writeInt32(27, this.iShelfStatus);
    os.writeString(28, this.sAndroidLogo);
    os.writeString(29, this.sIpadLogo);
    os.writeString(30, this.sIphoneLogo);
    os.writeString(31, this.sPropsCommBannerResourceEx);
    os.writeString(32, this.sPropsOwnBannerResourceEx);
    os.writeVector(33, this.vPresenterUid);
    os.writeVector(34, this.vPropView);
    os.writeInt16(35, this.iFaceUSwitch);
    os.writeInt16(36, this.iDisplayCd);
    os.writeInt16(37, this.iCount);
    os.writeInt32(38, this.iVbCount);
};

HUYA.PropsItem.prototype.readFrom = function (is)
{
    this.iPropsId= is.readInt32(1, false, this.iPropsId);
    this.sPropsName= is.readString(2, false, this.sPropsName);
    this.iPropsYb= is.readInt32(3, false, this.iPropsYb);
    this.iPropsGreenBean= is.readInt32(4, false, this.iPropsGreenBean);
    this.iPropsWhiteBean= is.readInt32(5, false, this.iPropsWhiteBean);
    this.iPropsGoldenBean= is.readInt32(6, false, this.iPropsGoldenBean);
    this.iPropsRed= is.readInt32(7, false, this.iPropsRed);
    this.iPropsPopular= is.readInt32(8, false, this.iPropsPopular);
    this.iPropsExpendNum= is.readInt32(9, false, this.iPropsExpendNum);
    this.iPropsFansValue= is.readInt32(10, false, this.iPropsFansValue);
    this.vPropsNum= is.readVector(11, false, this.vPropsNum);
    this.iPropsMaxNum= is.readInt32(12, false, this.iPropsMaxNum);
    this.iPropsBatterFlag= is.readInt32(13, false, this.iPropsBatterFlag);
    this.vPropsChannel= is.readVector(14, false, this.vPropsChannel);
    this.sPropsToolTip= is.readString(15, false, this.sPropsToolTip);
    this.vPropsIdentity= is.readVector(16, false, this.vPropsIdentity);
    this.iPropsWeights= is.readInt32(17, false, this.iPropsWeights);
    this.iPropsLevel= is.readInt32(18, false, this.iPropsLevel);
    this.tDisplayInfo= is.readStruct(19, false, this.tDisplayInfo);
    this.tSpecialInfo= is.readStruct(20, false, this.tSpecialInfo);
    this.iPropsGrade= is.readInt32(21, false, this.iPropsGrade);
    this.iPropsGroupNum= is.readInt32(22, false, this.iPropsGroupNum);
    this.sPropsCommBannerResource= is.readString(23, false, this.sPropsCommBannerResource);
    this.sPropsOwnBannerResource= is.readString(24, false, this.sPropsOwnBannerResource);
    this.iPropsShowFlag= is.readInt32(25, false, this.iPropsShowFlag);
    this.iTemplateType= is.readInt32(26, false, this.iTemplateType);
    this.iShelfStatus= is.readInt32(27, false, this.iShelfStatus);
    this.sAndroidLogo= is.readString(28, false, this.sAndroidLogo);
    this.sIpadLogo= is.readString(29, false, this.sIpadLogo);
    this.sIphoneLogo= is.readString(30, false, this.sIphoneLogo);
    this.sPropsCommBannerResourceEx= is.readString(31, false, this.sPropsCommBannerResourceEx);
    this.sPropsOwnBannerResourceEx= is.readString(32, false, this.sPropsOwnBannerResourceEx);
    this.vPresenterUid= is.readVector(33, false, this.vPresenterUid);
    this.vPropView= is.readVector(34, false, this.vPropView);
    this.iFaceUSwitch= is.readInt16(35, false, this.iFaceUSwitch);
    this.iDisplayCd= is.readInt16(36, false, this.iDisplayCd);
    this.iCount= is.readInt16(37, false, this.iCount);
    this.iVbCount= is.readInt32(38, false, this.iVbCount);
};
HUYA.PropsIdentity = function()
{
    this.iPropsIdType = 0;
    this.sPropsPic18 = "";
    this.sPropsPic24 = "";
    this.sPropsPicGif = "";
    this.sPropsBannerResource = "";
    this.sPropsBannerSize = "";
    this.sPropsBannerMaxTime = "";
    this.sPropsChatBannerResource = "";
    this.sPropsChatBannerSize = "";
    this.sPropsChatBannerMaxTime = "";
    this.iPropsChatBannerPos = 0;
    this.iPropsChatBannerIsCombo = 0;
    this.sPropsRollContent = "";
    this.iPropsBannerAnimationstyle = 0;
    this.sPropFaceu = "";
    this.sPropH5Resource = "";
    this.sPropsWeb = "";
    this.sWitch = 0;
    this.sCornerMark = "";
    this.iPropViewId = 0;
    this.sPropStreamerResource = "";
    this.iStreamerFrameRate = 0;
    this.sPropsPic108 = "";
    this.sPcBannerResource = "";
};
HUYA.PropsIdentity.prototype._clone = function () { return new HUYA.PropsIdentity(); }
HUYA.PropsIdentity.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PropsIdentity.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PropsIdentity.prototype.writeTo = function (os)
{
    os.writeInt32(1, this.iPropsIdType);
    os.writeString(2, this.sPropsPic18);
    os.writeString(3, this.sPropsPic24);
    os.writeString(4, this.sPropsPicGif);
    os.writeString(5, this.sPropsBannerResource);
    os.writeString(6, this.sPropsBannerSize);
    os.writeString(7, this.sPropsBannerMaxTime);
    os.writeString(8, this.sPropsChatBannerResource);
    os.writeString(9, this.sPropsChatBannerSize);
    os.writeString(10, this.sPropsChatBannerMaxTime);
    os.writeInt32(11, this.iPropsChatBannerPos);
    os.writeInt32(12, this.iPropsChatBannerIsCombo);
    os.writeString(13, this.sPropsRollContent);
    os.writeInt32(14, this.iPropsBannerAnimationstyle);
    os.writeString(15, this.sPropFaceu);
    os.writeString(16, this.sPropH5Resource);
    os.writeString(17, this.sPropsWeb);
    os.writeInt32(18, this.sWitch);
    os.writeString(19, this.sCornerMark);
    os.writeInt32(20, this.iPropViewId);
    os.writeString(21, this.sPropStreamerResource);
    os.writeInt16(22, this.iStreamerFrameRate);
    os.writeString(23, this.sPropsPic108);
    os.writeString(24, this.sPcBannerResource);
};

HUYA.PropsIdentity.prototype.readFrom = function (is)
{
    this.iPropsIdType= is.readInt32(1, false, this.iPropsIdType);
    this.sPropsPic18= is.readString(2, false, this.sPropsPic18);
    this.sPropsPic24= is.readString(3, false, this.sPropsPic24);
    this.sPropsPicGif= is.readString(4, false, this.sPropsPicGif);
    this.sPropsBannerResource= is.readString(5, false, this.sPropsBannerResource);
    this.sPropsBannerSize= is.readString(6, false, this.sPropsBannerSize);
    this.sPropsBannerMaxTime= is.readString(7, false, this.sPropsBannerMaxTime);
    this.sPropsChatBannerResource= is.readString(8, false, this.sPropsChatBannerResource);
    this.sPropsChatBannerSize= is.readString(9, false, this.sPropsChatBannerSize);
    this.sPropsChatBannerMaxTime= is.readString(10, false, this.sPropsChatBannerMaxTime);
    this.iPropsChatBannerPos= is.readInt32(11, false, this.iPropsChatBannerPos);
    this.iPropsChatBannerIsCombo= is.readInt32(12, false, this.iPropsChatBannerIsCombo);
    this.sPropsRollContent= is.readString(13, false, this.sPropsRollContent);
    this.iPropsBannerAnimationstyle= is.readInt32(14, false, this.iPropsBannerAnimationstyle);
    this.sPropFaceu= is.readString(15, false, this.sPropFaceu);
    this.sPropH5Resource= is.readString(16, false, this.sPropH5Resource);
    this.sPropsWeb= is.readString(17, false, this.sPropsWeb);
    this.sWitch= is.readInt32(18, false, this.sWitch);
    this.sCornerMark= is.readString(19, false, this.sCornerMark);
    this.iPropViewId= is.readInt32(20, false, this.iPropViewId);
    this.sPropStreamerResource= is.readString(21, false, this.sPropStreamerResource);
    this.iStreamerFrameRate= is.readInt16(22, false, this.iStreamerFrameRate);
    this.sPropsPic108= is.readString(23, false, this.sPropsPic108);
    this.sPcBannerResource= is.readString(24, false, this.sPcBannerResource);
};
HUYA.PropView = function()
{
    this.id = 0;
    this.name = "";
    this.uids = new Taf.Map(new Taf.INT64(), new Taf.INT16());
    this.tips = "";
};
HUYA.PropView.prototype._clone = function () { return new HUYA.PropView(); }
HUYA.PropView.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PropView.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PropView.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.id);
    os.writeString(1, this.name);
    os.writeMap(2, this.uids);
    os.writeString(3, this.tips);
};

HUYA.PropView.prototype.readFrom = function (is)
{
    this.id= is.readInt32(0, false, this.id);
    this.name= is.readString(1, false, this.name);
    this.uids= is.readMap(2, false, this.uids);
    this.tips= is.readString(3, false, this.tips);
};
HUYA.DisplayInfo = function()
{
    this.iMarqueeScopeMin = 0;
    this.iMarqueeScopeMax = 0;
    this.iCurrentVideoNum = 0;
    this.iCurrentVideoMin = 0;
    this.iCurrentVideoMax = 0;
    this.iAllVideoNum = 0;
    this.iAllVideoMin = 0;
    this.iAllVideoMax = 0;
    this.iCurrentScreenNum = 0;
    this.iCurrentScreenMin = 0;
    this.iCurrentScreenMax = 0;
};
HUYA.DisplayInfo.prototype._clone = function () { return new HUYA.DisplayInfo(); }
HUYA.DisplayInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DisplayInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DisplayInfo.prototype.writeTo = function (os)
{
    os.writeInt32(1, this.iMarqueeScopeMin);
    os.writeInt32(2, this.iMarqueeScopeMax);
    os.writeInt32(3, this.iCurrentVideoNum);
    os.writeInt32(4, this.iCurrentVideoMin);
    os.writeInt32(5, this.iCurrentVideoMax);
    os.writeInt32(6, this.iAllVideoNum);
    os.writeInt32(7, this.iAllVideoMin);
    os.writeInt32(8, this.iAllVideoMax);
    os.writeInt32(9, this.iCurrentScreenNum);
    os.writeInt32(10, this.iCurrentScreenMin);
    os.writeInt32(11, this.iCurrentScreenMax);
};

HUYA.DisplayInfo.prototype.readFrom = function (is)
{
    this.iMarqueeScopeMin= is.readInt32(1, false, this.iMarqueeScopeMin);
    this.iMarqueeScopeMax= is.readInt32(2, false, this.iMarqueeScopeMax);
    this.iCurrentVideoNum= is.readInt32(3, false, this.iCurrentVideoNum);
    this.iCurrentVideoMin= is.readInt32(4, false, this.iCurrentVideoMin);
    this.iCurrentVideoMax= is.readInt32(5, false, this.iCurrentVideoMax);
    this.iAllVideoNum= is.readInt32(6, false, this.iAllVideoNum);
    this.iAllVideoMin= is.readInt32(7, false, this.iAllVideoMin);
    this.iAllVideoMax= is.readInt32(8, false, this.iAllVideoMax);
    this.iCurrentScreenNum= is.readInt32(9, false, this.iCurrentScreenNum);
    this.iCurrentScreenMin= is.readInt32(10, false, this.iCurrentScreenMin);
    this.iCurrentScreenMax= is.readInt32(11, false, this.iCurrentScreenMax);
};
HUYA.SpecialInfo = function()
{
    this.iFirstSingle = 0;
    this.iFirstGroup = 0;
    this.sFirstTips = "";
    this.iSecondSingle = 0;
    this.iSecondGroup = 0;
    this.sSecondTips = "";
    this.iThirdSingle = 0;
    this.iThirdGroup = 0;
    this.sThirdTips = "";
    this.iWorldSingle = 0;
    this.iWorldGroup = 0;
};
HUYA.SpecialInfo.prototype._clone = function () { return new HUYA.SpecialInfo(); }
HUYA.SpecialInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SpecialInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SpecialInfo.prototype.writeTo = function (os)
{
    os.writeInt32(1, this.iFirstSingle);
    os.writeInt32(2, this.iFirstGroup);
    os.writeString(3, this.sFirstTips);
    os.writeInt32(4, this.iSecondSingle);
    os.writeInt32(5, this.iSecondGroup);
    os.writeString(6, this.sSecondTips);
    os.writeInt32(7, this.iThirdSingle);
    os.writeInt32(8, this.iThirdGroup);
    os.writeString(9, this.sThirdTips);
    os.writeInt32(10, this.iWorldSingle);
    os.writeInt32(11, this.iWorldGroup);
};

HUYA.SpecialInfo.prototype.readFrom = function (is)
{
    this.iFirstSingle= is.readInt32(1, false, this.iFirstSingle);
    this.iFirstGroup= is.readInt32(2, false, this.iFirstGroup);
    this.sFirstTips= is.readString(3, false, this.sFirstTips);
    this.iSecondSingle= is.readInt32(4, false, this.iSecondSingle);
    this.iSecondGroup= is.readInt32(5, false, this.iSecondGroup);
    this.sSecondTips= is.readString(6, false, this.sSecondTips);
    this.iThirdSingle= is.readInt32(7, false, this.iThirdSingle);
    this.iThirdGroup= is.readInt32(8, false, this.iThirdGroup);
    this.sThirdTips= is.readString(9, false, this.sThirdTips);
    this.iWorldSingle= is.readInt32(10, false, this.iWorldSingle);
    this.iWorldGroup= is.readInt32(11, false, this.iWorldGroup);
};
HUYA.GetWebdbUserInfoReq = function()
{
    this.lUid = 0;
    this.lImid = 0;
    this.sPassport = "";
    this.sAccount = "";
    this.bCacheFirst = true;
};
HUYA.GetWebdbUserInfoReq.prototype._clone = function () { return new HUYA.GetWebdbUserInfoReq(); }
HUYA.GetWebdbUserInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetWebdbUserInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetWebdbUserInfoReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lImid);
    os.writeString(2, this.sPassport);
    os.writeString(3, this.sAccount);
    os.writeBoolean(4, this.bCacheFirst);
};

HUYA.GetWebdbUserInfoReq.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lImid= is.readInt64(1, false, this.lImid);
    this.sPassport= is.readString(2, false, this.sPassport);
    this.sAccount= is.readString(3, false, this.sAccount);
    this.bCacheFirst= is.readBoolean(4, false, this.bCacheFirst);
};
HUYA.GetWebdbUserInfoRsp = function()
{
    this.tUserInfo = new HUYA.DBUserInfo();
};
HUYA.GetWebdbUserInfoRsp.prototype._clone = function () { return new HUYA.GetWebdbUserInfoRsp(); }
HUYA.GetWebdbUserInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetWebdbUserInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetWebdbUserInfoRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserInfo);
};

HUYA.GetWebdbUserInfoRsp.prototype.readFrom = function (is)
{
    this.tUserInfo= is.readStruct(0, false, this.tUserInfo);
};
HUYA.DBUserInfo = function()
{
    this.lUid = 0;
    this.sPassport = "";
    this.sAccount = "";
    this.sNick = "";
    this.iSex = 0;
    this.iBirthday = 0;
    this.sArea = "";
    this.sProvince = "";
    this.sCity = "";
    this.sSign = "";
    this.sIntro = "";
    this.iJifen = 0;
    this.sRegisterTime = "";
    this.sHdlogo = "";
    this.sSessionCard = "";
    this.lImid = 0;
    this.iLogoIndex = 0;
};
HUYA.DBUserInfo.prototype._clone = function () { return new HUYA.DBUserInfo(); }
HUYA.DBUserInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.DBUserInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.DBUserInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sPassport);
    os.writeString(2, this.sAccount);
    os.writeString(3, this.sNick);
    os.writeInt32(4, this.iSex);
    os.writeInt32(5, this.iBirthday);
    os.writeString(6, this.sArea);
    os.writeString(7, this.sProvince);
    os.writeString(8, this.sCity);
    os.writeString(9, this.sSign);
    os.writeString(10, this.sIntro);
    os.writeInt32(11, this.iJifen);
    os.writeString(12, this.sRegisterTime);
    os.writeString(13, this.sHdlogo);
    os.writeString(14, this.sSessionCard);
    os.writeInt64(16, this.lImid);
    os.writeInt32(17, this.iLogoIndex);
};

HUYA.DBUserInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sPassport= is.readString(1, false, this.sPassport);
    this.sAccount= is.readString(2, false, this.sAccount);
    this.sNick= is.readString(3, false, this.sNick);
    this.iSex= is.readInt32(4, false, this.iSex);
    this.iBirthday= is.readInt32(5, false, this.iBirthday);
    this.sArea= is.readString(6, false, this.sArea);
    this.sProvince= is.readString(7, false, this.sProvince);
    this.sCity= is.readString(8, false, this.sCity);
    this.sSign= is.readString(9, false, this.sSign);
    this.sIntro= is.readString(10, false, this.sIntro);
    this.iJifen= is.readInt32(11, false, this.iJifen);
    this.sRegisterTime= is.readString(12, false, this.sRegisterTime);
    this.sHdlogo= is.readString(13, false, this.sHdlogo);
    this.sSessionCard= is.readString(14, false, this.sSessionCard);
    this.lImid= is.readInt64(16, false, this.lImid);
    this.iLogoIndex= is.readInt32(17, false, this.iLogoIndex);
};
HUYA.PresenterChannelInfo = function()
{
    this.lYYId = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iSourceType = 0;
    this.iScreenType = 0;
    this.lUid = 0;
    this.iGameId = 0;
};
HUYA.PresenterChannelInfo.prototype._clone = function () { return new HUYA.PresenterChannelInfo(); }
HUYA.PresenterChannelInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterChannelInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterChannelInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lYYId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(3, this.lSid);
    os.writeInt32(4, this.iSourceType);
    os.writeInt32(5, this.iScreenType);
    os.writeInt64(6, this.lUid);
    os.writeInt32(7, this.iGameId);
};

HUYA.PresenterChannelInfo.prototype.readFrom = function (is)
{
    this.lYYId= is.readInt64(0, false, this.lYYId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(3, false, this.lSid);
    this.iSourceType= is.readInt32(4, false, this.iSourceType);
    this.iScreenType= is.readInt32(5, false, this.iScreenType);
    this.lUid= is.readInt64(6, false, this.lUid);
    this.iGameId= is.readInt32(7, false, this.iGameId);
};
HUYA.UserChannelReq = function()
{
    this.tId = new HUYA.UserId();
    this.lTopcid = 0;
    this.lSubcid = 0;
    this.sSendContent = "";
};
HUYA.UserChannelReq.prototype._clone = function () { return new HUYA.UserChannelReq(); }
HUYA.UserChannelReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserChannelReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserChannelReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lTopcid);
    os.writeInt64(2, this.lSubcid);
    os.writeString(3, this.sSendContent);
};

HUYA.UserChannelReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lTopcid= is.readInt64(1, false, this.lTopcid);
    this.lSubcid= is.readInt64(2, false, this.lSubcid);
    this.sSendContent= is.readString(3, false, this.sSendContent);
};
HUYA.InterveneCountRsp = function()
{
    this.lTimeStamp = 0;
    this.iExpire = 0;
    this.lChannelId = 0;
    this.vCountInfos = new Taf.Vector(new HUYA.InterveneCountInfo());
};
HUYA.InterveneCountRsp.prototype._clone = function () { return new HUYA.InterveneCountRsp(); }
HUYA.InterveneCountRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.InterveneCountRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.InterveneCountRsp.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTimeStamp);
    os.writeInt32(1, this.iExpire);
    os.writeInt64(2, this.lChannelId);
    os.writeVector(3, this.vCountInfos);
};

HUYA.InterveneCountRsp.prototype.readFrom = function (is)
{
    this.lTimeStamp= is.readInt64(0, false, this.lTimeStamp);
    this.iExpire= is.readInt32(1, false, this.iExpire);
    this.lChannelId= is.readInt64(2, false, this.lChannelId);
    this.vCountInfos= is.readVector(3, false, this.vCountInfos);
};
HUYA.InterveneCountInfo = function()
{
    this.lSubChannelId = 0;
    this.lAttendeeCount = 0;
};
HUYA.InterveneCountInfo.prototype._clone = function () { return new HUYA.InterveneCountInfo(); }
HUYA.InterveneCountInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.InterveneCountInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.InterveneCountInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lSubChannelId);
    os.writeInt64(1, this.lAttendeeCount);
};

HUYA.InterveneCountInfo.prototype.readFrom = function (is)
{
    this.lSubChannelId= is.readInt64(0, false, this.lSubChannelId);
    this.lAttendeeCount= is.readInt64(1, false, this.lAttendeeCount);
};
HUYA.AttendeeCountNotice = function()
{
    this.iAttendeeCount = 0;
};
HUYA.AttendeeCountNotice.prototype._clone = function () { return new HUYA.AttendeeCountNotice(); }
HUYA.AttendeeCountNotice.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.AttendeeCountNotice.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.AttendeeCountNotice.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iAttendeeCount);
};

HUYA.AttendeeCountNotice.prototype.readFrom = function (is)
{
    this.iAttendeeCount= is.readInt32(0, false, this.iAttendeeCount);
};
HUYA.ExternalUser = function()
{
    this.sId = "";
    this.sToken = "";
    this.sOther = "";
};
HUYA.ExternalUser.prototype._clone = function () { return new HUYA.ExternalUser(); }
HUYA.ExternalUser.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ExternalUser.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ExternalUser.prototype.writeTo = function (os)
{
    os.writeString(0, this.sId);
    os.writeString(1, this.sToken);
    os.writeString(2, this.sOther);
};

HUYA.ExternalUser.prototype.readFrom = function (is)
{
    this.sId= is.readString(0, false, this.sId);
    this.sToken= is.readString(1, false, this.sToken);
    this.sOther= is.readString(2, false, this.sOther);
};
HUYA.QueryPackageReq = function()
{
    this.tId = new HUYA.UserId();
    this.lTopSid = 0;
    this.lSubSid = 0;
};
HUYA.QueryPackageReq.prototype._clone = function () { return new HUYA.QueryPackageReq(); }
HUYA.QueryPackageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.QueryPackageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.QueryPackageReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lTopSid);
    os.writeInt64(2, this.lSubSid);
};

HUYA.QueryPackageReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lTopSid= is.readInt64(1, false, this.lTopSid);
    this.lSubSid= is.readInt64(2, false, this.lSubSid);
};
HUYA.QueryPackageRsp = function()
{
    this.iCode = 0;
    this.iItemWhiteBeanCount = 0;
    this.iItemGreenBeanCount = 0;
    this.lItemWhiteBeanCount = 0;
    this.lItemGreenBeanCount = 0;
};
HUYA.QueryPackageRsp.prototype._clone = function () { return new HUYA.QueryPackageRsp(); }
HUYA.QueryPackageRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.QueryPackageRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.QueryPackageRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCode);
    os.writeInt32(1, this.iItemWhiteBeanCount);
    os.writeInt32(2, this.iItemGreenBeanCount);
    os.writeInt64(3, this.lItemWhiteBeanCount);
    os.writeInt64(4, this.lItemGreenBeanCount);
};

HUYA.QueryPackageRsp.prototype.readFrom = function (is)
{
    this.iCode= is.readInt32(0, false, this.iCode);
    this.iItemWhiteBeanCount= is.readInt32(1, false, this.iItemWhiteBeanCount);
    this.iItemGreenBeanCount= is.readInt32(2, false, this.iItemGreenBeanCount);
    this.lItemWhiteBeanCount= is.readInt64(3, false, this.lItemWhiteBeanCount);
    this.lItemGreenBeanCount= is.readInt64(4, false, this.lItemGreenBeanCount);
};
HUYA.BadgeNameRsp = function()
{
    this.lBadgeId = 0;
    this.sBadgeName = "";
};
HUYA.BadgeNameRsp.prototype._clone = function () { return new HUYA.BadgeNameRsp(); }
HUYA.BadgeNameRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BadgeNameRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BadgeNameRsp.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lBadgeId);
    os.writeString(1, this.sBadgeName);
};

HUYA.BadgeNameRsp.prototype.readFrom = function (is)
{
    this.lBadgeId= is.readInt64(0, false, this.lBadgeId);
    this.sBadgeName= is.readString(1, false, this.sBadgeName);
};
HUYA.GameBaseInfo = function()
{
    this.iId = 0;
    this.sFullName = "";
    this.sShortName = "";
    this.sIcon = "";
    this.iCategory = 0;
    this.sCategoryName = "";
    this.iExeId = 0;
};
HUYA.GameBaseInfo.prototype._clone = function () { return new HUYA.GameBaseInfo(); }
HUYA.GameBaseInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameBaseInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameBaseInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iId);
    os.writeString(1, this.sFullName);
    os.writeString(2, this.sShortName);
    os.writeString(3, this.sIcon);
    os.writeInt32(4, this.iCategory);
    os.writeString(5, this.sCategoryName);
    os.writeInt32(6, this.iExeId);
};

HUYA.GameBaseInfo.prototype.readFrom = function (is)
{
    this.iId= is.readInt32(0, false, this.iId);
    this.sFullName= is.readString(1, false, this.sFullName);
    this.sShortName= is.readString(2, false, this.sShortName);
    this.sIcon= is.readString(3, false, this.sIcon);
    this.iCategory= is.readInt32(4, false, this.iCategory);
    this.sCategoryName= is.readString(5, false, this.sCategoryName);
    this.iExeId= is.readInt32(6, false, this.iExeId);
};
HUYA.AwardUser = function()
{
    this.sUserNick = "";
    this.iPrizeType = 0;
    this.sPrizeName = "";
};
HUYA.AwardUser.prototype._clone = function () { return new HUYA.AwardUser(); }
HUYA.AwardUser.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.AwardUser.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.AwardUser.prototype.writeTo = function (os)
{
    os.writeString(0, this.sUserNick);
    os.writeInt16(1, this.iPrizeType);
    os.writeString(2, this.sPrizeName);
};

HUYA.AwardUser.prototype.readFrom = function (is)
{
    this.sUserNick= is.readString(0, false, this.sUserNick);
    this.iPrizeType= is.readInt16(1, false, this.iPrizeType);
    this.sPrizeName= is.readString(2, false, this.sPrizeName);
};
HUYA.SubscribeInfoNotify = function()
{
    this.tTo = new HUYA.Activity();
    this.iToCount = 0;
};
HUYA.SubscribeInfoNotify.prototype._clone = function () { return new HUYA.SubscribeInfoNotify(); }
HUYA.SubscribeInfoNotify.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SubscribeInfoNotify.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SubscribeInfoNotify.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tTo);
    os.writeInt32(1, this.iToCount);
};

HUYA.SubscribeInfoNotify.prototype.readFrom = function (is)
{
    this.tTo= is.readStruct(0, false, this.tTo);
    this.iToCount= is.readInt32(1, false, this.iToCount);
};
HUYA.Activity = function()
{
    this.iType = 0;
    this.sKey = "";
};
HUYA.Activity.prototype._clone = function () { return new HUYA.Activity(); }
HUYA.Activity.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.Activity.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.Activity.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeString(1, this.sKey);
};

HUYA.Activity.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.sKey= is.readString(1, false, this.sKey);
};
HUYA.BannerNotice = function()
{
    this.lBannerId = 0;
    this.mParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.tChInfo = new HUYA.PresenterChannelInfo();
};
HUYA.BannerNotice.prototype._clone = function () { return new HUYA.BannerNotice(); }
HUYA.BannerNotice.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BannerNotice.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BannerNotice.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lBannerId);
    os.writeMap(1, this.mParam);
    os.writeStruct(2, this.tChInfo);
};

HUYA.BannerNotice.prototype.readFrom = function (is)
{
    this.lBannerId= is.readInt64(0, false, this.lBannerId);
    this.mParam= is.readMap(1, false, this.mParam);
    this.tChInfo= is.readStruct(2, false, this.tChInfo);
};
HUYA.UserProfile = function()
{
    this.tUserBase = new HUYA.UserBase();
    this.tPresenterBase = new HUYA.PresenterBase();
    this.tRecentLive = new HUYA.GameLiveInfo();
};
HUYA.UserProfile.prototype._clone = function () { return new HUYA.UserProfile(); }
HUYA.UserProfile.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserProfile.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserProfile.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserBase);
    os.writeStruct(1, this.tPresenterBase);
    os.writeStruct(2, this.tRecentLive);
};

HUYA.UserProfile.prototype.readFrom = function (is)
{
    this.tUserBase= is.readStruct(0, false, this.tUserBase);
    this.tPresenterBase= is.readStruct(1, false, this.tPresenterBase);
    this.tRecentLive= is.readStruct(2, false, this.tRecentLive);
};
HUYA.UserBase = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.sAvatarUrl = "";
    this.iGender = 0;
    this.lYYId = 0;
    this.iCertified = 0;
    this.iSubscribedCount = 0;
    this.iSubscribeToCount = 0;
    this.iUserLevel = 0;
    this.lUserExp = 0;
    this.iBirthday = 0;
    this.sSign = "";
    this.sArea = "";
    this.sLocation = "";
    this.sRegisterTime = "";
    this.iFreezeTime = 0;
    this.iBindPhone = 0;
};
HUYA.UserBase.prototype._clone = function () { return new HUYA.UserBase(); }
HUYA.UserBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserBase.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sAvatarUrl);
    os.writeInt32(3, this.iGender);
    os.writeInt64(4, this.lYYId);
    os.writeInt32(5, this.iCertified);
    os.writeInt32(6, this.iSubscribedCount);
    os.writeInt32(7, this.iSubscribeToCount);
    os.writeInt32(8, this.iUserLevel);
    os.writeInt64(9, this.lUserExp);
    os.writeInt32(10, this.iBirthday);
    os.writeString(11, this.sSign);
    os.writeString(12, this.sArea);
    os.writeString(13, this.sLocation);
    os.writeString(14, this.sRegisterTime);
    os.writeInt32(15, this.iFreezeTime);
    os.writeInt32(16, this.iBindPhone);
};

HUYA.UserBase.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sAvatarUrl= is.readString(2, false, this.sAvatarUrl);
    this.iGender= is.readInt32(3, false, this.iGender);
    this.lYYId= is.readInt64(4, false, this.lYYId);
    this.iCertified= is.readInt32(5, false, this.iCertified);
    this.iSubscribedCount= is.readInt32(6, false, this.iSubscribedCount);
    this.iSubscribeToCount= is.readInt32(7, false, this.iSubscribeToCount);
    this.iUserLevel= is.readInt32(8, false, this.iUserLevel);
    this.lUserExp= is.readInt64(9, false, this.lUserExp);
    this.iBirthday= is.readInt32(10, false, this.iBirthday);
    this.sSign= is.readString(11, false, this.sSign);
    this.sArea= is.readString(12, false, this.sArea);
    this.sLocation= is.readString(13, false, this.sLocation);
    this.sRegisterTime= is.readString(14, false, this.sRegisterTime);
    this.iFreezeTime= is.readInt32(15, false, this.iFreezeTime);
    this.iBindPhone= is.readInt32(16, false, this.iBindPhone);
};
HUYA.PresenterBase = function()
{
    this.iIsPresenter = 0;
    this.sPresenterName = "";
    this.lSignedChannel = 0;
    this.sPrivateHost = "";
    this.iRecType = 0;
    this.iFreeze = 0;
    this.iPresenterLevel = 0;
    this.lPresenterExp = 0;
    this.vPresentedGames = new Taf.Vector(new HUYA.GameBaseInfo());
    this.iCertified = 0;
};
HUYA.PresenterBase.prototype._clone = function () { return new HUYA.PresenterBase(); }
HUYA.PresenterBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterBase.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iIsPresenter);
    os.writeString(1, this.sPresenterName);
    os.writeInt64(2, this.lSignedChannel);
    os.writeString(3, this.sPrivateHost);
    os.writeInt32(4, this.iRecType);
    os.writeInt32(5, this.iFreeze);
    os.writeInt32(6, this.iPresenterLevel);
    os.writeInt64(7, this.lPresenterExp);
    os.writeVector(8, this.vPresentedGames);
    os.writeInt32(9, this.iCertified);
};

HUYA.PresenterBase.prototype.readFrom = function (is)
{
    this.iIsPresenter= is.readInt32(0, false, this.iIsPresenter);
    this.sPresenterName= is.readString(1, false, this.sPresenterName);
    this.lSignedChannel= is.readInt64(2, false, this.lSignedChannel);
    this.sPrivateHost= is.readString(3, false, this.sPrivateHost);
    this.iRecType= is.readInt32(4, false, this.iRecType);
    this.iFreeze= is.readInt32(5, false, this.iFreeze);
    this.iPresenterLevel= is.readInt32(6, false, this.iPresenterLevel);
    this.lPresenterExp= is.readInt64(7, false, this.lPresenterExp);
    this.vPresentedGames= is.readVector(8, false, this.vPresentedGames);
    this.iCertified= is.readInt32(9, false, this.iCertified);
};
HUYA.GameLiveInfo = function()
{
    this.lLiveId = 0;
    this.lUid = 0;
    this.lChannelId = 0;
    this.iShortChannel = 0;
    this.lSubchannel = 0;
    this.sSubchannelName = "";
    this.iGameId = 0;
    this.sGameName = "";
    this.iAttendeeCount = 0;
    this.eGender = HUYA.EGender.MALE;
    this.iAid = 0;
    this.sNick = "";
    this.sAvatarUrl = "";
    this.iStartTime = 0;
    this.iEndTime = 0;
    this.iSourceType = 0;
    this.bIsCameraOpen = false;
    this.bIsRoomSecret = false;
    this.sVideoCaptureUrl = "";
    this.iCdnAttendee = 0;
    this.lYYId = 0;
    this.bCertified = false;
    this.iRecType = 0;
    this.lSignChannel = 0;
    this.sLiveDesc = "";
    this.iLevel = 0;
    this.sGameShortName = "";
    this.iGameType = 0;
    this.sPrivateHost = "";
    this.iActivityCount = 0;
    this.iStreamType = 0;
    this.iBitRate = 0;
    this.iResolution = 0;
    this.iFrameRate = 0;
    this.iIsMultiStream = 0;
    this.iExeGameId = 0;
    this.lExp = 0;
    this.sReplayHls = "";
    this.lMultiStreamFlag = 0;
    this.iScreenType = 0;
    this.iChannelType = 0;
    this.sLocation = "";
    this.iCodecType = 0;
    this.vPresenterTags = new Taf.Vector(new HUYA.GameLiveTag());
    this.vGameTags = new Taf.Vector(new HUYA.GameLiveTag());
    this.lLiveCompatibleFlag = 0;
    this.sTraceId = "";
};
HUYA.GameLiveInfo.prototype._clone = function () { return new HUYA.GameLiveInfo(); }
HUYA.GameLiveInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lLiveId);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lChannelId);
    os.writeInt32(3, this.iShortChannel);
    os.writeInt64(4, this.lSubchannel);
    os.writeString(5, this.sSubchannelName);
    os.writeInt32(6, this.iGameId);
    os.writeString(7, this.sGameName);
    os.writeInt32(8, this.iAttendeeCount);
    os.writeInt32(9, this.eGender);
    os.writeInt32(10, this.iAid);
    os.writeString(11, this.sNick);
    os.writeString(12, this.sAvatarUrl);
    os.writeInt32(13, this.iStartTime);
    os.writeInt32(14, this.iEndTime);
    os.writeInt32(15, this.iSourceType);
    os.writeBoolean(16, this.bIsCameraOpen);
    os.writeBoolean(17, this.bIsRoomSecret);
    os.writeString(18, this.sVideoCaptureUrl);
    os.writeInt32(19, this.iCdnAttendee);
    os.writeInt64(20, this.lYYId);
    os.writeBoolean(21, this.bCertified);
    os.writeInt32(22, this.iRecType);
    os.writeInt64(23, this.lSignChannel);
    os.writeString(24, this.sLiveDesc);
    os.writeInt32(25, this.iLevel);
    os.writeString(26, this.sGameShortName);
    os.writeInt32(27, this.iGameType);
    os.writeString(28, this.sPrivateHost);
    os.writeInt32(29, this.iActivityCount);
    os.writeInt32(30, this.iStreamType);
    os.writeInt32(31, this.iBitRate);
    os.writeInt32(32, this.iResolution);
    os.writeInt32(33, this.iFrameRate);
    os.writeInt32(34, this.iIsMultiStream);
    os.writeInt32(35, this.iExeGameId);
    os.writeInt64(36, this.lExp);
    os.writeString(37, this.sReplayHls);
    os.writeInt64(38, this.lMultiStreamFlag);
    os.writeInt32(39, this.iScreenType);
    os.writeInt32(40, this.iChannelType);
    os.writeString(41, this.sLocation);
    os.writeInt32(42, this.iCodecType);
    os.writeVector(43, this.vPresenterTags);
    os.writeVector(44, this.vGameTags);
    os.writeInt64(45, this.lLiveCompatibleFlag);
    os.writeString(46, this.sTraceId);
};

HUYA.GameLiveInfo.prototype.readFrom = function (is)
{
    this.lLiveId= is.readInt64(0, false, this.lLiveId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lChannelId= is.readInt64(2, false, this.lChannelId);
    this.iShortChannel= is.readInt32(3, false, this.iShortChannel);
    this.lSubchannel= is.readInt64(4, false, this.lSubchannel);
    this.sSubchannelName= is.readString(5, false, this.sSubchannelName);
    this.iGameId= is.readInt32(6, false, this.iGameId);
    this.sGameName= is.readString(7, false, this.sGameName);
    this.iAttendeeCount= is.readInt32(8, false, this.iAttendeeCount);
    this.eGender= is.readInt32(9, false, this.eGender);
    this.iAid= is.readInt32(10, false, this.iAid);
    this.sNick= is.readString(11, false, this.sNick);
    this.sAvatarUrl= is.readString(12, false, this.sAvatarUrl);
    this.iStartTime= is.readInt32(13, false, this.iStartTime);
    this.iEndTime= is.readInt32(14, false, this.iEndTime);
    this.iSourceType= is.readInt32(15, false, this.iSourceType);
    this.bIsCameraOpen= is.readBoolean(16, false, this.bIsCameraOpen);
    this.bIsRoomSecret= is.readBoolean(17, false, this.bIsRoomSecret);
    this.sVideoCaptureUrl= is.readString(18, false, this.sVideoCaptureUrl);
    this.iCdnAttendee= is.readInt32(19, false, this.iCdnAttendee);
    this.lYYId= is.readInt64(20, false, this.lYYId);
    this.bCertified= is.readBoolean(21, false, this.bCertified);
    this.iRecType= is.readInt32(22, false, this.iRecType);
    this.lSignChannel= is.readInt64(23, false, this.lSignChannel);
    this.sLiveDesc= is.readString(24, false, this.sLiveDesc);
    this.iLevel= is.readInt32(25, false, this.iLevel);
    this.sGameShortName= is.readString(26, false, this.sGameShortName);
    this.iGameType= is.readInt32(27, false, this.iGameType);
    this.sPrivateHost= is.readString(28, false, this.sPrivateHost);
    this.iActivityCount= is.readInt32(29, false, this.iActivityCount);
    this.iStreamType= is.readInt32(30, false, this.iStreamType);
    this.iBitRate= is.readInt32(31, false, this.iBitRate);
    this.iResolution= is.readInt32(32, false, this.iResolution);
    this.iFrameRate= is.readInt32(33, false, this.iFrameRate);
    this.iIsMultiStream= is.readInt32(34, false, this.iIsMultiStream);
    this.iExeGameId= is.readInt32(35, false, this.iExeGameId);
    this.lExp= is.readInt64(36, false, this.lExp);
    this.sReplayHls= is.readString(37, false, this.sReplayHls);
    this.lMultiStreamFlag= is.readInt64(38, false, this.lMultiStreamFlag);
    this.iScreenType= is.readInt32(39, false, this.iScreenType);
    this.iChannelType= is.readInt32(40, false, this.iChannelType);
    this.sLocation= is.readString(41, false, this.sLocation);
    this.iCodecType= is.readInt32(42, false, this.iCodecType);
    this.vPresenterTags= is.readVector(43, false, this.vPresenterTags);
    this.vGameTags= is.readVector(44, false, this.vGameTags);
    this.lLiveCompatibleFlag= is.readInt64(45, false, this.lLiveCompatibleFlag);
    this.sTraceId= is.readString(46, false, this.sTraceId);
};
HUYA.GameLiveTag = function()
{
    this.iTagId = 0;
    this.sTagName = "";
    this.bIsShow = true;
    this.iBindingGameId = 0;
    this.iShowType = 0;
};
HUYA.GameLiveTag.prototype._clone = function () { return new HUYA.GameLiveTag(); }
HUYA.GameLiveTag.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveTag.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveTag.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iTagId);
    os.writeString(1, this.sTagName);
    os.writeBoolean(2, this.bIsShow);
    os.writeInt32(3, this.iBindingGameId);
    os.writeInt32(4, this.iShowType);
};

HUYA.GameLiveTag.prototype.readFrom = function (is)
{
    this.iTagId= is.readInt32(0, false, this.iTagId);
    this.sTagName= is.readString(1, false, this.sTagName);
    this.bIsShow= is.readBoolean(2, false, this.bIsShow);
    this.iBindingGameId= is.readInt32(3, false, this.iBindingGameId);
    this.iShowType= is.readInt32(4, false, this.iShowType);
};
HUYA.GuardianPresenterInfoNotice = function()
{
    this.lUid = 0;
    this.sNick = "";
    this.iLevel = 0;
    this.lGuardianUid = 0;
    this.sGuardianNick = "";
    this.eNoticeType = 0;
    this.iOpenDays = 0;
    this.iLastLevel = 0;
    this.iNobleLevel = 0;
};
HUYA.GuardianPresenterInfoNotice.prototype._clone = function () { return new HUYA.GuardianPresenterInfoNotice(); }
HUYA.GuardianPresenterInfoNotice.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GuardianPresenterInfoNotice.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GuardianPresenterInfoNotice.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNick);
    os.writeInt32(2, this.iLevel);
    os.writeInt64(3, this.lGuardianUid);
    os.writeString(4, this.sGuardianNick);
    os.writeInt32(5, this.eNoticeType);
    os.writeInt32(6, this.iOpenDays);
    os.writeInt32(7, this.iLastLevel);
    os.writeInt32(8, this.iNobleLevel);
};

HUYA.GuardianPresenterInfoNotice.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNick= is.readString(1, false, this.sNick);
    this.iLevel= is.readInt32(2, false, this.iLevel);
    this.lGuardianUid= is.readInt64(3, false, this.lGuardianUid);
    this.sGuardianNick= is.readString(4, false, this.sGuardianNick);
    this.eNoticeType= is.readInt32(5, false, this.eNoticeType);
    this.iOpenDays= is.readInt32(6, false, this.iOpenDays);
    this.iLastLevel= is.readInt32(7, false, this.iLastLevel);
    this.iNobleLevel= is.readInt32(8, false, this.iNobleLevel);
};
HUYA.SubscribeReq = function()
{
    this.tId = new HUYA.UserId();
    this.tFrom = new HUYA.Subscriber();
    this.tTo = new HUYA.Activity();
    this.iAction = 0;
};
HUYA.SubscribeReq.prototype._clone = function () { return new HUYA.SubscribeReq(); }
HUYA.SubscribeReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SubscribeReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SubscribeReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeStruct(1, this.tFrom);
    os.writeStruct(2, this.tTo);
    os.writeInt32(3, this.iAction);
};

HUYA.SubscribeReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.tFrom= is.readStruct(1, false, this.tFrom);
    this.tTo= is.readStruct(2, false, this.tTo);
    this.iAction= is.readInt32(3, false, this.iAction);
};
HUYA.SubscribeResp = function()
{
    this.tFrom = new HUYA.Subscriber();
    this.tTo = new HUYA.Activity();
    this.iAction = 0;
    this.iFlag = 0;
};
HUYA.SubscribeResp.prototype._clone = function () { return new HUYA.SubscribeResp(); }
HUYA.SubscribeResp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SubscribeResp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SubscribeResp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tFrom);
    os.writeStruct(1, this.tTo);
    os.writeInt32(2, this.iAction);
    os.writeInt32(3, this.iFlag);
};

HUYA.SubscribeResp.prototype.readFrom = function (is)
{
    this.tFrom= is.readStruct(0, false, this.tFrom);
    this.tTo= is.readStruct(1, false, this.tTo);
    this.iAction= is.readInt32(2, false, this.iAction);
    this.iFlag= is.readInt32(3, false, this.iFlag);
};
HUYA.UnsubscribeReq = function()
{
    this.tId = new HUYA.UserId();
    this.tFrom = new HUYA.Subscriber();
    this.tTo = new HUYA.Activity();
};
HUYA.UnsubscribeReq.prototype._clone = function () { return new HUYA.UnsubscribeReq(); }
HUYA.UnsubscribeReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UnsubscribeReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UnsubscribeReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeStruct(1, this.tFrom);
    os.writeStruct(2, this.tTo);
};

HUYA.UnsubscribeReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.tFrom= is.readStruct(1, false, this.tFrom);
    this.tTo= is.readStruct(2, false, this.tTo);
};
HUYA.UnsubscribeResp = function()
{
    this.tFrom = new HUYA.Subscriber();
    this.tTo = new HUYA.Activity();
    this.iFlag = 0;
};
HUYA.UnsubscribeResp.prototype._clone = function () { return new HUYA.UnsubscribeResp(); }
HUYA.UnsubscribeResp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UnsubscribeResp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UnsubscribeResp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tFrom);
    os.writeStruct(1, this.tTo);
    os.writeInt32(3, this.iFlag);
};

HUYA.UnsubscribeResp.prototype.readFrom = function (is)
{
    this.tFrom= is.readStruct(0, false, this.tFrom);
    this.tTo= is.readStruct(1, false, this.tTo);
    this.iFlag= is.readInt32(3, false, this.iFlag);
};
HUYA.SubscribeStatusReq = function()
{
    this.tId = new HUYA.UserId();
    this.tFrom = new HUYA.Subscriber();
    this.tTo = new HUYA.Activity();
};
HUYA.SubscribeStatusReq.prototype._clone = function () { return new HUYA.SubscribeStatusReq(); }
HUYA.SubscribeStatusReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SubscribeStatusReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SubscribeStatusReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeStruct(1, this.tFrom);
    os.writeStruct(2, this.tTo);
};

HUYA.SubscribeStatusReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.tFrom= is.readStruct(1, false, this.tFrom);
    this.tTo= is.readStruct(2, false, this.tTo);
};
HUYA.SubscribeStatusResp = function()
{
    this.tFrom = new HUYA.Subscriber();
    this.tTo = new HUYA.Activity();
    this.iSubscribedCount = 0;
    this.iStatus = 0;
};
HUYA.SubscribeStatusResp.prototype._clone = function () { return new HUYA.SubscribeStatusResp(); }
HUYA.SubscribeStatusResp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SubscribeStatusResp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SubscribeStatusResp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tFrom);
    os.writeStruct(1, this.tTo);
    os.writeInt32(2, this.iSubscribedCount);
    os.writeInt32(3, this.iStatus);
};

HUYA.SubscribeStatusResp.prototype.readFrom = function (is)
{
    this.tFrom= is.readStruct(0, false, this.tFrom);
    this.tTo= is.readStruct(1, false, this.tTo);
    this.iSubscribedCount= is.readInt32(2, false, this.iSubscribedCount);
    this.iStatus= is.readInt32(3, false, this.iStatus);
};
HUYA.Subscriber = function()
{
    this.iType = 0;
    this.sKey = "";
    this.lSubscribeTime = 0;
};
HUYA.Subscriber.prototype._clone = function () { return new HUYA.Subscriber(); }
HUYA.Subscriber.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.Subscriber.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.Subscriber.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeString(1, this.sKey);
    os.writeInt64(2, this.lSubscribeTime);
};

HUYA.Subscriber.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.sKey= is.readString(1, false, this.sKey);
    this.lSubscribeTime= is.readInt64(2, false, this.lSubscribeTime);
};
HUYA.SendItemSubBroadcastPacket = function()
{
    this.iItemType = 0;
    this.strPayId = "";
    this.iItemCount = 0;
    this.lPresenterUid = 0;
    this.lSenderUid = 0;
    this.sPresenterNick = "";
    this.sSenderNick = "";
    this.sSendContent = "";
    this.iItemCountByGroup = 0;
    this.iItemGroup = 0;
    this.iSuperPupleLevel = 0;
    this.iComboScore = 0;
    this.iDisplayInfo = 0;
    this.iEffectType = 0;
    this.iSenderIcon = "";
    this.iPresenterIcon = "";
    this.iTemplateType = 0;
    this.sExpand = "";
    this.bBusi = false;
    this.iColorEffectType = 0;
    this.sPropsName = "";
    this.iAccpet = 0;
};
HUYA.SendItemSubBroadcastPacket.prototype._clone = function () { return new HUYA.SendItemSubBroadcastPacket(); }
HUYA.SendItemSubBroadcastPacket.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendItemSubBroadcastPacket.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendItemSubBroadcastPacket.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iItemType);
    os.writeString(1, this.strPayId);
    os.writeInt32(2, this.iItemCount);
    os.writeInt64(3, this.lPresenterUid);
    os.writeInt64(4, this.lSenderUid);
    os.writeString(5, this.sPresenterNick);
    os.writeString(6, this.sSenderNick);
    os.writeString(7, this.sSendContent);
    os.writeInt32(8, this.iItemCountByGroup);
    os.writeInt32(9, this.iItemGroup);
    os.writeInt32(10, this.iSuperPupleLevel);
    os.writeInt32(11, this.iComboScore);
    os.writeInt32(12, this.iDisplayInfo);
    os.writeInt32(13, this.iEffectType);
    os.writeString(14, this.iSenderIcon);
    os.writeString(15, this.iPresenterIcon);
    os.writeInt32(16, this.iTemplateType);
    os.writeString(17, this.sExpand);
    os.writeBoolean(18, this.bBusi);
    os.writeInt32(19, this.iColorEffectType);
    os.writeString(20, this.sPropsName);
    os.writeInt16(21, this.iAccpet);
};

HUYA.SendItemSubBroadcastPacket.prototype.readFrom = function (is)
{
    this.iItemType= is.readInt32(0, false, this.iItemType);
    this.strPayId= is.readString(1, false, this.strPayId);
    this.iItemCount= is.readInt32(2, false, this.iItemCount);
    this.lPresenterUid= is.readInt64(3, false, this.lPresenterUid);
    this.lSenderUid= is.readInt64(4, false, this.lSenderUid);
    this.sPresenterNick= is.readString(5, false, this.sPresenterNick);
    this.sSenderNick= is.readString(6, false, this.sSenderNick);
    this.sSendContent= is.readString(7, false, this.sSendContent);
    this.iItemCountByGroup= is.readInt32(8, false, this.iItemCountByGroup);
    this.iItemGroup= is.readInt32(9, false, this.iItemGroup);
    this.iSuperPupleLevel= is.readInt32(10, false, this.iSuperPupleLevel);
    this.iComboScore= is.readInt32(11, false, this.iComboScore);
    this.iDisplayInfo= is.readInt32(12, false, this.iDisplayInfo);
    this.iEffectType= is.readInt32(13, false, this.iEffectType);
    this.iSenderIcon= is.readString(14, false, this.iSenderIcon);
    this.iPresenterIcon= is.readString(15, false, this.iPresenterIcon);
    this.iTemplateType= is.readInt32(16, false, this.iTemplateType);
    this.sExpand= is.readString(17, false, this.sExpand);
    this.bBusi= is.readBoolean(18, false, this.bBusi);
    this.iColorEffectType= is.readInt32(19, false, this.iColorEffectType);
    this.sPropsName= is.readString(20, false, this.sPropsName);
    this.iAccpet= is.readInt16(21, false, this.iAccpet);
};
HUYA.SendItemNoticeWordBroadcastPacket = function()
{
    this.iItemType = 0;
    this.iItemCount = 0;
    this.lSenderSid = 0;
    this.lSenderUid = 0;
    this.sSenderNick = "";
    this.lPresenterUid = 0;
    this.sPresenterNick = "";
    this.lNoticeChannelCount = 0;
    this.iItemCountByGroup = 0;
    this.iItemGroup = 0;
    this.iDisplayInfo = 0;
    this.iSuperPupleLevel = 0;
    this.iTemplateType = 0;
    this.sExpand = "";
    this.bBusi = false;
    this.iShowTime = 0;
    this.lPresenterYY = 0;
    this.lSid = 0;
    this.lSubSid = 0;
};
HUYA.SendItemNoticeWordBroadcastPacket.prototype._clone = function () { return new HUYA.SendItemNoticeWordBroadcastPacket(); }
HUYA.SendItemNoticeWordBroadcastPacket.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendItemNoticeWordBroadcastPacket.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendItemNoticeWordBroadcastPacket.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iItemType);
    os.writeInt32(1, this.iItemCount);
    os.writeInt64(2, this.lSenderSid);
    os.writeInt64(3, this.lSenderUid);
    os.writeString(4, this.sSenderNick);
    os.writeInt64(5, this.lPresenterUid);
    os.writeString(6, this.sPresenterNick);
    os.writeInt64(7, this.lNoticeChannelCount);
    os.writeInt32(8, this.iItemCountByGroup);
    os.writeInt32(9, this.iItemGroup);
    os.writeInt32(10, this.iDisplayInfo);
    os.writeInt32(11, this.iSuperPupleLevel);
    os.writeInt32(12, this.iTemplateType);
    os.writeString(13, this.sExpand);
    os.writeBoolean(14, this.bBusi);
    os.writeInt32(15, this.iShowTime);
    os.writeInt64(16, this.lPresenterYY);
    os.writeInt64(17, this.lSid);
    os.writeInt64(18, this.lSubSid);
};

HUYA.SendItemNoticeWordBroadcastPacket.prototype.readFrom = function (is)
{
    this.iItemType= is.readInt32(0, false, this.iItemType);
    this.iItemCount= is.readInt32(1, false, this.iItemCount);
    this.lSenderSid= is.readInt64(2, false, this.lSenderSid);
    this.lSenderUid= is.readInt64(3, false, this.lSenderUid);
    this.sSenderNick= is.readString(4, false, this.sSenderNick);
    this.lPresenterUid= is.readInt64(5, false, this.lPresenterUid);
    this.sPresenterNick= is.readString(6, false, this.sPresenterNick);
    this.lNoticeChannelCount= is.readInt64(7, false, this.lNoticeChannelCount);
    this.iItemCountByGroup= is.readInt32(8, false, this.iItemCountByGroup);
    this.iItemGroup= is.readInt32(9, false, this.iItemGroup);
    this.iDisplayInfo= is.readInt32(10, false, this.iDisplayInfo);
    this.iSuperPupleLevel= is.readInt32(11, false, this.iSuperPupleLevel);
    this.iTemplateType= is.readInt32(12, false, this.iTemplateType);
    this.sExpand= is.readString(13, false, this.sExpand);
    this.bBusi= is.readBoolean(14, false, this.bBusi);
    this.iShowTime= is.readInt32(15, false, this.iShowTime);
    this.lPresenterYY= is.readInt64(16, false, this.lPresenterYY);
    this.lSid= is.readInt64(17, false, this.lSid);
    this.lSubSid= is.readInt64(18, false, this.lSubSid);
};
HUYA.Metric = function()
{
    this.sMetricName = "";
    this.vDimension = new Taf.Vector(new HUYA.Dimension());
    this.iTS = 0;
    this.iSuccess = 0;
    this.iRetCode = 0;
    this.fValue = 0;
    this.eUnit = 0;
    this.tStatsSet = new HUYA.StatsSet();
    this.sExtDesc = "";
};
HUYA.Metric.prototype._clone = function () { return new HUYA.Metric(); }
HUYA.Metric.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.Metric.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.Metric.prototype.writeTo = function (os)
{
    os.writeString(0, this.sMetricName);
    os.writeVector(1, this.vDimension);
    os.writeInt64(2, this.iTS);
    os.writeInt32(3, this.iSuccess);
    os.writeInt32(4, this.iRetCode);
    os.writeDouble(5, this.fValue);
    os.writeInt32(6, this.eUnit);
    os.writeStruct(7, this.tStatsSet);
    os.writeString(8, this.sExtDesc);
};

HUYA.Metric.prototype.readFrom = function (is)
{
    this.sMetricName= is.readString(0, true, this.sMetricName);
    this.vDimension= is.readVector(1, false, this.vDimension);
    this.iTS= is.readInt64(2, false, this.iTS);
    this.iSuccess= is.readInt32(3, false, this.iSuccess);
    this.iRetCode= is.readInt32(4, false, this.iRetCode);
    this.fValue= is.readDouble(5, false, this.fValue);
    this.eUnit= is.readInt32(6, false, this.eUnit);
    this.tStatsSet= is.readStruct(7, false, this.tStatsSet);
    this.sExtDesc= is.readString(8, false, this.sExtDesc);
};
HUYA.Dimension = function()
{
    this.sName = "";
    this.sValue = "";
};
HUYA.Dimension.prototype._clone = function () { return new HUYA.Dimension(); }
HUYA.Dimension.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.Dimension.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.Dimension.prototype.writeTo = function (os)
{
    os.writeString(0, this.sName);
    os.writeString(1, this.sValue);
};

HUYA.Dimension.prototype.readFrom = function (is)
{
    this.sName= is.readString(0, false, this.sName);
    this.sValue= is.readString(1, false, this.sValue);
};
HUYA.EUnit =
{
    EUnit_None : 0,
    EUnit_Seconds : 1,
    EUnit_Microseconds : 2,
    EUnit_Milliseconds : 3,
    EUnit_Bytes : 4,
    EUnit_Kilobytes : 5,
    EUnit_Megabytes : 6,
    EUnit_Gigabytes : 7,
    EUnit_Terabytes : 8,
    EUnit_Bits : 9,
    EUnit_Kilobits : 10,
    EUnit_Megabits : 11,
    EUnit_Gigabits : 12,
    EUnit_Terabits : 13,
    EUnit_Percent : 14,
    EUnit_Count : 15,
    EUnit_BytesPerSecond : 16,
    EUnit_KilobytesPerSecond : 17,
    EUnit_MegabytesPerSecond : 18,
    EUnit_GigabytesPerSecond : 19,
    EUnit_TerabytesPerSecond : 20,
    EUnit_BitsPerSecond : 21,
    EUnit_KilobitsPerSecond : 22,
    EUnit_MegabitsPerSecond : 23,
    EUnit_GigabitsPerSecond : 24,
    EUnit_TerabitsPerSecond : 25,
    EUnit_CountPerSecond : 26
};
HUYA.MetricSet = function()
{
    this.tId = new HUYA.UserId();
    this.vMetric = new Taf.Vector(new HUYA.Metric());
};
HUYA.MetricSet.prototype._clone = function () { return new HUYA.MetricSet(); }
HUYA.MetricSet.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MetricSet.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MetricSet.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeVector(1, this.vMetric);
};

HUYA.MetricSet.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, true, this.tId);
    this.vMetric= is.readVector(1, true, this.vMetric);
};
HUYA.StatsSet = function()
{
    this.fSum = 0;
    this.fMaxValue = 0;
    this.fMinValue = 0;
    this.lSampleCnt = 0;
};
HUYA.StatsSet.prototype._clone = function () { return new HUYA.StatsSet(); }
HUYA.StatsSet.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.StatsSet.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.StatsSet.prototype.writeTo = function (os)
{
    os.writeDouble(0, this.fSum);
    os.writeDouble(1, this.fMaxValue);
    os.writeDouble(2, this.fMinValue);
    os.writeInt64(3, this.lSampleCnt);
};

HUYA.StatsSet.prototype.readFrom = function (is)
{
    this.fSum= is.readDouble(0, false, this.fSum);
    this.fMaxValue= is.readDouble(1, false, this.fMaxValue);
    this.fMinValue= is.readDouble(2, false, this.fMinValue);
    this.lSampleCnt= is.readInt64(3, false, this.lSampleCnt);
};
HUYA.VipEnterBanner = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.lPid = 0;
    this.tNobleInfo = new HUYA.NobleInfo();
    this.tGuardInfo = new HUYA.GuardInfo();
    this.tWeekRankInfo = new HUYA.WeekRankInfo();
    this.sLogoURL = "";
    this.bFromNearby = false;
    this.sLocation = "";
};
HUYA.VipEnterBanner.prototype._clone = function () { return new HUYA.VipEnterBanner(); }
HUYA.VipEnterBanner.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VipEnterBanner.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VipEnterBanner.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeInt64(2, this.lPid);
    os.writeStruct(3, this.tNobleInfo);
    os.writeStruct(4, this.tGuardInfo);
    os.writeStruct(5, this.tWeekRankInfo);
    os.writeString(6, this.sLogoURL);
    os.writeBoolean(7, this.bFromNearby);
    os.writeString(8, this.sLocation);
};

HUYA.VipEnterBanner.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.lPid= is.readInt64(2, false, this.lPid);
    this.tNobleInfo= is.readStruct(3, false, this.tNobleInfo);
    this.tGuardInfo= is.readStruct(4, false, this.tGuardInfo);
    this.tWeekRankInfo= is.readStruct(5, false, this.tWeekRankInfo);
    this.sLogoURL= is.readString(6, false, this.sLogoURL);
    this.bFromNearby= is.readBoolean(7, false, this.bFromNearby);
    this.sLocation= is.readString(8, false, this.sLocation);
};
HUYA.NobleInfo = function()
{
    this.lUid = 0;
    this.lPid = 0;
    this.lValidDate = 0;
    this.sNobleName = "";
    this.iNobleLevel = 0;
    this.iNoblePet = 0;
    this.iNobleStatus = 0;
    this.iNobleType = 0;
    this.iRemainDays = 0;
};
HUYA.NobleInfo.prototype._clone = function () { return new HUYA.NobleInfo(); }
HUYA.NobleInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.NobleInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.NobleInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPid);
    os.writeInt64(2, this.lValidDate);
    os.writeString(3, this.sNobleName);
    os.writeInt32(4, this.iNobleLevel);
    os.writeInt32(5, this.iNoblePet);
    os.writeInt32(6, this.iNobleStatus);
    os.writeInt32(7, this.iNobleType);
    os.writeInt32(8, this.iRemainDays);
};

HUYA.NobleInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.lValidDate= is.readInt64(2, false, this.lValidDate);
    this.sNobleName= is.readString(3, false, this.sNobleName);
    this.iNobleLevel= is.readInt32(4, false, this.iNobleLevel);
    this.iNoblePet= is.readInt32(5, false, this.iNoblePet);
    this.iNobleStatus= is.readInt32(6, false, this.iNobleStatus);
    this.iNobleType= is.readInt32(7, false, this.iNobleType);
    this.iRemainDays= is.readInt32(8, false, this.iRemainDays);
};
HUYA.WeekRankInfo = function()
{
    this.lUid = 0;
    this.iRank = 0;
};
HUYA.WeekRankInfo.prototype._clone = function () { return new HUYA.WeekRankInfo(); }
HUYA.WeekRankInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WeekRankInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WeekRankInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt32(1, this.iRank);
};

HUYA.WeekRankInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.iRank= is.readInt32(1, false, this.iRank);
};
;
/**
 * TAF协议映射，此文件依赖 TafProtocol.js
 */
var TafMx = TafMx || {};
TafMx.UriMapping = {
    "1400": HUYA.MessageNotice,

    "3104": HUYA.SubscribeInfoNotify,

    "6501": HUYA.SendItemSubBroadcastPacket,
    "6502": HUYA.SendItemNoticeWordBroadcastPacket,


    //直播状态和信息
    "8001": HUYA.EndLiveNotice,
    "8006": HUYA.AttendeeCountNotice,
    "6110": HUYA.VipEnterBanner,

    "44000": HUYA.InterveneCountRsp


};
TafMx.WupMapping = {

    //播放器核心及UI
    "OnUserEvent": HUYA.UserEventRsp,
    "doLaunch": HUYA.LiveLaunchRsp,
    "getLivingInfo": HUYA.GetLivingInfoRsp,
    "getWebdbUserInfo": HUYA.GetWebdbUserInfoRsp,
    "getPropsList": HUYA.GetPropsListRsp,
    "sendCardPackageItem": HUYA.SendCardPackageItemRsp,
    "OnUserHeartBeat": HUYA.UserHeartBeatRsp,

    //公频
    "sendMessage": HUYA.SendMessageRsp,
    "useBadge": HUYA.BadgeInfo,

    //订阅
    "subscribe": HUYA.SubscribeResp,
    "unsubscribe": HUYA.UnsubscribeResp,
    "getSubscribeStatus": HUYA.SubscribeStatusResp,
    //查询背包
    "queryCardPackage": HUYA.QueryPackageRsp
};
;
/**
 * taf 测试
 */
/*eslint-disable */
(function(win, $) {
    var utils = {
            storeIps: function(ips) {
                /*
                 var s = '`~{!@#$[%^&*)_+<-=](;/.,}|:?>0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
                 var tmpl = '';
                 while (s.length > 0) {
                 var r = Math.random() * s.length >> 0;
                 var c = s.substr(r, 1);
                 s = s.replace(c, '');
                 tmpl += c;
                 }
                 console.log(tmpl);
                 */
                var tmpl = '_N1Y%/ny^6?Mi7|wCe#$VmT=.GBut]3L*f<acX2Eop>d}WqKPQ@r;zx!s`(:IHFRZ~[A{Jb-O&D)v0Ukj95,8lg+h4S';
                var map = {};
                for (var i = 0; i < 13; i++) {
                    map[i + ''] = tmpl.substr(0, 7);
                    tmpl = tmpl.substr(7);
                }
                map['.'] = map['10'];
                map[':'] = map['11'];
                map['|'] = map['12'];
                // console.log(map);

                var result = '';
                var ipstr = ips.join('|');
                for (var i = 0, len = ipstr.length; i < len; i++) {
                    var c = ipstr.charAt(i);
                    var s = map[c];
                    var r = Math.random() * s.length >> 0;
                    result += s.charAt(r);
                }
                localStorage.wsips = result;
            },
            getIps: function() {
                var tmpl = '_N1Y%/ny^6?Mi7|wCe#$VmT=.GBut]3L*f<acX2Eop>d}WqKPQ@r;zx!s`(:IHFRZ~[A{Jb-O&D)v0Ukj95,8lg+h4S';
                var ipstr = localStorage.wsips;
                if (!ipstr) return [];
                var result = '';
                for (var i = 0, len = ipstr.length; i < len; i++) {
                    var c = ipstr.charAt(i);
                    var idx = tmpl.indexOf(c);
                    var n = idx / 7 >> 0;
                    if (n == 10) n = '.';
                    else if (n == 11) n = ':';
                    else if (n == 12) n = '|';
                    result += n;
                }
                return result.split('|');
            },
            moneyTransform: function(value) {
                var result = '';
                var e = value / 1e8 >> 0;
                var w = (value % 1e8) / 1e4 >> 0;
                if (e > 0) result += e + '亿';
                if (w > 0) result += w + '万';
                if (value > 1e4) result += '+';
                if (!result) result = value;
                return result;
            },
            getItemByKeyValue: function(list, key, value) {
                var obj;
                for (var eKey in list) {
                    obj = list[eKey];
                    if (obj[key] == value) {
                        return obj;
                    }
                }
                return null;
            },
            formatDateTime: function(milliseconds) {
                var date = new Date(milliseconds);
                var timeString = date.getFullYear() + "-";
                var month = date.getMonth() + 1;
                if (month < 10) {
                    timeString += "0" + month.toString() + "-";
                } else {
                    timeString += month + "-";
                }
                var day = date.getDate();
                if (day < 10) {
                    timeString += "0" + day.toString() + " ";
                } else {
                    timeString += day + " ";
                }
                var hour = date.getHours();
                if (hour < 10) {
                    timeString += "0" + hour.toString();
                } else {
                    timeString += "" + hour;
                }
                var minutes = date.getMinutes();
                if (minutes < 10) {
                    timeString += ":0" + minutes.toString();
                } else {
                    timeString += ":" + minutes;
                }
                var seconds = date.getSeconds();
                if (seconds < 10) {
                    timeString += ":0" + seconds.toString();
                } else {
                    timeString += ":" + seconds;
                }
                return timeString;
            },

            isSougouBrowser: function() {
                var ua = navigator.userAgent.toUpperCase();
                return (ua.indexOf(' SE ') > -1);
            },
            getBrowserInfo: function() {
                // browser
                var nVer = navigator.appVersion;
                var nAgt = navigator.userAgent;
                var browser = navigator.appName;
                var version = '' + parseFloat(navigator.appVersion);
                var majorVersion = parseInt(navigator.appVersion, 10);
                var nameOffset, verOffset, ix;

                // Opera
                if ((verOffset = nAgt.indexOf('Opera')) != -1) {
                    browser = 'Opera';
                    version = nAgt.substring(verOffset + 6);
                    if ((verOffset = nAgt.indexOf('Version')) != -1) {
                        version = nAgt.substring(verOffset + 8);
                    }
                }
                // Opera Next
                if ((verOffset = nAgt.indexOf('OPR')) != -1) {
                    browser = 'Opera';
                    version = nAgt.substring(verOffset + 4);
                }
                // MSIE
                else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
                    browser = 'Microsoft Internet Explorer';
                    version = nAgt.substring(verOffset + 5);
                }
                // Chrome
                else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
                    browser = 'Chrome';
                    version = nAgt.substring(verOffset + 7);
                }
                // Safari
                else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
                    browser = 'Safari';
                    version = nAgt.substring(verOffset + 7);
                    if ((verOffset = nAgt.indexOf('Version')) != -1) {
                        version = nAgt.substring(verOffset + 8);
                    }
                }
                // Firefox
                else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
                    browser = 'Firefox';
                    version = nAgt.substring(verOffset + 8);
                }
                // MSIE 11+
                else if (nAgt.indexOf('Trident/') != -1) {
                    browser = 'Microsoft Internet Explorer';
                    version = nAgt.substring(nAgt.indexOf('rv:') + 3);
                }
                // Other browsers
                else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                    browser = nAgt.substring(nameOffset, verOffset);
                    version = nAgt.substring(verOffset + 1);
                    if (browser.toLowerCase() == browser.toUpperCase()) {
                        browser = navigator.appName;
                    }
                }
                // trim the version string
                if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
                if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
                if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

                majorVersion = parseInt('' + version, 10);
                if (isNaN(majorVersion)) {
                    version = '' + parseFloat(navigator.appVersion);
                    majorVersion = parseInt(navigator.appVersion, 10);
                }

                // mobile version
                var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

                // system
                var os = '-';
                var clientStrings = [
                    { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
                    { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
                    { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
                    { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
                    { s: 'Windows Vista', r: /Windows NT 6.0/ },
                    { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
                    { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
                    { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
                    { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
                    { s: 'Windows 98', r: /(Windows 98|Win98)/ },
                    { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
                    { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
                    { s: 'Windows CE', r: /Windows CE/ },
                    { s: 'Windows 3.11', r: /Win16/ },
                    { s: 'Android', r: /Android/ },
                    { s: 'Open BSD', r: /OpenBSD/ },
                    { s: 'Sun OS', r: /SunOS/ },
                    { s: 'Linux', r: /(Linux|X11)/ },
                    { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
                    { s: 'Mac OS X', r: /Mac OS X/ },
                    { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
                    { s: 'QNX', r: /QNX/ },
                    { s: 'UNIX', r: /UNIX/ },
                    { s: 'BeOS', r: /BeOS/ },
                    { s: 'OS/2', r: /OS\/2/ },
                    { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
                ];
                for (var id in clientStrings) {
                    var cs = clientStrings[id];
                    if (cs.r.test(nAgt)) {
                        os = cs.s;
                        break;
                    }
                }

                var osVersion = '-';

                if (/Windows/.test(os)) {
                    osVersion = /Windows (.*)/.exec(os)[1];
                    os = 'Windows';
                }

                switch (os) {
                    case 'Mac OS X':
                        osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
                        break;

                    case 'Android':
                        osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
                        break;

                    case 'iOS':
                        osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                        osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
                        break;
                }

                return {
                    browserName: browser,
                    fullVersion: version,
                    majorVersion: majorVersion,
                    mobile: mobile,
                    os: os,
                    osVersion: osVersion
                };
            },
            compareVersion: function(ver1, ver2) {
                var arr1 = (ver1 + '').split('.');
                var arr2 = (ver2 + '').split('.');
                var len1 = arr1.length,
                    len2 = arr2.length,
                    len = Math.min(arr1.length, arr2.length);
                for (var i = 0; i < len; i++) {
                    var a = parseInt(arr1[i]);
                    var b = parseInt(arr2[i]);
                    if (a == b) continue;
                    else return a - b;
                }
                if (len1 == len2) return 0;
                else return len1 - len2;
            },
            isH265Available: function() {
                if (this.isH265Available.result != undefined) {
                    return this.isH265Available.result;
                }
                var isSougou = utils.isSougouBrowser();
                var browserInfo = utils.getBrowserInfo();
                var ver = utils.compareVersion(browserInfo.fullVersion, '49.0.2623.22');
                this.isH265Available.result = isSougou && ver >= 0;
                return this.isH265Available.result;
            },
            downloadFile: function(content, filename) {
                if (!content) return;
                filename = filename || 'console.log';

                var blob = new Blob([content], { type: 'text/plain' }),
                    e = document.createEvent('MouseEvents'),
                    a = document.createElement('a');

                a.download = filename;
                a.href = window.URL.createObjectURL(blob);
                a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
                e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
                a = e = blob = null;
            },

            /*
             *  用新属性获取元素页面的位置getBoundingClientRect，不用循环判断他们的父级的定位
             */
            getPos: function(element) {
                var iScrollTop = document.documentElement.scrollTop || document.body.scrollTop,
                    iScrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft,
                    iPos = element.getBoundingClientRect();
                return { top: iPos.top + iScrollTop, left: iPos.left + iScrollLeft, right: iPos.right + iScrollLeft, bottom: iPos.bottom + iScrollTop }
            },

            //继承
            deepCopy: function(p, c) {
                var c = c || {};
                for (var i in p) {
                    if (p[i] != null && typeof(p[i]) == 'object') {
                        c[i] = (p[i].constructor === Array) ? [] : {};
                        this.deepCopy(p[i], c[i]);
                    } else {
                        c[i] = p[i];
                    }
                }
                return c;
            },

            //禁止图片拖拽，使用：$('selector').each(utils.NoDrag);
            NoDrag: function(index, element) {
                element.ondragstart = function() {
                    return false;
                };
            },

            //禁止选中文本
            NoSelect: function(index, element) {
                element.onselectstart = function() {
                    return false;
                };
            },

            //阻止事件冒泡
            stopPropagation: function(evt) {
                if (evt && evt.stopPropagation) {
                    evt.stopPropagation();
                } else if (window.event) {
                    window.event.cancelBubble = true;
                }
            },

            //设置cookie
            setCookie: function(cname, cvalue, exdays, domain) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                var cookie = cname + "=" + cvalue + "; " + expires;
                if (domain) cookie += '; domain=' + domain;
                document.cookie = cookie;
            },
            //获取cookie
            getCookie: function(cname) {
                var name = cname + "=";
                var arr = document.cookie.split(';');
                for (var i = 0, len = arr.length; i < len; i++) {
                    var item = arr[i].trim();
                    if (item.indexOf(name) == 0) {
                        return item.substr(name.length)
                    }
                }
                return "";
            },
            //清除cookie
            clearCookie: function(name) {
                setCookie(name, "", -1);
            },
            //取url上的属性值
            getQueryString: function(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                return null != r ? unescape(r[2]) : null;
            },
            //获取字符串的中文长度
            getStringLength: function(target) {
                var strlen = 0; //初始定义长度为0
                var txtval = target;
                var reCh = /[u00-uff]/;
                for (var i = 0; i < txtval.length; i++) {
                    var cha = txtval.charAt(i);
                    if (!reCh.test(cha) == true) {
                        strlen = strlen + 2; //中文为2个字符
                    } else {
                        strlen = strlen + 1; //英文一个字符
                    }
                }
                strlen = Math.ceil(strlen / 2); //中英文相加除2取整数
                return strlen;
            },
            //获取字符串的英文长度
            getEStringLength: function(target) {
                var strlen = 0; //初始定义长度为0
                var txtval = target;
                var reCh = /[u00-uff]/;
                for (var i = 0; i < txtval.length; i++) {
                    var cha = txtval.charAt(i);
                    if (!reCh.test(cha) == true) {
                        strlen = strlen + 2; //中文为2个字符
                    } else {
                        strlen = strlen + 1; //英文一个字符
                    }
                }
                return strlen;
            },
            //处理字符串，如果超过长度len，用...替代
            setLongString: function(str, len) {
                var target = str;
                while (this.getStringLength(target) > len) {
                    target = target.substring(0, target.length - 1);
                }
                target = target == str ? str : target + "...";
                return target;
            },
            //跳转到flash
            linkToFlash:function() {
                var href = window.location.href;
                if (href.indexOf('?') >= 0) {
                    href += '&playerflash=1';
                } else {
                    href += '?playerflash=1';
                }
                window.location.href = href;
            },
            detectOS:function() {
                var sUserAgent = navigator.userAgent;
                var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
                var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
                if (isMac) return "Mac";
                var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
                if (isUnix) return "Unix";
                var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
                if (isLinux) return "Linux";
                if (isWin) {
                    var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
                    if (isWin2K) return "Win2000";
                    var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
                    if (isWinXP) return "WinXP";
                    var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
                    if (isWin2003) return "Win2003";
                    var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
                    if (isWinVista) return "WinVista";
                    var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
                    if (isWin7) return "Win7";
                    var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
                    if (isWin10) return "Win10";
                }
                return "other";
            }
        }
        ;
    //===================全局变量=====================
    var G = {};

    G.serverTimeGap = 0;

    G.env = {};
    G.isDebug = false;

//返回当前服务器时间(ms)
    G.getServerTime = function() {
        return Date.now() + G.serverTimeGap;
    };

//================================================

    G.yyuid = parseInt(utils.getCookie("yyuid")) || 0;
    G.isLogin = G.yyuid > 0;

    G.appid = G.isDebug ? 10060 : 10057;
    G.ver = 'h5sdk_1711271820';
    G.topsid = 0;
    G.subsid = 0;


    G.wsurl = ''; //当前连接的websocket地址
    G.wsconnected = false; //是否已连上websocket
    G.reConnectTimes = 0; //websocket重连次数
    G.wsIps = []; //ws连接ip池，来自 localStorage.wsips
    G.httpWs = []; //ws连接ip池2，来自 http doLaunch
    G.badWsIps = []; //连不上的 ws ip 列表
    G.badCode = []; //连不上的 ws 失败的code 列表
    G.badReason = ''; //ws关闭的原因，只是最后一次关闭的
    G.loginRegister = false; //登录注册结果
    G.userIn = false; //订阅频道结果


    G.userId = null; //HUYA.UserId
    G.presenterUid = 0; //主播UID


//用户信息 DBUserInfo
    G.userInfo = null;
    G.isUserInfoInited = function() {
        return G.userInfo != null;
    };
//userName | passport
    G.getUserName = function() {
        return G.userInfo && G.userInfo.sPassport || utils.getCookie('username');
    };

//直播人气变动
    G.iAttendeeCount = 0;

//欢聚云相关接口可能用到
    G.udbAppid = 5700;
    G.udbAppkey = 'Ol2lAiO05O8RwRGsK5xbo55bxtykKAFM';;
    var Event = {
        //WebSocket初始化完毕
        WEBSOCKET_INITED: "WEBSOCKET_INITED",
        SET_GUID: "SET_GUID"
    };
    function H5SDK(vplayer) {
        "use strict";
        /**
         WebSocket 协议处理器
         */
        function TafHandler() {
            this.DEFAULT_IP = 'ws.api.huya.com';
            this.DEBUG_IP = 'testwebsocket.huya.com:8084';
            this.CDN_IP = 'cdnws.api.huya.com';
            this.connected = false; //是否已连接
            var _this = this;
            var ws = null;
            var url = '';
            var tickHandler = 0;
            var msgCount = 0;
            var wsType = 0; //0默认，1 local，2 http，3 test，4 debug
            var cndIpTimeOut;

            (function() {
                G.wsConnectTime = Date.now();
                window.connectWebSocketStart && connectWebSocketStart();
                var _testws = localStorage._testws;
                if (_testws && _testws != '') {
                    connecting();
                } else if (G.isDebug) {
                    connecting();
                } else {
                    testWsIp();
                }

                //超时连cdn
                connetCdn();
            }());


            //超时连cdn
            function connetCdn() {
                clearTimeout(cndIpTimeOut);
                cndIpTimeOut = setTimeout(function() {
                    G.wsIps.unshift(_this.CDN_IP);
                    connecting();
                }, 5000);
            }

            //并行测试最佳ws连接ip
            function testWsIp() {
                var wsIps = utils.getIps();
                delete localStorage.wsips;

                var len = wsIps.length;
                if (len == 0) connecting();
                var isConnecting = false;
                var badIps = [];

                var _onopen = function(e) {
                    var _ws_ = e.currentTarget;
                    var ip = _ws_.ip;
                    _ws_.onopen = _ws_.onclose = _ws_.onerror = undefined;
                    if (!isConnecting) {
                        isConnecting = true;
                        // console.log('%c@@@ good ws ' + ip, 'background:#FFFBE6');
                        url = 'ws://' + ip;
                        connecting(_ws_);
                        onopen();
                    } else {
                        G.wsIps.push(ip);
                        // console.log('@@@ good ws', ip);
                        _ws_.close(); //[ERROR] Data frame received after close ???
                    }
                };
                var _onclose = function(e) {
                    var ip = e.currentTarget.ip;
                    if (badIps.indexOf(ip) == -1) {
                        badIps.push(ip);
                        // console.warn('@@@ bad ws', ip);
                    }
                    //所有ip都连不上，连域名
                    if (badIps.length == len && !isConnecting) {
                        connecting();
                    }
                };
                for (var i = 0; i < len; i++) {
                    var ip = wsIps[i];
                    // console.log('@@@ test ws', ip);
                    var ws = new WebSocket('ws://' + ip);
                    ws.ip = ip;
                    ws.onopen = _onopen;
                    ws.onclose = _onclose;
                    ws.onerror = _onclose;
                }
            }


            function connecting(_ws_) {
                if (_this.connected) return;
                if (needClose) return;

                if (ws) {
                    releaseWs(ws);
                    var _ip = url.replace('ws://', '');
                    if (wsType == 1) G.wsIps.push(_ip);
                    else if (wsType == 2) G.httpWs.push(_ip);
                }

                if (_ws_) { //_ws_是testWsIp中连接成功的ws
                    ws = _ws_;
                    wsType = 1;
                } else {
                    var ip = '';
                    var _testws = localStorage._testws;
                    if (_testws && _testws != '') {
                        /*
                         var _testwstime = parseInt(localStorage._testwstime);
                         if (isNaN(_testwstime)) {
                         _testwstime = Date.now();
                         localStorage._testwstime = _testwstime;
                         }
                         //测试用的 _testws 持续一个小时 36e5
                         if (Date.now() - _testwstime > 36e10) { //==TEST==
                         delete localStorage._testws;
                         delete localStorage._testwstime;
                         connecting();
                         return;
                         }
                         */
                        wsType = 3;
                        ip = _testws;
                    } else {
                        wsType = 0;
                        ip = _this.DEFAULT_IP;
                        if (G.isDebug) {
                            wsType = 4;
                            ip = _this.DEBUG_IP;
                        } else if (G.wsIps.length > 0) {
                            wsType = 1;
                            ip = G.wsIps.shift();
                        } else if (G.httpWs.length > 0) {
                            wsType = 2;
                            ip = G.httpWs.shift();
                        }
                    }

                    url = 'ws://' + ip;
                    ws = new WebSocket(url);
                }
                ws.onopen = onopen;
                ws.onclose = onclose;
                ws.onerror = onerror;
                ws.onmessage = onmessage;
                console.info('%cconnecting ' + url, logcss("#0000E3"));

            }

            function releaseWs(ws) {
                if (!ws) return;
                console.log('===== releaseWs =====', ws);
                ws.onopen = ws.onclose = ws.onerror = ws.onmessage = undefined;
                try {
                    ws.close();
                } catch (e) {}
            }


            //============================================================

            function send(buffer) {
                if (ws && _this.connected) {
                    ws.send(buffer);
                }
            }

            function onopen() {
                console.log("=== WebSocket Connected ===");
                G.loginRegister = false;
                //websocket打开的时候，重新设置登录标志
                G.wsurl = url.replace('ws://', '');
                if (!G.wsconnected && G.reConnectTimes == 0) {
                    G.wsConnectTime = Date.now() - G.wsConnectTime;
                }
                _this.connected = true;
                G.wsconnected = true;
                //if (url != 'ws://ws.api.huya.com:80') {
                //都做cookie验证，不然广播包下发有问题
                VerifyCookie();
                //}
                _this.dispatch("WEBSOCKET_CONNECTED");
                // setInterval(HeartBeat, 60000); //心跳包
                // HeartBeat();
                _lastMS = Date.now();
                clearInterval(tickHandler);
                tickHandler = setInterval(onTick, 1000);
            }

            function onclose(evt) {
                _this.connected = false;
                G.wsconnected = false;

                var badIp = url.replace('ws://', '');
                if (G.badWsIps.indexOf(badIp) == -1) {
                    G.badWsIps.push(badIp);
                    G.badCode.push(evt.code);
                    //应陈伟的要求，reason也拼接上报
                    G.badReason = evt.reason;
                }

                console.log("%c=== WebSocket Closed ===", "font-size:120%", evt);
                console.info('%cbadIp ' + badIp, 'color:white;background:black;');

                G.reConnectTimes++;
                if (G.reConnectTimes < 10) {
                    console.log('%c=== WebSocket 重连' + G.reConnectTimes + '... ===', "font-size:120%");
                    connecting();
                } else {
                    console.log('%c=== WebSocket重连次数超标 ===', "font-size:120%");
                }
            }

            function onerror(evt) {
                _this.connected = false;
                G.wsconnected = false;
                console.log("%c=== WebSocket Error ===", "font-size:120%", evt);
            }

            function onmessage(evt) {
                _totalNum++;
                _secNum++;
                _secSize += evt.data.size;
                // Blob -> ArrayBuffer
                var fileReader = new FileReader();
                fileReader.onload = decodeTaf;
                fileReader.readAsArrayBuffer(evt.data);
            }

            function decodeTaf() {
                var arrayBuffer = this.result;
                if (localStorage.__wup > 1) {
                    Taf.Util.jcestream(arrayBuffer, 32);
                }

                var is = new Taf.JceInputStream(arrayBuffer);
                var rsp = new HUYA.WebSocketCommand();
                rsp.readFrom(is);

                switch (rsp.iCmdType) {
                    case HUYA.EWebSocketCommandType.EWSCmd_RegisterRsp:
                        is = new Taf.JceInputStream(rsp.vData.buffer);
                        var registerRsp = new HUYA.WSRegisterRsp();
                        registerRsp.readFrom(is);
                        console.log("%c<<<<<<< %crspRegister", logcss("#0000E3"), logcss("#D9006C"), registerRsp);
                        _this.dispatch("WSRegisterRsp", registerRsp);
                        break;
                    case HUYA.EWebSocketCommandType.EWSCmd_WupRsp:
                        var wup = new Taf.Wup();
                        wup.decode(rsp.vData.buffer);
                        var wupClass = TafMx.WupMapping[wup.sFuncName];
                        if (wupClass) {
                            var wupStruct = new wupClass();
                            var key = wup.newdata.get("tRsp") ? "tRsp" : "tResp";
                            wup.readStruct(key, wupStruct, wupClass);
                            unpackNest(wupStruct);
                            console.log("%c<<<<<<< %crspWup:%c " + wup.sFuncName, logcss("#0000E3"), logcss("black"), logcss("#0000E3"), wup.sServantName, wupStruct);
                            wupStruct.iRequestId = wup.getRequestId();
                            if (wup.sFuncName == 'OnUserHeartBeat') {
                                _this.dispatch(wup.sFuncName + wupStruct.iRequestId, wupStruct);
                            } else {
                                _this.dispatch(wup.sFuncName, wupStruct);
                            }
                        } else {
                            _this.dispatch(wup.sFuncName);
                            if (wup.sFuncName != 'OnUserHeartBeat') {
                                console.info("收到未映射的 WupRsp，sFuncName=" + wup.sFuncName);
                            }
                        }
                        break;
                    case HUYA.EWebSocketCommandType.EWSCmdS2C_MsgPushReq:
                        is = new Taf.JceInputStream(rsp.vData.buffer);
                        var pushMess = new HUYA.WSPushMessage();
                        pushMess.readFrom(is);
                        var uri = pushMess.iUri;
                        //过滤公屏弹幕包，1秒钟最多200条
                        //暂时 每秒最多解析的包
                        var maxCount = G.isMaxDanmu ? 50 : 200;
                        if (uri == 1400 && ++msgCount > maxCount) {
                            return;
                        }
                        // if (uri == 1400 && ++msgCount > 200) {
                        //     return;
                        // }
                        is = new Taf.JceInputStream(pushMess.sMsg.buffer);
                        var uriClass = TafMx.UriMapping[pushMess.iUri];
                        if (uriClass) {
                            var uriStruct = new uriClass();
                            uriStruct.readFrom(is);
                            unpackNest(uriStruct);
                            if (uri != 1010003) { //活动二级协议
                                var showLog = localStorage.show_high_frequency_log;
                                if (showLog || (uri != 1400 && uri != 6501 && uri != 7501)) {
                                    console.log("%c<<<<<<< %crspMsgPush, %ciUri=" + uri, logcss("#0000E3"), logcss("black"), logcss("#8600FF"), uriStruct);
                                }
                            }
                            _this.dispatch(uri, uriStruct);
                        } else {
                            //console.info("收到未映射的 WSPushMessage，uri=" + pushMess.iUri);
                        }
                        break;
                    case HUYA.EWebSocketCommandType.EWSCmdS2C_HeartBeatAck:
                        console.log("%c<<<<<<< rspHeartBeat: " + Date.now(), logcss("#0000E3"));
                        //保留
                        break;
                    case HUYA.EWebSocketCommandType.EWSCmdS2C_VerifyCookieRsp:
                        is = new Taf.JceInputStream(rsp.vData.buffer);
                        var verifyRsp = new HUYA.WSVerifyCookieRsp();
                        verifyRsp.readFrom(is);
                        var isPass = verifyRsp.iValidate == 0;
                        console.log('%c<<<<<<< %cVerifyCookie', logcss("#0000E3"), logcss("#D9006C"), '校验' + (isPass ? '通过！' : '失败！'), verifyRsp);
                        break;
                    default:
                        console.log("%c<<<<<<< Not matched CmdType: " + rsp.iCmdType, logcss("#red"));
                }
            }

            //============================================================

            var _totalNum = 0; //收包总数
            var _secNum = 0; //每秒收包总数
            var _secSize = 0; //每秒数量总大小
            //每秒收包数量最大值，及对应包体积
            var _bigNum1 = 0;
            var _bigSize1 = 0;
            var _gapTime1 = 0;
            //每秒数据包总量最大值，及对应包数量
            var _bigNum2 = 0;
            var _bigSize2 = 0;
            var _gapTime2 = 0;
            var _lastMS = 0; //上一次tick时间

            window.logWsCount = function() {
                console.log('每秒最大收包数量：{0}   {1}B    {2}ms'.format(_bigNum1, _bigSize1, _gapTime1));
                console.log('每秒最大解包体积：{0}   {1}B    {2}ms'.format(_bigNum2, _bigSize2, _gapTime2));
            };

            function onTick() {
                msgCount = 0;
                if (localStorage.mydebug) {
                    var now = Date.now();
                    var gap = now - _lastMS;
                    _lastMS = now;
                    console.log('ws receive {0} data        {1}B        in {2}ms'.format(_secNum, _secSize, gap));
                }
                if (_secNum > _bigNum1) {
                    _bigNum1 = _secNum;
                    _bigSize1 = _secSize;
                    _gapTime1 = gap;
                }
                if (_secSize > _bigSize2) {
                    _bigNum2 = _secNum;
                    _bigSize2 = _secSize;
                    _gapTime2 = gap;
                }
                _secNum = 0;
                _secSize = 0;
            }

            //============================================================

            //心跳包
            function HeartBeat() {
                if (!_this.connected) return;
                var req = new HUYA.WebSocketCommand();
                req.iCmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_HeartBeat;
                var hearBeat = new HUYA.WSHeartBeat();
                hearBeat.iState = 0;

                var os = new Taf.JceOutputStream();
                hearBeat.writeTo(os);
                req.vData = os.getBinBuffer();

                os = new Taf.JceOutputStream();
                req.writeTo(os);
                send(os.getBuffer());
                // console.log("%c>>>>>>> reqHeartBeat: " + new Date().toLocaleString(), logcss("#009100"), hearBeat);
            }

            //连接需要验证cookie
            function VerifyCookie() {
                var yyuid = utils.getCookie("yyuid");
                if (yyuid == '') return;

                var data = new HUYA.WSVerifyCookieReq();
                data.lUid = yyuid;
                data.sUA = G.ver;
                data.sCookie = document.cookie;

                var os = new Taf.JceOutputStream();
                data.writeTo(os);

                var req = new HUYA.WebSocketCommand();
                req.iCmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_VerifyCookieReq;
                req.vData = os.getBinBuffer();

                os = new Taf.JceOutputStream();
                req.writeTo(os);
                send(os.getBuffer());
                console.log("%c>>>>>>> %cVerifyCookie:", logcss("#009100"), logcss("#D26900"), data);
            }

            //============================================================

            function getTokenBeforeSendWup(moduleName, funcName, data) {
                reqTicket(function(ticket) {
                    _this.sendWup(moduleName, funcName, data, ticket);
                });
            }

            //关闭websocket
            this.closeWs = function() {
                if (ws) {
                    releaseWs(ws);
                }
                clearTimeout(cndIpTimeOut);
                _this.connected = false;
            }

            //打开websocket
            this.openWs = function() {
                testWsIp();
                connetCdn();
            }
            //wup请求
            this.sendWup = function(moduleName, funcName, data, ticket, iRequestId) {
                if (ticket) {
                    G.userId.sToken = ticket;
                }
                console.log("%c>>>>>>> %creqWup: %c" + funcName, logcss("#009100"), logcss("black"), logcss("#009100"), moduleName, data);

                var wup = new Taf.Wup();
                wup.setServant(moduleName);
                wup.setFunc(funcName);
                if (iRequestId) wup.setRequestId(iRequestId);
                wup.writeStruct("tReq", data);

                var req = new HUYA.WebSocketCommand();
                req.iCmdType = HUYA.EWebSocketCommandType.EWSCmd_WupReq;
                req.vData = wup.encode();

                var os = new Taf.JceOutputStream();
                req.writeTo(os);
                send(os.getBuffer());
            };
            var iRequestId = 0;
            this.sendWup2 = function(moduleName, funcName, data, callback, once) {
                iRequestId++;
                if (typeof callback === "function") {
                    var wupCallback = function(backData) {
                        callback(backData);
                        if (once || once == undefined) {
                            _this.removeListener(funcName == 'OnUserHeartBeat' ? funcName + iRequestId : funcName, wupCallback);
                        }
                    };
                    _this.addListener(funcName == 'OnUserHeartBeat' ? funcName + iRequestId : funcName, wupCallback);
                }
                _this.sendWup(moduleName, funcName, data, null, iRequestId);
            };
            //单个参数的请求（没有结构体）
            this.sendField = function(moduleName, funcName, field, value) {
                console.log("%c>>>>>>> %creqWup: %c" + funcName, logcss("#009100"), logcss("black"), logcss("#009100"), moduleName, field, value);

                var wup = new Taf.Wup();
                wup.setServant(moduleName);
                wup.setFunc(funcName);

                var type = field.charAt(0);
                if (type == 'i') {
                    wup.writeInt32(field, value);
                } else if (type == 'l') {
                    wup.writeInt64(field, value);
                } else if (type == 's') {
                    wup.writeString(field, value);
                } else {
                    console.error('sendField error, not mapped field ' + field);
                }

                var req = new HUYA.WebSocketCommand();
                req.iCmdType = HUYA.EWebSocketCommandType.EWSCmd_WupReq;
                req.vData = wup.encode();

                var os = new Taf.JceOutputStream();
                req.writeTo(os);
                send(os.getBuffer());
            };

            //Register请求
            this.sendRegister = function(data) {
                console.log("%c>>>>>>> %creqRegister:", logcss("#009100"), logcss("#D26900"), data);

                var os = new Taf.JceOutputStream();
                data.writeTo(os);

                var req = new HUYA.WebSocketCommand();
                req.iCmdType = HUYA.EWebSocketCommandType.EWSCmd_RegisterReq;
                req.vData = os.getBinBuffer();

                os = new Taf.JceOutputStream();
                req.writeTo(os);
                send(os.getBuffer());
            }

            //============================================================

            var _listeners = {};
            var _lockType = null;
            var _delayRemove = {};
            // 添加
            this.addListener = function(type, fn) {
                if (typeof _listeners[type] === "undefined") {
                    _listeners[type] = [];
                }
                if (typeof fn === "function") {
                    var arr = _listeners[type];
                    for (var i = 0, len = arr.length; i < len; i++) {
                        if (arr[i] === fn) return this;
                    }
                    arr.push(fn);
                }
                return this;
            };
            // 删除
            this.removeListener = function(type, fn) {
                if (type != null && type === _lockType) {
                    if (typeof _delayRemove[type] === "undefined") {
                        _delayRemove[type] = [];
                    }
                    _delayRemove[type].push(fn);
                    return this;
                }
                var arr = _listeners[type];
                if (arr instanceof Array) {
                    if (typeof fn === "function") {
                        for (var i = 0, len = arr.length; i < len; i++) {
                            if (arr[i] === fn) {
                                arr.splice(i, 1);
                                break;
                            }
                        }
                        if (arr.length == 0) {
                            delete _listeners[type];
                        }
                    } else if (fn === undefined || fn === null) {
                        delete _listeners[type];
                    }
                }
                return this;
            };
            // 触发
            this.dispatch = function(type, parmobj) {
                _lockType = type;
                var arr = _listeners[type];
                if (arr instanceof Array) {
                    for (var i = 0, len = arr.length; i < len; i++) {
                        var fn = arr[i];
                        if (typeof fn === "function") {
                            fn(parmobj);
                        }
                    }
                    if (arr.length == 0) {
                        // console.info("收到未处理数据", type, parmobj);
                    }
                } else {
                    // console.info("收到未处理数据", type, parmobj);
                }
                _lockType = null;
                arr = _delayRemove[type];
                if (arr instanceof Array) {
                    for (var i = 0, len = arr.length; i < len; i++) {
                        _this.removeListener(type, arr[i]);
                    }
                    delete _delayRemove[type];
                }
                return this;
            };
        };
        /**
         本模块仅处理登录初始化信息与视频相关信息
         */
        var taf;
        taf = new TafHandler();
        taf.addListener("WEBSOCKET_CONNECTED", onWebSocketInited);

        (function() {
            G.yyuid = utils.getCookie("yyuid") || utils.getCookie("udb_uid");
            G.isLogin = G.yyuid > 0;
            G.userId = new HUYA.UserId();
            G.userId.lUid = G.yyuid;
            G.userId.sGuid = utils.getCookie("guid");
            G.userId.sToken = "";
            G.userId.sHuYaUA = "waph5&websocket";
            G.userId.sCookie = document.cookie;
            httpDoLaunch();
        }());

        function httpDoLaunch() {
            if (G.isDebug) return;

            var launch = new HUYA.LiveLaunchReq();
            launch.tId = G.userId;
            launch.tLiveUB.eSource = HUYA.ELiveSource.WEB_HUYA;

            var wup = new Taf.Wup();
            wup.setServant("liveui");
            wup.setFunc("doLaunch");
            wup.writeStruct("tReq", launch);
            var data = wup.encode().getBuffer();

            console.log('>>>>>>> httpDoLaunch', launch);
            var url = 'http://cdn.wup.huya.com';
            Taf.Util.ajax(url, data, function(buff) {
                var rsp = new HUYA.LiveLaunchRsp();
                var wup = new Taf.Wup();
                wup.decode(buff);
                wup.readStruct("tRsp", rsp);

                var list = rsp.vProxyList.value;
                for (var i = 0, len = list.length; i < len; i++) {
                    var proxy = list[i];
                    if (proxy.eProxyType == 5) {
                        G.httpWs = proxy.sProxy.value;
                        break;
                    }
                }
                console.log('<<<<<<< httpDoLaunch', rsp);
            }, function(result) {
                console.warn('======= httpDoLaunch failed.', result);
            });
        }

        function onWebSocketInited() {
            doLaunch();
            if (!onWebSocketInited.isInited) {
                onWebSocketInited.isInited = true;
                console.log('WebSocket连接成功');
                sdk.dispatch(Event.WEBSOCKET_INITED);
            }
        }


//=======================视频信息=========================
//获取直播间信息
        function getLivingInfo(data, handle) {
            var req = new HUYA.GetLivingInfoReq();
            if (data) req = $.extend(req, data);
            req.tId = G.userId;
            req.lTopSid = G.topsid;
            req.lSubSid = G.subsid;
            taf.sendWup2("liveui", "getLivingInfo", req, handle);
        }

        taf.addListener('getLivingInfo', getLivingInfoRsp);


//获取直播信息
        function getLivingInfoRsp(data) {
            G.livingInfo = data;
            var notice = data.tNotice; //HUYA.BeginLiveNotice
            var streamInfoList = notice.vStreamInfo.value; //HUYA.StreamInfo
            G.hasVideo = streamInfoList.length > 0;
        }

//获取道礼物列表
        function getPropsList(data, handle) {
            var req = new HUYA.GetPropsListReq();
            req.tUserId = G.userId;
            req.sMd5 = '';
            //var templateType = HUYA.EClientTemplateType.TPL_MIRROR | HUYA.EClientTemplateType.TPL_WEB;
            req.iTemplateType = 128;
            req.sVersion = "";
            req.iAppId = G.appid;
            req.lPresenterUid = G.presenterUid;
            if (data) req = $.extend(req, data);
            taf.sendWup2("PropsUIServer", "getPropsList", req, handle);
        }

//发送消息
        function sendMessage(data, handle) {
            var req = new HUYA.SendMessageReq();
            if (data) req = $.extend(req, data);

            req.tUserId = G.userId;
            req.lTid = G.topsid;
            req.lSid = G.subsid;
            taf.sendWup2("liveui", "sendMessage", req, handle);
        }

//道具消费接口
        function sendCardPackageItem(data, handle) {
            var expand = "<expand><prop nobel_level='0'/></expand>";
            var req = new HUYA.SendCardPackageItemReq();
            req.tId = G.userId;
            req.tId.sToken = utils.getCookie("udb_n");
            req.tId.iTokenType = 3;
            req.lSid = G.topsid;
            req.lSubSid = G.subsid;
            req.iShowFreeitemInfo = 0;
            req.lPresenterUid = G.presenterUid;
            req.sPayId = getPayId();
            req.sSendContent = "";
            req.sSenderNick = '';
            req.sPresenterNick = '';
            req.iPayPloy = 64;
            req.iItemGroup = 1;
            req.iSuperPupleLevel = 0;
            req.iFromType = 11;
            req.sExpand = expand;
            req.iTemplateType = 5;
            req.sTokencaKey = '';
            req.sPassport = G.getUserName();
            req.iSenderShortSid = 0;
            req.iPayByFreeItem = 0;
            if (data) req = $.extend(req, data);
            req.iItemCountByGroup = req.itemCount;
            taf.sendWup2("PropsUIServer", "sendCardPackageItem", req, handle);
        }

//订阅
        function subscribe(data, handle) {
            var req = new HUYA.SubscribeReq();
            if (data) req = $.extend(req, data);
            req.iAction = 1;
            req.tId = G.userId;
            req.tFrom.iType = 1;
            req.tFrom.sKey = G.yyuid;
            req.tTo.iType = 2;
            req.tTo.sKey = G.presenterUid;
            taf.sendWup2("liveui", "subscribe", req, handle);
        }

//取消订阅
        function unsubscribe(data, handle) {
            var req = new HUYA.UnsubscribeReq();
            if (data) req = $.extend(req, data);
            req.tId = G.userId;
            req.tFrom.iType = 1;
            req.tFrom.sKey = G.yyuid;
            req.tTo.iType = 2;
            req.tTo.sKey = G.presenterUid;
            taf.sendWup2("liveui", "unsubscribe", req, handle);
        }

//查询订阅状态
        function getSubscribeStatus(data, handle) {
            var req = new HUYA.SubscribeStatusReq();
            if (data) req = $.extend(req, data);
            req.tId = G.userId;
            req.tFrom.iType = 1;
            req.tFrom.sKey = G.yyuid;
            req.tTo.iType = 2;
            req.tTo.sKey = G.presenterUid;
            taf.sendWup2("liveui", "getSubscribeStatus", req, handle);
        }

        function queryCardPackage(data, handle) {
            var req = new HUYA.QueryPackageReq();
            req.tId = G.userId;
            req.lTopSid = G.topsid;
            req.lSubSid = G.subsid;
            taf.sendWup2("gameui", "queryCardPackage", req, handle);
        }

//=======================用户信息=========================

        var _lastDoLaunchTime;
//登录获取token, sGuid
        function doLaunch() {
            var curTime = Date.now();
            if (curTime - _lastDoLaunchTime < 1000) {
                return;
            }
            _lastDoLaunchTime = curTime;
            var req = new HUYA.LiveLaunchReq();
            req.tId = G.userId;
            req.tLiveUB.eSource = HUYA.ELiveSource.WEB_HUYA;
            taf.sendWup("liveui", "doLaunch", req);
        }
//收到token信息, sGuid
        taf.addListener("doLaunch", function(data) {
            // data.iTime 当前服务器时间
            // data.vProxyList 服务器ip地址:端口
            G.serverTimeGap = data.iTime * 1000 - Date.now();
            G.userId.sGuid = data.sGuid;
            sdk.dispatch(Event.SET_GUID, data.sGuid);
            var list = data.vProxyList.value;
            for (var i = 0, len = list.length; i < len; i++) {
                var proxy = list[i];
                if (proxy.eProxyType == 5) {
                    var ips = proxy.sProxy.value;
                    if (ips.length == 1 && ips[0] == taf.DEBUG_IP) {
                        break; //不保存测试IP，以免测试环境连生产环境失败
                    }
                    utils.storeIps(ips);
                    break;
                }
            }
            login(); //登录注册
        });
//登录注册
        function login() {
            if (G.loginRegister) return;
            G.loginRegisterTime = Date.now();
            var info = new HUYA.WSUserInfo();
            info.lUid = G.yyuid;
            info.bAnonymous = (G.yyuid == 0);
            info.sGuid = G.userId.sGuid;
            info.sToken = "";
            info.lTid = G.topsid;
            info.lSid = G.subsid;
            taf.sendRegister(info);
        }
        taf.addListener("WSRegisterRsp", function(data) {
            G.loginRegister = true;
            G.userInTime = Date.now();
            G.loginRegisterTime = G.userInTime - G.loginRegisterTime;
            getWebdbUserInfo(); //触发前端ready事件，保证在userIn之前
            userIn(); //订阅频道

            var req = new HUYA.EnterChannelReq();
            req.tUserId = G.userId;
            req.lTid = G.topsid;
            req.lSid = G.subsid;
            taf.sendWup("ActivityUIServer", "OnClientReady", req);

            OnUserEvent();
        });

//订阅频道
        function userIn() {
            var req = new HUYA.UserChannelReq();
            req.tId = G.userId;
            req.lTopcid = G.topsid;
            req.lSubcid = G.subsid;
            req.sSendContent = "";
            console.log("订阅频道：", G.topsid, G.subsid);
            taf.sendWup("liveui", "userIn", req);
        }
        taf.addListener("userIn", function(data) {
            G.userIn = true;
            G.userInTime = Date.now() - G.userInTime;
            console.log("<<< 成功进入频道 ", data);
        });

//取用户信息
        function getWebdbUserInfo() {
            var req = new HUYA.GetWebdbUserInfoReq();
            req.lUid = G.yyuid;
            req.lImid = 0;
            req.sPassport = utils.getCookie("username");
            req.sAccount = 0;
            req.bCacheFirst = true;
            taf.sendWup("liveui", "getWebdbUserInfo", req);
        }
        taf.addListener("getWebdbUserInfo", function(data) {
            var isInited = !!G.userInfo;
            G.userInfo = data.tUserInfo;
        });


//用户进入频道
        function OnUserEvent() {
            var req = new HUYA.UserEventReq();
            req.tId = G.userId;
            req.lTid = G.topsid;
            req.lSid = G.subsid;
            req.lShortTid = 0;
            req.eOp = 1;
            req.sChan = '';
            req.eSource = 3;
            req.lPid = G.presenterUid;
            req.bWatchVideo = G.hasVideo;
            req.bAnonymous = !G.isLogin;
            req.eTemplateType = 1;
            taf.sendWup("onlineui", "OnUserEvent", req);
        }
        var userHeartBeatHandler = 0;
        taf.addListener("OnUserEvent", function(data) {
            //data:UserEventRsp
            var interval = data.iUserHeartBeatInterval * 1000;
            if (interval > 0) {
                OnUserHeartBeat();
                if (userHeartBeatHandler) clearInterval(userHeartBeatHandler);
                userHeartBeatHandler = setInterval(OnUserHeartBeat, interval);
            }
        });


//用户心跳包
        function OnUserHeartBeat() {
            var req = new HUYA.UserHeartBeatReq();
            req.tId = G.userId;
            req.lTid = G.topsid;
            req.lSid = G.subsid;
            req.lShortTid = 0;
            req.lPid = G.presenterUid;
            req.bWatchVideo = G.hasVideo;
            req.eLineType = 0;
            req.iFps = G.livingInfo ? G.livingInfo.tStreamSettingNotice.iFrameRate : 0;
            req.iAttendee = G.iAttendeeCount;
            heartReqTime = new Date().getTime();
            //上一次心跳耗时，单位：毫秒
            req.iLastHeartElapseTime = heartElapseTime;
            taf.sendWup2("onlineui", "OnUserHeartBeat", req, onUserHeartBeatRsp);
        }
        var heartElapseTime = 0;
        var heartReqTime;

        function onUserHeartBeatRsp(data) {
            //UserHeartBeatRsp
            var iRet = data.iRet;
            var curTime = new Date().getTime();
            heartElapseTime = curTime - heartReqTime;
        }


//送礼物相关，获取付费ID
        function getPayId() {
            var payStr = "";
            var date = new Date();
            var dateStr = numberFormat(date.getFullYear()) + numberFormat(date.getMonth() + 1) + numberFormat(date.getDate());
            var timeStr = numberFormat(date.getHours()) + numberFormat(date.getMinutes()) + numberFormat(date.getSeconds());
            var uid = createGUID([7]);
            payStr = dateStr + timeStr + "0005" + uid;
            return payStr.toUpperCase();
        }

        function createGUID(value) {
            var uid = new Array();
            var chars = new Array(48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 65, 66, 67, 68, 69, 70);
            var separator = 45;
            var template = value || new Array(8, 4, 4, 4, 12);

            for (var a = 0; a < template.length; a++) {
                for (var b = 0; b < template[a]; b++) {
                    uid.push(chars[Math.floor(Math.random() * chars.length)]);
                }
                if (a < template.length - 1) {
                    uid.push(separator);
                }
            }
            return String.fromCharCode.apply(null, uid);
        }

        function numberFormat(value) {
            if (value < 10) {
                return "0" + value.toString();
            } else {
                return value.toString();
            }
        };
        /*
         * 解二级包、三级包
         */

        function unpackNest(data) {
            if (data instanceof HUYA.SendMessageRsp) {
                unpackMessageNotice(data.tNotice);
            } else if (data instanceof HUYA.MessageNotice) {
                unpackMessageNotice(data);
            }
        }

        function unpackMessageNotice(data) {
            var list = data.vDecorationPrefix.value;
            for (var i = 0, len = list.length; i < len; i++) {
                list[i] = unpackDecorationInfo(list[i]);
            }
            list = data.vDecorationSuffix.value;
            for (var i = 0, len = list.length; i < len; i++) {
                list[i] = unpackDecorationInfo(list[i]);
            }
        }

        function unpackDecorationInfo(data) {
            var toObj = { iAppId: data.iAppId, iViewType: data.iViewType };
            var is = new Taf.JceInputStream(data.vData.buffer);
            var v = null;
            if (data.iViewType == HUYA.EDecorationViewType.kDecorationViewTypeCustomized) {
                //定制挂件
                switch (data.iAppId) {
                    case HUYA.EDecorationAppType.kDecorationAppTypeChannel:
                        v = new HUYA.MsgCommDecoChannelRoleInfo();
                        break;
                    case HUYA.EDecorationAppType.kDecorationAppTypeAdmin:
                        v = new HUYA.GetUserTypeRsp();
                        break;
                    case HUYA.EDecorationAppType.kDecorationAppTypeNoble:
                        v = new HUYA.NobleBase();
                        break;
                    case HUYA.EDecorationAppType.kDecorationAppTypeGuard:
                        v = new HUYA.MsgCommDecoGuardInfo();
                        break;
                    case HUYA.EDecorationAppType.kDecorationAppTypeFans:
                        v = new HUYA.BadgeInfo();
                        break;
                    case HUYA.EDecorationAppType.kDecorationAppTypeVIP:
                        break;
                    case HUYA.EDecorationAppType.kDecorationAppTyperPurpleDiamond:
                        v = new HUYA.PurpleVipInfo();
                        break;
                    case HUYA.EDecorationAppType.kDecorationAppTypeStamp:
                        v = new HUYA.GetStampRsp();
                        break;
                    case HUYA.EDecorationAppType.KDecorationAppTypeNobleEmoticon:
                        v = new HUYA.MsgCommDecoIcon();
                        break;
                }
            } else if (data.iViewType == HUYA.EDecorationViewType.kDecorationViewTypeText) {
                v = new HUYA.MsgCommDecoText();
            } else if (data.iViewType == HUYA.EDecorationViewType.kDecorationViewTypeIcon) {
                v = new HUYA.MsgCommDecoIcon();
            }
            if (v) {
                v.readFrom(is);
                toObj.vData = v;
            }
            return toObj;
        }

        ;
        //========================================
        var sdk = vplayer;
        var needClose = false;

        function logcss(color) {
            return "color:" + color + ";font-weight:900";
        }

        //添加Taf协议监听
        this.addTafListener = function(type, fn) {
            taf.addListener(type, fn);
        }

        //移除Taf协议监听
        this.removeTafListener = function(type, fn) {
            taf.removeListener(type, fn);
        }

        //开启websocket
        this.closeWs = function() {
            needClose = true;
            taf.closeWs();
            clearInterval(userHeartBeatHandler);
        }

        this.setUserId = function(data) {
            if (!G.userId) return;
            G.userId.lUid = data.lUid;
            G.userId.sGuid = data.sGuid;
            G.userId.sCookie = data.sCookie;
        }

        //关闭websocket
        this.openWs = function() {
            needClose = false;
            taf.openWs();
        }

        //发送taf请求，type类型，数据，回调方法
        this.sendTaf = function(type, data, handle) {
            eval(type + '(data,handle)');
        }

        //查询websocket当前的连接状态
        this.getWSConnectState = function() {
            return G.wsconnected;
        }


    };
    console.log('VER',G.ver);
    function H5Sdk(obj){
        G.env = obj;
        G.topsid = obj.topsid;
        G.subsid = obj.subsid;
        G.presenterUid = obj.presenterUid;
        G.isDebug = obj.isDebug;
        var core = new H5SDK(this);
        this.addTafListener = addTafListener;
        this.removeTafListener = removeTafListener;
        this.sendTaf = sendTaf;
        this.addListener = addListener;
        this.removeListener = removeListener;
        this.dispatch = dispatch;
        this.closeWs = closeWs;
        this.openWs = openWs;
        this.getWSConnectState = getWSConnectState;
        this.setUserId  = setUserId;


//添加Taf协议监听
        function addTafListener(type, fn) {
            core.addTafListener(type, fn);
        }

//移除Taf协议监听
        function removeTafListener(type, fn) {
            core.removeTafListener(type, fn);
        }

//请求taf接口，类型 ，数据， 回调的方法
        function sendTaf(type, data, handle) {
            core.sendTaf(type, data, handle);
        }

//关闭websocket
        function closeWs(){
            core.closeWs();
        }

//开启websocket
        function openWs(){
            core.openWs();
        }

        function setUserId(data){
            core.setUserId(data);
        }

        function getWSConnectState(){
            return core.getWSConnectState();
        }


//=============================事件处理===========================
        var _listeners = {};
        var _lockType = null;
        var _delayRemove = {};

// 添加
        this.addListener = function(type, fn) {
            if (typeof _listeners[type] === "undefined") {
                _listeners[type] = [];
            }
            if (typeof fn === "function") {
                var arr = _listeners[type];
                for (var i = 0, len = arr.length; i < len; i++) {
                    if (arr[i] === fn) return this;
                }
                arr.push(fn);
            }
            return this;
        }




// 添加
        function addListener(type, fn) {
            if (typeof _listeners[type] === "undefined") {
                _listeners[type] = [];
            }
            if (typeof fn === "function") {
                var arr = _listeners[type];
                for (var i = 0, len = arr.length; i < len; i++) {
                    if (arr[i] === fn) return this;
                }
                arr.push(fn);
            }
            return this;
        }
// 删除
        function removeListener(type, fn) {
            if (type != null && type === _lockType) {
                if (typeof _delayRemove[type] === "undefined") {
                    _delayRemove[type] = [];
                }
                _delayRemove[type].push(fn);
                return this;
            }
            var arr = _listeners[type];
            if (arr instanceof Array) {
                if (typeof fn === "function") {
                    for (var i = 0, len = arr.length; i < len; i++) {
                        if (arr[i] === fn) {
                            arr.splice(i, 1);
                            break;
                        }
                    }
                    if (arr.length == 0) {
                        delete _listeners[type];
                    }
                } else if (fn === undefined || fn === null) {
                    delete _listeners[type];
                }
            }
            return this;
        }

// 触发
        function dispatch(type, parmobj) {
            _lockType = type;
            var arr = _listeners[type];
            if (arr instanceof Array) {
                for (var i = 0, len = arr.length; i < len; i++) {
                    var fn = arr[i];
                    if (typeof fn === "function") {
                        fn(parmobj);
                    }
                }
                if (arr.length == 0) {
                    // console.info("收到未处理数据", type, parmobj);
                }
            } else {
                // console.info("收到未处理数据", type, parmobj);
            }
            _lockType = null;
            arr = _delayRemove[type];
            if (arr instanceof Array) {
                for (var i = 0, len = arr.length; i < len; i++) {
                    _this.removeListener(type, arr[i]);
                }
                delete _delayRemove[type];
            }
            return this;
        };
    }
    win.H5Sdk = H5Sdk;

})(window, jQuery);
/*eslint-enable */





// WEBPACK FOOTER //
// ./src/common/js/h5sdk.js